/** Accumulator issue request type */
export var Accumulator_Issue_Request_Type;
(function (Accumulator_Issue_Request_Type) {
    Accumulator_Issue_Request_Type["Issue"] = "issue";
    Accumulator_Issue_Request_Type["Report"] = "report";
})(Accumulator_Issue_Request_Type || (Accumulator_Issue_Request_Type = {}));
export var Advocate_Pharmacy_Card_Type;
(function (Advocate_Pharmacy_Card_Type) {
    Advocate_Pharmacy_Card_Type["OutboundSso"] = "outbound_sso";
    Advocate_Pharmacy_Card_Type["Regular"] = "regular";
})(Advocate_Pharmacy_Card_Type || (Advocate_Pharmacy_Card_Type = {}));
export var Annual_Physical_Form_Answers_Kinds_Type;
(function (Annual_Physical_Form_Answers_Kinds_Type) {
    Annual_Physical_Form_Answers_Kinds_Type["Checkbox"] = "Checkbox";
    Annual_Physical_Form_Answers_Kinds_Type["Choice"] = "Choice";
    Annual_Physical_Form_Answers_Kinds_Type["Date"] = "Date";
    Annual_Physical_Form_Answers_Kinds_Type["File"] = "File";
    Annual_Physical_Form_Answers_Kinds_Type["Input"] = "Input";
    Annual_Physical_Form_Answers_Kinds_Type["Number"] = "Number";
})(Annual_Physical_Form_Answers_Kinds_Type || (Annual_Physical_Form_Answers_Kinds_Type = {}));
export var Appointments_Order;
(function (Appointments_Order) {
    /** Ascending sort by 'created' field. */
    Appointments_Order["Created"] = "created";
    /** Descending sort by 'created' field. */
    Appointments_Order["ReverseCreated"] = "reverse_created";
    /** Descending sort by 'updated' field. */
    Appointments_Order["ReverseUpdated"] = "reverse_updated";
    /** Ascending sort by 'updated' field. */
    Appointments_Order["Updated"] = "updated";
})(Appointments_Order || (Appointments_Order = {}));
export var Appointment_Preferred_Part_Of_Day_Type;
(function (Appointment_Preferred_Part_Of_Day_Type) {
    Appointment_Preferred_Part_Of_Day_Type["Am"] = "AM";
    Appointment_Preferred_Part_Of_Day_Type["Pm"] = "PM";
})(Appointment_Preferred_Part_Of_Day_Type || (Appointment_Preferred_Part_Of_Day_Type = {}));
export var Appointment_Status;
(function (Appointment_Status) {
    /** Cancelled */
    Appointment_Status["Cancelled"] = "cancelled";
    /** Completed */
    Appointment_Status["Completed"] = "completed";
    /** Confirmed */
    Appointment_Status["Confirmed"] = "confirmed";
    /** Pending */
    Appointment_Status["Pending"] = "pending";
    /** Pending cancelled */
    Appointment_Status["PendingCancelled"] = "pending_cancelled";
    /** Rejected */
    Appointment_Status["Rejected"] = "rejected";
    /** Suggested */
    Appointment_Status["Suggested"] = "suggested";
})(Appointment_Status || (Appointment_Status = {}));
export var Appointment_Status_Change_Event;
(function (Appointment_Status_Change_Event) {
    /** Changes state from 'pending' to 'pending' from 'suggested' to 'pending' */
    Appointment_Status_Change_Event["Approve"] = "approve";
    /**
     * Changes state from 'confirmed' to 'pending_cancelled' from 'pending_cancelled'
     * to 'pending_cancelled' from 'pending' to 'rejected' from 'rejected' to
     * 'rejected' from 'suggested' to 'rejected' from 'pending' to 'pending' from
     * 'suggested' to 'pending'
     */
    Appointment_Status_Change_Event["Cancel"] = "cancel";
    /** Changes state from 'suggested' to 'completed' from 'confirmed' to 'completed' from 'cancelled' to 'completed' */
    Appointment_Status_Change_Event["Complete"] = "complete";
    /** Changes state from 'suggested' to 'confirmed' from 'pending' to 'confirmed' */
    Appointment_Status_Change_Event["Confirm"] = "confirm";
    /** Changes state from 'cancelled' to 'pending' from 'pending_cancelled' to 'pending' from 'pending' to 'pending' */
    Appointment_Status_Change_Event["FinishCancellation"] = "finish_cancellation";
    /** Changes state from 'rejected' to 'rejected' from 'pending' to 'pending' from 'suggested' to 'pending' */
    Appointment_Status_Change_Event["Reject"] = "reject";
    /** Changes state from 'pending' to 'suggested' from 'suggested' to 'suggested' from 'pending_cancelled' to 'suggested' */
    Appointment_Status_Change_Event["Suggest"] = "suggest";
})(Appointment_Status_Change_Event || (Appointment_Status_Change_Event = {}));
export var Articles_Order;
(function (Articles_Order) {
    /** Ascending sort by 'organization_relevance' field. */
    Articles_Order["OrganizationRelevance"] = "organization_relevance";
    /** Ascending sort by 'pins_count' field. */
    Articles_Order["PinsCount"] = "pins_count";
    /** Descending sort by 'organization_relevance' field. */
    Articles_Order["ReverseOrganizationRelevance"] = "reverse_organization_relevance";
    /** Descending sort by 'pins_count' field. */
    Articles_Order["ReversePinsCount"] = "reverse_pins_count";
    /** Descending sort by 'title' field. */
    Articles_Order["ReverseTitle"] = "reverse_title";
    /** Descending sort by 'updated_at' field. */
    Articles_Order["ReverseUpdatedAt"] = "reverse_updated_at";
    /** Descending sort by 'views_count' field. */
    Articles_Order["ReverseViewsCount"] = "reverse_views_count";
    /** Ascending sort by 'title' field. */
    Articles_Order["Title"] = "title";
    /** Ascending sort by 'updated_at' field. */
    Articles_Order["UpdatedAt"] = "updated_at";
    /** Ascending sort by 'views_count' field. */
    Articles_Order["ViewsCount"] = "views_count";
})(Articles_Order || (Articles_Order = {}));
/** Possible upload statuses for Message */
export var Attachment_Status_Kind;
(function (Attachment_Status_Kind) {
    Attachment_Status_Kind["Clean"] = "clean";
    Attachment_Status_Kind["Deleted"] = "deleted";
    Attachment_Status_Kind["Infected"] = "infected";
    Attachment_Status_Kind["InvalidLink"] = "invalid_link";
    Attachment_Status_Kind["NotChecked"] = "not_checked";
    Attachment_Status_Kind["SanitizationFailed"] = "sanitization_failed";
    Attachment_Status_Kind["Sanitized"] = "sanitized";
    Attachment_Status_Kind["Started"] = "started";
})(Attachment_Status_Kind || (Attachment_Status_Kind = {}));
export var Audit_Logs_Order;
(function (Audit_Logs_Order) {
    /** Ascending sort by 'id' field. */
    Audit_Logs_Order["Id"] = "id";
    /** Descending sort by 'id' field. */
    Audit_Logs_Order["ReverseId"] = "reverse_id";
})(Audit_Logs_Order || (Audit_Logs_Order = {}));
export var AccumulatorType;
(function (AccumulatorType) {
    AccumulatorType["Family"] = "FAMILY";
    AccumulatorType["Individual"] = "INDIVIDUAL";
})(AccumulatorType || (AccumulatorType = {}));
export var ArticleOrganizationsScope;
(function (ArticleOrganizationsScope) {
    ArticleOrganizationsScope["All"] = "all";
    ArticleOrganizationsScope["Custom"] = "custom";
    ArticleOrganizationsScope["Tpa"] = "tpa";
})(ArticleOrganizationsScope || (ArticleOrganizationsScope = {}));
export var Benefit_Categories_Order;
(function (Benefit_Categories_Order) {
    /** Ascending sort by 'id' field. */
    Benefit_Categories_Order["Id"] = "id";
    /** Ascending sort by 'name' field. */
    Benefit_Categories_Order["Name"] = "name";
    /** Descending sort by 'id' field. */
    Benefit_Categories_Order["ReverseId"] = "reverse_id";
    /** Descending sort by 'name' field. */
    Benefit_Categories_Order["ReverseName"] = "reverse_name";
})(Benefit_Categories_Order || (Benefit_Categories_Order = {}));
/** Benefit inquiry topic areas */
export var Benefit_Inquiry_Topic_Area;
(function (Benefit_Inquiry_Topic_Area) {
    Benefit_Inquiry_Topic_Area["Accumulator"] = "accumulator";
    Benefit_Inquiry_Topic_Area["Copay"] = "copay";
    Benefit_Inquiry_Topic_Area["DrugCoverage"] = "drug_coverage";
    Benefit_Inquiry_Topic_Area["Other"] = "other";
})(Benefit_Inquiry_Topic_Area || (Benefit_Inquiry_Topic_Area = {}));
/** Possible Bill Claim categories. */
export var Bill_Claim_Category;
(function (Bill_Claim_Category) {
    /** Dental */
    Bill_Claim_Category["Dental"] = "dental";
    /** Medical */
    Bill_Claim_Category["Medical"] = "medical";
    /** Pharmacy */
    Bill_Claim_Category["Pharmacy"] = "pharmacy";
    /** Vision */
    Bill_Claim_Category["Vision"] = "vision";
})(Bill_Claim_Category || (Bill_Claim_Category = {}));
export var Brand_File_Kind;
(function (Brand_File_Kind) {
    /** ICO favicon. */
    Brand_File_Kind["Favicon"] = "favicon";
    /** SVG sidebar mobile logo. */
    Brand_File_Kind["MobileSplashScreenSidebarSvg"] = "mobile_splash_screen_sidebar_svg";
    /** SVG sidebar logo. */
    Brand_File_Kind["SplashScreenSidebarSvg"] = "splash_screen_sidebar_svg";
    /** Square SVG logo. */
    Brand_File_Kind["SplashScreenSvg"] = "splash_screen_svg";
})(Brand_File_Kind || (Brand_File_Kind = {}));
export var BenefitType;
(function (BenefitType) {
    BenefitType["Deductible"] = "DEDUCTIBLE";
    BenefitType["OutOfPocket"] = "OUT_OF_POCKET";
})(BenefitType || (BenefitType = {}));
export var Care_Finder_Display_Facility_Flag;
(function (Care_Finder_Display_Facility_Flag) {
    /** Dental Care */
    Care_Finder_Display_Facility_Flag["DentalCare"] = "dental_care";
    /** Dialysis */
    Care_Finder_Display_Facility_Flag["Dialysis"] = "dialysis";
    /** Emergency Rooms */
    Care_Finder_Display_Facility_Flag["EmergencyRooms"] = "emergency_rooms";
    /** Hospitals */
    Care_Finder_Display_Facility_Flag["Hospitals"] = "hospitals";
    /** Long Term Care Facilities */
    Care_Finder_Display_Facility_Flag["LongTermCareFacilities"] = "long_term_care_facilities";
    /** Pharmacies */
    Care_Finder_Display_Facility_Flag["Pharmacies"] = "pharmacies";
    /** Physical Therapy And Chiropractors */
    Care_Finder_Display_Facility_Flag["PhysicalTherapyAndChiropractors"] = "physical_therapy_and_chiropractors";
    /** Primary Care */
    Care_Finder_Display_Facility_Flag["PrimaryCare"] = "primary_care";
    /** Rehabilitation Centers */
    Care_Finder_Display_Facility_Flag["RehabilitationCenters"] = "rehabilitation_centers";
    /** Specialty Care */
    Care_Finder_Display_Facility_Flag["SpecialtyCare"] = "specialty_care";
    /** Testing And Diagnostics */
    Care_Finder_Display_Facility_Flag["TestingAndDiagnostics"] = "testing_and_diagnostics";
    /** Urgent Care */
    Care_Finder_Display_Facility_Flag["UrgentCare"] = "urgent_care";
    /** Vision Care */
    Care_Finder_Display_Facility_Flag["VisionCare"] = "vision_care";
})(Care_Finder_Display_Facility_Flag || (Care_Finder_Display_Facility_Flag = {}));
export var Care_Finder_Display_Provider_Flag;
(function (Care_Finder_Display_Provider_Flag) {
    /** Acupuncturist */
    Care_Finder_Display_Provider_Flag["Acupuncturist"] = "ACUPUNCTURIST";
    /** Allergist */
    Care_Finder_Display_Provider_Flag["Allergist"] = "ALLERGIST";
    /** Audiologist (Hearing Aids) */
    Care_Finder_Display_Provider_Flag["Audiologist"] = "AUDIOLOGIST";
    /** Cardiologist */
    Care_Finder_Display_Provider_Flag["Cardiologist"] = "CARDIOLOGIST";
    /** Chiropractor */
    Care_Finder_Display_Provider_Flag["Chiropractor"] = "CHIROPRACTOR";
    /** Dentists and Dental Specialists */
    Care_Finder_Display_Provider_Flag["Dentist"] = "DENTIST";
    /** Dermatologist */
    Care_Finder_Display_Provider_Flag["Dermatologist"] = "DERMATOLOGIST";
    /** Endocrinologist (Hormones, Thyroid, Osteoporosis, and/or Diabetes) */
    Care_Finder_Display_Provider_Flag["Endocrinologist"] = "ENDOCRINOLOGIST";
    /** Eye Doctors */
    Care_Finder_Display_Provider_Flag["EyeDoctor"] = "EYE_DOCTOR";
    /** Gastroenterologist (Colonoscopy) */
    Care_Finder_Display_Provider_Flag["Gastroenterologist"] = "GASTROENTEROLOGIST";
    /** Obstetrician-Gynecologists (OBGYNs) */
    Care_Finder_Display_Provider_Flag["Gynecologist"] = "GYNECOLOGIST";
    /** Hematologist (Blood Specialist) */
    Care_Finder_Display_Provider_Flag["Hematologist"] = "HEMATOLOGIST";
    /** Infectious Disease Specialist */
    Care_Finder_Display_Provider_Flag["InfectiousDisease"] = "INFECTIOUS_DISEASE";
    /** Mental Health Providers */
    Care_Finder_Display_Provider_Flag["MentalHealth"] = "MENTAL_HEALTH";
    /** Nephrologist (Kidney Specialist) */
    Care_Finder_Display_Provider_Flag["Nephrologist"] = "NEPHROLOGIST";
    /** Neurologist (Headache and Nervous System) */
    Care_Finder_Display_Provider_Flag["Neurologist"] = "NEUROLOGIST";
    /** Dietician / Nutritionist */
    Care_Finder_Display_Provider_Flag["Nutritionist"] = "NUTRITIONIST";
    /** Occupational Therapy */
    Care_Finder_Display_Provider_Flag["OccupationalTherapy"] = "OCCUPATIONAL_THERAPY";
    /** Oncologist (Cancer Specialist) */
    Care_Finder_Display_Provider_Flag["Oncologist"] = "ONCOLOGIST";
    /** Orthopedist/Orthopedic Surgeon */
    Care_Finder_Display_Provider_Flag["Orthopedist"] = "ORTHOPEDIST";
    /** Ear, Nose, & Throat Doctor (ENT/Otolaryngologist) */
    Care_Finder_Display_Provider_Flag["Otolaryngolist"] = "OTOLARYNGOLIST";
    /** Pain Medicine Specialist */
    Care_Finder_Display_Provider_Flag["PainMedicine"] = "PAIN_MEDICINE";
    /** Pediatricians */
    Care_Finder_Display_Provider_Flag["Pediatrician"] = "PEDIATRICIAN";
    /** Physiatrist (Physical Medicine) */
    Care_Finder_Display_Provider_Flag["Physiatrist"] = "PHYSIATRIST";
    /** Physical Therapy */
    Care_Finder_Display_Provider_Flag["PhysicalTherapy"] = "PHYSICAL_THERAPY";
    /** Podiatrist (Foot/Ankle Specialist) */
    Care_Finder_Display_Provider_Flag["Podiatrist"] = "PODIATRIST";
    /** Primary Care Physicians (PCPs) */
    Care_Finder_Display_Provider_Flag["PrimaryCare"] = "PRIMARY_CARE";
    /** Pulmonologist (Lung Specialist) */
    Care_Finder_Display_Provider_Flag["Pulmonologist"] = "PULMONOLOGIST";
    /** Reproductive Endocrinologist (Fertility Specialist) */
    Care_Finder_Display_Provider_Flag["ReproductiveEndocrinologist"] = "REPRODUCTIVE_ENDOCRINOLOGIST";
    /** Rheumatologist (Arthritis and/or Autoimmune Conditions) */
    Care_Finder_Display_Provider_Flag["Rheumatologist"] = "RHEUMATOLOGIST";
    /** Sleep Specialist */
    Care_Finder_Display_Provider_Flag["SleepSpecialist"] = "SLEEP_SPECIALIST";
    /** Speech Therapy */
    Care_Finder_Display_Provider_Flag["SpeechTherapy"] = "SPEECH_THERAPY";
    /** Surgeons */
    Care_Finder_Display_Provider_Flag["Surgeons"] = "SURGEONS";
    /** Urologist */
    Care_Finder_Display_Provider_Flag["Urologist"] = "UROLOGIST";
})(Care_Finder_Display_Provider_Flag || (Care_Finder_Display_Provider_Flag = {}));
export var Care_Pod_Organizations_Order;
(function (Care_Pod_Organizations_Order) {
    /** Ascending sort by 'name' field. */
    Care_Pod_Organizations_Order["Name"] = "name";
    /** Descending sort by 'name' field. */
    Care_Pod_Organizations_Order["ReverseName"] = "reverse_name";
})(Care_Pod_Organizations_Order || (Care_Pod_Organizations_Order = {}));
export var Care_Pod_Tpa_Order;
(function (Care_Pod_Tpa_Order) {
    /** Ascending sort by 'name' field. */
    Care_Pod_Tpa_Order["Name"] = "name";
    /** Descending sort by 'name' field. */
    Care_Pod_Tpa_Order["ReverseName"] = "reverse_name";
})(Care_Pod_Tpa_Order || (Care_Pod_Tpa_Order = {}));
export var Care_Program_Status_Type;
(function (Care_Program_Status_Type) {
    Care_Program_Status_Type["Eligible"] = "eligible";
    Care_Program_Status_Type["Enrolled"] = "enrolled";
    Care_Program_Status_Type["NonAdherent"] = "non_adherent";
    Care_Program_Status_Type["Unspecified"] = "unspecified";
})(Care_Program_Status_Type || (Care_Program_Status_Type = {}));
export var Chat_Messages_Order;
(function (Chat_Messages_Order) {
    /** Ascending sort by 'created' field. */
    Chat_Messages_Order["Created"] = "created";
    /** Descending sort by 'created' field. */
    Chat_Messages_Order["ReverseCreated"] = "reverse_created";
    /** Descending sort by 'updated' field. */
    Chat_Messages_Order["ReverseUpdated"] = "reverse_updated";
    /** Ascending sort by 'updated' field. */
    Chat_Messages_Order["Updated"] = "updated";
})(Chat_Messages_Order || (Chat_Messages_Order = {}));
export var Chat_Message_Attachment;
(function (Chat_Message_Attachment) {
    /** Additional notification message.. */
    Chat_Message_Attachment["Notification"] = "notification";
    /** Redirect to resource, or application part. */
    Chat_Message_Attachment["Transition"] = "transition";
})(Chat_Message_Attachment || (Chat_Message_Attachment = {}));
export var Chat_Message_Attachment_Notification;
(function (Chat_Message_Attachment_Notification) {
    /** System notification. */
    Chat_Message_Attachment_Notification["System"] = "system";
})(Chat_Message_Attachment_Notification || (Chat_Message_Attachment_Notification = {}));
export var Chat_Message_Attachment_Position;
(function (Chat_Message_Attachment_Position) {
    /** Display the message and then attachment right after it. */
    Chat_Message_Attachment_Position["Prepend"] = "prepend";
    /** Hide the message and display attachment only. */
    Chat_Message_Attachment_Position["Replace"] = "replace";
})(Chat_Message_Attachment_Position || (Chat_Message_Attachment_Position = {}));
export var Chat_Message_Attachment_Transition;
(function (Chat_Message_Attachment_Transition) {
    /** Redirection to particular Appointment's page. */
    Chat_Message_Attachment_Transition["Appointment"] = "appointment";
    /** Redirection to particular Bill Advocacy request page. */
    Chat_Message_Attachment_Transition["Claim"] = "claim";
    /** Redirection to find care page. */
    Chat_Message_Attachment_Transition["FindCare"] = "find_care";
    /** Redirection to particular Care Plan's page. */
    Chat_Message_Attachment_Transition["Roadmap"] = "roadmap";
})(Chat_Message_Attachment_Transition || (Chat_Message_Attachment_Transition = {}));
/** Content Type of file attachment. */
export var Chat_Message_File_Content_Type;
(function (Chat_Message_File_Content_Type) {
    /** application/pdf */
    Chat_Message_File_Content_Type["ApplicationPdf"] = "APPLICATION_PDF";
    /** image/gif */
    Chat_Message_File_Content_Type["ImageGif"] = "IMAGE_GIF";
    /** image/jpeg */
    Chat_Message_File_Content_Type["ImageJpeg"] = "IMAGE_JPEG";
    /** image/jpg */
    Chat_Message_File_Content_Type["ImageJpg"] = "IMAGE_JPG";
    /** image/png */
    Chat_Message_File_Content_Type["ImagePng"] = "IMAGE_PNG";
})(Chat_Message_File_Content_Type || (Chat_Message_File_Content_Type = {}));
/** Kind of a chat review annotation */
export var Chat_Review_Annotation_Kind;
(function (Chat_Review_Annotation_Kind) {
    Chat_Review_Annotation_Kind["Negative"] = "NEGATIVE";
    Chat_Review_Annotation_Kind["Positive"] = "POSITIVE";
    Chat_Review_Annotation_Kind["Unspecified"] = "UNSPECIFIED";
})(Chat_Review_Annotation_Kind || (Chat_Review_Annotation_Kind = {}));
/** Severity level of a chat review domain */
export var Chat_Review_Domain_Severity;
(function (Chat_Review_Domain_Severity) {
    Chat_Review_Domain_Severity["Coaching"] = "COACHING";
    Chat_Review_Domain_Severity["ComplianceRisk"] = "COMPLIANCE_RISK";
    Chat_Review_Domain_Severity["CriticalRisk"] = "CRITICAL_RISK";
    Chat_Review_Domain_Severity["Informational"] = "INFORMATIONAL";
    Chat_Review_Domain_Severity["Unspecified"] = "UNSPECIFIED";
})(Chat_Review_Domain_Severity || (Chat_Review_Domain_Severity = {}));
/** Status of chat. */
export var Chat_Status_Type;
(function (Chat_Status_Type) {
    /** Active */
    Chat_Status_Type["Active"] = "active";
    /** Archived */
    Chat_Status_Type["Archived"] = "archived";
    /** Inactive */
    Chat_Status_Type["Inactive"] = "inactive";
    /** Resolved */
    Chat_Status_Type["Resolved"] = "resolved";
})(Chat_Status_Type || (Chat_Status_Type = {}));
export var Chat_Template_Type_Order;
(function (Chat_Template_Type_Order) {
    /** Descending sort by 'title' field. */
    Chat_Template_Type_Order["ReverseTitle"] = "reverse_title";
    /** Ascending sort by 'title' field. */
    Chat_Template_Type_Order["Title"] = "title";
})(Chat_Template_Type_Order || (Chat_Template_Type_Order = {}));
export var Chat_Ticket_Subscription_Event_Type;
(function (Chat_Ticket_Subscription_Event_Type) {
    /** The ticket was assigned to chat. */
    Chat_Ticket_Subscription_Event_Type["TicketAssigned"] = "ticket_assigned";
    /** The ticket in the chat has been updated. */
    Chat_Ticket_Subscription_Event_Type["TicketUpdated"] = "ticket_updated";
})(Chat_Ticket_Subscription_Event_Type || (Chat_Ticket_Subscription_Event_Type = {}));
export var Chat_Type_Order;
(function (Chat_Type_Order) {
    /** Ascending sort by 'care_pod_name' field. */
    Chat_Type_Order["CarePodName"] = "care_pod_name";
    /** Ascending sort by 'created' field. */
    Chat_Type_Order["Created"] = "created";
    /** Ascending sort by 'id' field. */
    Chat_Type_Order["Id"] = "id";
    /** Ascending sort by 'last_message' field. */
    Chat_Type_Order["LastMessage"] = "last_message";
    /** Descending sort by 'care_pod_name' field. */
    Chat_Type_Order["ReverseCarePodName"] = "reverse_care_pod_name";
    /** Descending sort by 'created' field. */
    Chat_Type_Order["ReverseCreated"] = "reverse_created";
    /** Descending sort by 'id' field. */
    Chat_Type_Order["ReverseId"] = "reverse_id";
    /** Descending sort by 'last_message' field. */
    Chat_Type_Order["ReverseLastMessage"] = "reverse_last_message";
    /** Descending sort by 'subject' field. */
    Chat_Type_Order["ReverseSubject"] = "reverse_subject";
    /** Descending sort by 'ticket_id' field. */
    Chat_Type_Order["ReverseTicketId"] = "reverse_ticket_id";
    /** Descending sort by 'updated' field. */
    Chat_Type_Order["ReverseUpdated"] = "reverse_updated";
    /** Ascending sort by 'subject' field. */
    Chat_Type_Order["Subject"] = "subject";
    /** Ascending sort by 'ticket_id' field. */
    Chat_Type_Order["TicketId"] = "ticket_id";
    /** Ascending sort by 'updated' field. */
    Chat_Type_Order["Updated"] = "updated";
})(Chat_Type_Order || (Chat_Type_Order = {}));
export var Chronic_Condition_Order;
(function (Chronic_Condition_Order) {
    /** Ascending sort by 'first_observed' field. */
    Chronic_Condition_Order["FirstObserved"] = "first_observed";
    /** Ascending sort by 'last_observed' field. */
    Chronic_Condition_Order["LastObserved"] = "last_observed";
    /** Ascending sort by 'name' field. */
    Chronic_Condition_Order["Name"] = "name";
    /** Descending sort by 'first_observed' field. */
    Chronic_Condition_Order["ReverseFirstObserved"] = "reverse_first_observed";
    /** Descending sort by 'last_observed' field. */
    Chronic_Condition_Order["ReverseLastObserved"] = "reverse_last_observed";
    /** Descending sort by 'name' field. */
    Chronic_Condition_Order["ReverseName"] = "reverse_name";
})(Chronic_Condition_Order || (Chronic_Condition_Order = {}));
export var Claims_Type_Order;
(function (Claims_Type_Order) {
    /** Ascending sort by 'created_at' field. */
    Claims_Type_Order["CreatedAt"] = "created_at";
    /** Ascending sort by 'id' field. */
    Claims_Type_Order["Id"] = "id";
    /** Descending sort by 'created_at' field. */
    Claims_Type_Order["ReverseCreatedAt"] = "reverse_created_at";
    /** Descending sort by 'id' field. */
    Claims_Type_Order["ReverseId"] = "reverse_id";
    /** Descending sort by 'ticket_id' field. */
    Claims_Type_Order["ReverseTicketId"] = "reverse_ticket_id";
    /** Descending sort by 'updated_at' field. */
    Claims_Type_Order["ReverseUpdatedAt"] = "reverse_updated_at";
    /** Ascending sort by 'ticket_id' field. */
    Claims_Type_Order["TicketId"] = "ticket_id";
    /** Ascending sort by 'updated_at' field. */
    Claims_Type_Order["UpdatedAt"] = "updated_at";
})(Claims_Type_Order || (Claims_Type_Order = {}));
/** Possible Claim statuses. */
export var Claim_Status;
(function (Claim_Status) {
    /** Action needed */
    Claim_Status["ActionNeeded"] = "action_needed";
    /** In progress */
    Claim_Status["InProgress"] = "in_progress";
    /** Pending */
    Claim_Status["Pending"] = "pending";
    /** Resolved */
    Claim_Status["Resolved"] = "resolved";
})(Claim_Status || (Claim_Status = {}));
/** Contact method types for client communications */
export var Contact_Method_Type;
(function (Contact_Method_Type) {
    Contact_Method_Type["Email"] = "email";
    Contact_Method_Type["Other"] = "other";
    Contact_Method_Type["Phone"] = "phone";
    Contact_Method_Type["Text"] = "text";
    Contact_Method_Type["Unspecified"] = "unspecified";
})(Contact_Method_Type || (Contact_Method_Type = {}));
/** Possible plan contact types */
export var Contact_Type;
(function (Contact_Type) {
    /** Benefits department */
    Contact_Type["BenefitsDepartment"] = "benefits_department";
    /** Billing */
    Contact_Type["Billing"] = "billing";
    /** Carrier */
    Contact_Type["Carrier"] = "carrier";
    /** Claims issues */
    Contact_Type["ClaimsIssues"] = "claims_issues";
    /** Customer service */
    Contact_Type["CustomerService"] = "customer_service";
    /** Dental */
    Contact_Type["Dental"] = "dental";
    /** Disability vendor */
    Contact_Type["DisabilityVendor"] = "disability_vendor";
    /** Hr */
    Contact_Type["Hr"] = "hr";
    /** Medical */
    Contact_Type["Medical"] = "medical";
    /** Mental health */
    Contact_Type["MentalHealth"] = "mental_health";
    /** Organization */
    Contact_Type["Organization"] = "organization";
    /** Other */
    Contact_Type["Other"] = "other";
    /** Partners */
    Contact_Type["Partners"] = "partners";
    /** PBM */
    Contact_Type["Pbm"] = "pbm";
    /** Pharmacy */
    Contact_Type["Pharmacy"] = "pharmacy";
    /** Point solution */
    Contact_Type["PointSolution"] = "point_solution";
    /** Spending account vendor */
    Contact_Type["SpendingAccountVendor"] = "spending_account_vendor";
    /** TPA */
    Contact_Type["Tpa"] = "tpa";
    /** Vision */
    Contact_Type["Vision"] = "vision";
    /** Voluntary ancillary benefits vendor */
    Contact_Type["VoluntaryAncillaryBenefitsVendor"] = "voluntary_ancillary_benefits_vendor";
})(Contact_Type || (Contact_Type = {}));
export var Cost_Estimate_Type;
(function (Cost_Estimate_Type) {
    Cost_Estimate_Type["PrimaryCare"] = "primary_care";
    Cost_Estimate_Type["SpecialistVisit"] = "specialist_visit";
    Cost_Estimate_Type["UrgentCare"] = "urgent_care";
})(Cost_Estimate_Type || (Cost_Estimate_Type = {}));
export var CareCompleteConsultType;
(function (CareCompleteConsultType) {
    CareCompleteConsultType["Adhoc"] = "ADHOC";
    CareCompleteConsultType["Onboarding"] = "ONBOARDING";
    CareCompleteConsultType["Routine"] = "ROUTINE";
})(CareCompleteConsultType || (CareCompleteConsultType = {}));
export var Categories;
(function (Categories) {
    /** Drug covered */
    Categories["DrugCovered"] = "drug_covered";
    /** Drug not covered */
    Categories["DrugNotCovered"] = "drug_not_covered";
    /** Prescription no refill */
    Categories["PrescriptionNoRefill"] = "prescription_no_refill";
    /** Prescription prior auth */
    Categories["PrescriptionPriorAuth"] = "prescription_prior_auth";
    /** Prescription refill pending */
    Categories["PrescriptionRefillPending"] = "prescription_refill_pending";
    /** Prescription transfer pharmacy */
    Categories["PrescriptionTransferPharmacy"] = "prescription_transfer_pharmacy";
    /** Unknown */
    Categories["Unknown"] = "unknown";
})(Categories || (Categories = {}));
/** Enum representing claim status codes */
export var ClaimCode;
(function (ClaimCode) {
    ClaimCode["Aa"] = "AA";
    ClaimCode["Ap"] = "AP";
    ClaimCode["Ar"] = "AR";
    ClaimCode["R"] = "R";
    ClaimCode["UnspecifiedClaimCode"] = "UNSPECIFIED_CLAIM_CODE";
})(ClaimCode || (ClaimCode = {}));
/** Describes, which address should be selected in contacts. */
export var ContactsSelectBy;
(function (ContactsSelectBy) {
    /** Find first available address, sorted by its confidence level */
    ContactsSelectBy["MaxConfidence"] = "max_confidence";
    /** Find the closest address */
    ContactsSelectBy["Nearest"] = "nearest";
    /** Find contact that been stored as default */
    ContactsSelectBy["Preferred"] = "preferred";
    /** Find Rightway Primary address */
    ContactsSelectBy["RightwayPrimary"] = "rightway_primary";
})(ContactsSelectBy || (ContactsSelectBy = {}));
export var ContentStepTypeEnum;
(function (ContentStepTypeEnum) {
    ContentStepTypeEnum["Link"] = "link";
    ContentStepTypeEnum["RxCard"] = "rx_card";
    ContentStepTypeEnum["Text"] = "text";
})(ContentStepTypeEnum || (ContentStepTypeEnum = {}));
export var Day_Name;
(function (Day_Name) {
    Day_Name["Friday"] = "Friday";
    Day_Name["Monday"] = "Monday";
    Day_Name["Saturday"] = "Saturday";
    Day_Name["Sunday"] = "Sunday";
    Day_Name["Thursday"] = "Thursday";
    Day_Name["Tuesday"] = "Tuesday";
    Day_Name["Wednesday"] = "Wednesday";
})(Day_Name || (Day_Name = {}));
export var Deliverable_Categories_Order;
(function (Deliverable_Categories_Order) {
    /** Ascending sort by 'id' field. */
    Deliverable_Categories_Order["Id"] = "id";
    /** Ascending sort by 'name' field. */
    Deliverable_Categories_Order["Name"] = "name";
    /** Ascending sort by 'position' field. */
    Deliverable_Categories_Order["Position"] = "position";
    /** Descending sort by 'id' field. */
    Deliverable_Categories_Order["ReverseId"] = "reverse_id";
    /** Descending sort by 'name' field. */
    Deliverable_Categories_Order["ReverseName"] = "reverse_name";
    /** Descending sort by 'position' field. */
    Deliverable_Categories_Order["ReversePosition"] = "reverse_position";
})(Deliverable_Categories_Order || (Deliverable_Categories_Order = {}));
export var Deliverable_Labels_Order;
(function (Deliverable_Labels_Order) {
    /** Ascending sort by 'id' field. */
    Deliverable_Labels_Order["Id"] = "id";
    /** Ascending sort by 'name' field. */
    Deliverable_Labels_Order["Name"] = "name";
    /** Descending sort by 'id' field. */
    Deliverable_Labels_Order["ReverseId"] = "reverse_id";
    /** Descending sort by 'name' field. */
    Deliverable_Labels_Order["ReverseName"] = "reverse_name";
})(Deliverable_Labels_Order || (Deliverable_Labels_Order = {}));
export var Detailed_Third_Party_Admins_Order;
(function (Detailed_Third_Party_Admins_Order) {
    /** Ascending sort by 'name' field. */
    Detailed_Third_Party_Admins_Order["Name"] = "name";
    /** Descending sort by 'name' field. */
    Detailed_Third_Party_Admins_Order["ReverseName"] = "reverse_name";
})(Detailed_Third_Party_Admins_Order || (Detailed_Third_Party_Admins_Order = {}));
export var Detailed_Ticket_Type_Order;
(function (Detailed_Ticket_Type_Order) {
    /** Ascending sort by 'id' field. */
    Detailed_Ticket_Type_Order["Id"] = "id";
    /** Ascending sort by 'name' field. */
    Detailed_Ticket_Type_Order["Name"] = "name";
    /** Descending sort by 'id' field. */
    Detailed_Ticket_Type_Order["ReverseId"] = "reverse_id";
    /** Descending sort by 'name' field. */
    Detailed_Ticket_Type_Order["ReverseName"] = "reverse_name";
})(Detailed_Ticket_Type_Order || (Detailed_Ticket_Type_Order = {}));
export var Documents_Order;
(function (Documents_Order) {
    /** Ascending sort by 'created' field. */
    Documents_Order["Created"] = "created";
    /** Ascending sort by 'id' field. */
    Documents_Order["Id"] = "id";
    /** Descending sort by 'created' field. */
    Documents_Order["ReverseCreated"] = "reverse_created";
    /** Descending sort by 'id' field. */
    Documents_Order["ReverseId"] = "reverse_id";
    /** Descending sort by 'title' field. */
    Documents_Order["ReverseTitle"] = "reverse_title";
    /** Ascending sort by 'title' field. */
    Documents_Order["Title"] = "title";
})(Documents_Order || (Documents_Order = {}));
export var Document_Attached_To_Type;
(function (Document_Attached_To_Type) {
    /** Member */
    Document_Attached_To_Type["Member"] = "member";
    /** Organization */
    Document_Attached_To_Type["Organization"] = "organization";
})(Document_Attached_To_Type || (Document_Attached_To_Type = {}));
export var Document_Content_Type;
(function (Document_Content_Type) {
    /** Image */
    Document_Content_Type["Image"] = "image";
    /** Other */
    Document_Content_Type["Other"] = "other";
    /** PDF */
    Document_Content_Type["Pdf"] = "pdf";
})(Document_Content_Type || (Document_Content_Type = {}));
export var Document_Source_Type;
(function (Document_Source_Type) {
    /** Bill Advocacy */
    Document_Source_Type["BillAdvocacy"] = "bill_advocacy";
    /** Chat */
    Document_Source_Type["Chat"] = "chat";
    /** HIPAA Document */
    Document_Source_Type["HipaaDocument"] = "hipaa_document";
    /** Insurance Card */
    Document_Source_Type["InsuranceCard"] = "insurance_card";
    /** Member-related documents */
    Document_Source_Type["Member"] = "member";
    /** Organization Document */
    Document_Source_Type["Organization"] = "organization";
})(Document_Source_Type || (Document_Source_Type = {}));
/** Type of user document. */
export var Document_Type_Type;
(function (Document_Type_Type) {
    /** General document. If none of the below, select this. */
    Document_Type_Type["Document"] = "document";
    /** HIPAA Document */
    Document_Type_Type["HipaaDocument"] = "hipaa_document";
    /** Document related to a member. Can be uploaded by navigator! */
    Document_Type_Type["MemberDocument"] = "member_document";
})(Document_Type_Type || (Document_Type_Type = {}));
/** Drug list update request actions */
export var Drug_List_Update_Request_Action;
(function (Drug_List_Update_Request_Action) {
    Drug_List_Update_Request_Action["Addition"] = "addition";
    Drug_List_Update_Request_Action["Removal"] = "removal";
})(Drug_List_Update_Request_Action || (Drug_List_Update_Request_Action = {}));
/** Day of the week */
export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["Friday"] = "FRIDAY";
    DayOfWeek["Monday"] = "MONDAY";
    DayOfWeek["Saturday"] = "SATURDAY";
    DayOfWeek["Sunday"] = "SUNDAY";
    DayOfWeek["Thursday"] = "THURSDAY";
    DayOfWeek["Tuesday"] = "TUESDAY";
    DayOfWeek["UnspecifiedDayOfWeek"] = "UNSPECIFIED_DAY_OF_WEEK";
    DayOfWeek["Wednesday"] = "WEDNESDAY";
})(DayOfWeek || (DayOfWeek = {}));
export var Diabetes;
(function (Diabetes) {
    /** Gestational */
    Diabetes["Gestational"] = "gestational";
    /** Prediabetes */
    Diabetes["Prediabetes"] = "prediabetes";
    /** Type 1 */
    Diabetes["Type_1"] = "type_1";
    /** Type 2 */
    Diabetes["Type_2"] = "type_2";
    /** Unknown */
    Diabetes["Unknown"] = "unknown";
})(Diabetes || (Diabetes = {}));
export var DisclaimerType;
(function (DisclaimerType) {
    DisclaimerType["Error"] = "ERROR";
    DisclaimerType["Success"] = "SUCCESS";
    DisclaimerType["UnspecifiedPriority"] = "UNSPECIFIED_PRIORITY";
    DisclaimerType["Warning"] = "WARNING";
})(DisclaimerType || (DisclaimerType = {}));
/** Possible action types */
export var EligibilityActionEventType;
(function (EligibilityActionEventType) {
    /** Activation */
    EligibilityActionEventType["Activation"] = "activation";
    /** Deactivation */
    EligibilityActionEventType["Deactivation"] = "deactivation";
})(EligibilityActionEventType || (EligibilityActionEventType = {}));
/** Possible eligibility action reasons */
export var EligibilityActionReasonsType;
(function (EligibilityActionReasonsType) {
    /** Advocate */
    EligibilityActionReasonsType["Advocate"] = "advocate";
    /** API */
    EligibilityActionReasonsType["Api"] = "api";
    /** Census */
    EligibilityActionReasonsType["Census"] = "census";
    /** Organization deactivated */
    EligibilityActionReasonsType["OrganizationDeactivated"] = "organization_deactivated";
})(EligibilityActionReasonsType || (EligibilityActionReasonsType = {}));
export var EmailDirection;
(function (EmailDirection) {
    EmailDirection["EmailDirectionInbound"] = "EMAIL_DIRECTION_INBOUND";
    EmailDirection["EmailDirectionOutbound"] = "EMAIL_DIRECTION_OUTBOUND";
    EmailDirection["EmailDirectionUnspecified"] = "EMAIL_DIRECTION_UNSPECIFIED";
})(EmailDirection || (EmailDirection = {}));
export var EmailScanStatus;
(function (EmailScanStatus) {
    EmailScanStatus["ScanStatusApproved"] = "SCAN_STATUS_APPROVED";
    EmailScanStatus["ScanStatusFlagged"] = "SCAN_STATUS_FLAGGED";
    EmailScanStatus["ScanStatusPending"] = "SCAN_STATUS_PENDING";
    EmailScanStatus["ScanStatusUnscannable"] = "SCAN_STATUS_UNSCANNABLE";
    EmailScanStatus["ScanStatusUnspecified"] = "SCAN_STATUS_UNSPECIFIED";
})(EmailScanStatus || (EmailScanStatus = {}));
export var EmailStatus;
(function (EmailStatus) {
    EmailStatus["EmailStatusBounced"] = "EMAIL_STATUS_BOUNCED";
    EmailStatus["EmailStatusComplained"] = "EMAIL_STATUS_COMPLAINED";
    EmailStatus["EmailStatusDelivered"] = "EMAIL_STATUS_DELIVERED";
    EmailStatus["EmailStatusFailed"] = "EMAIL_STATUS_FAILED";
    EmailStatus["EmailStatusQueued"] = "EMAIL_STATUS_QUEUED";
    EmailStatus["EmailStatusSent"] = "EMAIL_STATUS_SENT";
    EmailStatus["EmailStatusUnspecified"] = "EMAIL_STATUS_UNSPECIFIED";
})(EmailStatus || (EmailStatus = {}));
export var Facility_Location_Type;
(function (Facility_Location_Type) {
    /** Ambulatory Surgery Center */
    Facility_Location_Type["AmbulatorySurgeryCenter"] = "AMBULATORY_SURGERY_CENTER";
    /** Assisted Living Facility */
    Facility_Location_Type["AssistedLivingFacility"] = "ASSISTED_LIVING_FACILITY";
    /** Clinic */
    Facility_Location_Type["Clinic"] = "CLINIC";
    /** Clinic - Dental */
    Facility_Location_Type["ClinicDental"] = "CLINIC_DENTAL";
    /** Clinic - Vision */
    Facility_Location_Type["ClinicVision"] = "CLINIC_VISION";
    /** Dialysis Center */
    Facility_Location_Type["DialysisCenter"] = "DIALYSIS_CENTER";
    /** Emergency Room */
    Facility_Location_Type["EmergencyRoom"] = "EMERGENCY_ROOM";
    /** Home Health Agency */
    Facility_Location_Type["HomeHealthAgency"] = "HOME_HEALTH_AGENCY";
    /** Hospice */
    Facility_Location_Type["Hospice"] = "HOSPICE";
    /** Hospital */
    Facility_Location_Type["Hospital"] = "HOSPITAL";
    /** Hospital - Children Chronic Disease */
    Facility_Location_Type["HospitalChildrenChronicDisease"] = "HOSPITAL_CHILDREN_CHRONIC_DISEASE";
    /** Hospital - Children General Acute Care */
    Facility_Location_Type["HospitalChildrenGeneralAcuteCare"] = "HOSPITAL_CHILDREN_GENERAL_ACUTE_CARE";
    /** Hospital - Children Rehabilitation */
    Facility_Location_Type["HospitalChildrenRehabilitation"] = "HOSPITAL_CHILDREN_REHABILITATION";
    /** Hospital - Chronic Disease */
    Facility_Location_Type["HospitalChronicDisease"] = "HOSPITAL_CHRONIC_DISEASE";
    /** Hospital - General Acute Care */
    Facility_Location_Type["HospitalGeneralAcuteCare"] = "HOSPITAL_GENERAL_ACUTE_CARE";
    /** Hospital - Long Term Care */
    Facility_Location_Type["HospitalLongTermCare"] = "HOSPITAL_LONG_TERM_CARE";
    /** Hospital - Psychiatric */
    Facility_Location_Type["HospitalPsychiatric"] = "HOSPITAL_PSYCHIATRIC";
    /** Hospital - Rehabilitation */
    Facility_Location_Type["HospitalRehabilitation"] = "HOSPITAL_REHABILITATION";
    /** Imaging Center */
    Facility_Location_Type["ImagingCenter"] = "IMAGING_CENTER";
    /** Independent Clinic */
    Facility_Location_Type["IndependentClinic"] = "INDEPENDENT_CLINIC";
    /** Laboratory - Dental */
    Facility_Location_Type["LaboratoryDental"] = "LABORATORY_DENTAL";
    /** Laboratory - Medical */
    Facility_Location_Type["LaboratoryMedical"] = "LABORATORY_MEDICAL";
    /** Laboratory - Physiological */
    Facility_Location_Type["LaboratoryPhysiological"] = "LABORATORY_PHYSIOLOGICAL";
    /** Pharmacy */
    Facility_Location_Type["Pharmacy"] = "PHARMACY";
    /** Physical Therapy */
    Facility_Location_Type["PhysicalTherapy"] = "PHYSICAL_THERAPY";
    /** Primary Care Clinic */
    Facility_Location_Type["PrimaryCareClinic"] = "PRIMARY_CARE_CLINIC";
    /** Residential Treatment Facility - Mental or Developmental Disabilities */
    Facility_Location_Type["ResidentialTreatmentFacilityMentalOrDevelopmentalDisabilities"] = "RESIDENTIAL_TREATMENT_FACILITY_MENTAL_OR_DEVELOPMENTAL_DISABILITIES";
    /** Residential Treatment Facility - Physical Disabilities */
    Facility_Location_Type["ResidentialTreatmentFacilityPhysicalDisabilities"] = "RESIDENTIAL_TREATMENT_FACILITY_PHYSICAL_DISABILITIES";
    /** Residential Treatment Facility - Psychiatric */
    Facility_Location_Type["ResidentialTreatmentFacilityPsychiatric"] = "RESIDENTIAL_TREATMENT_FACILITY_PSYCHIATRIC";
    /** Residential Treatment Facility - Substance Abuse */
    Facility_Location_Type["ResidentialTreatmentFacilitySubstanceAbuse"] = "RESIDENTIAL_TREATMENT_FACILITY_SUBSTANCE_ABUSE";
    /** Respite Care */
    Facility_Location_Type["RespiteCare"] = "RESPITE_CARE";
    /** Retail Health Clinic */
    Facility_Location_Type["RetailHealthClinic"] = "RETAIL_HEALTH_CLINIC";
    /** Skilled Nursing Facility */
    Facility_Location_Type["SkilledNursingFacility"] = "SKILLED_NURSING_FACILITY";
    /** Skilled Nursing Facility - Pediatric */
    Facility_Location_Type["SkilledNursingFacilityPediatric"] = "SKILLED_NURSING_FACILITY_PEDIATRIC";
    /** Telemedicine */
    Facility_Location_Type["Telemedicine"] = "TELEMEDICINE";
    /** Urgent Care */
    Facility_Location_Type["UrgentCare"] = "URGENT_CARE";
})(Facility_Location_Type || (Facility_Location_Type = {}));
export var Focus_Request_Type;
(function (Focus_Request_Type) {
    /** Disputing a charge */
    Focus_Request_Type["DisputingACharge"] = "disputing_a_charge";
    /** Other */
    Focus_Request_Type["Other"] = "other";
    /** Requesting information about my coverage */
    Focus_Request_Type["RequestingInformationAboutMyCoverage"] = "requesting_information_about_my_coverage";
    /** Submit an out-of-network claim for reimbursement */
    Focus_Request_Type["SubmittingOutOfNetworkForReimbursement"] = "submitting_out_of_network_for_reimbursement";
})(Focus_Request_Type || (Focus_Request_Type = {}));
export var FacilityTierEnum;
(function (FacilityTierEnum) {
    /** Tier 1 */
    FacilityTierEnum["Tier_1"] = "tier_1";
    /** Tier 2 */
    FacilityTierEnum["Tier_2"] = "tier_2";
})(FacilityTierEnum || (FacilityTierEnum = {}));
/** Member flags for Care Complete Diabetes Program */
export var FlagsCcdpEnrollmentType;
(function (FlagsCcdpEnrollmentType) {
    /** Declined */
    FlagsCcdpEnrollmentType["Declined"] = "declined";
    /** Disenrolled */
    FlagsCcdpEnrollmentType["Disenrolled"] = "disenrolled";
    /** Eligible */
    FlagsCcdpEnrollmentType["Eligible"] = "eligible";
    /** Enrolled */
    FlagsCcdpEnrollmentType["Enrolled"] = "enrolled";
    /** Not eligible */
    FlagsCcdpEnrollmentType["NotEligible"] = "not_eligible";
})(FlagsCcdpEnrollmentType || (FlagsCcdpEnrollmentType = {}));
/** Member flags for Care Complete Weight Management */
export var FlagsCcwmpEnrollmentType;
(function (FlagsCcwmpEnrollmentType) {
    /** Declined */
    FlagsCcwmpEnrollmentType["Declined"] = "declined";
    /** Disenrolled */
    FlagsCcwmpEnrollmentType["Disenrolled"] = "disenrolled";
    /** Eligible */
    FlagsCcwmpEnrollmentType["Eligible"] = "eligible";
    /** Enrolled */
    FlagsCcwmpEnrollmentType["Enrolled"] = "enrolled";
    /** Not eligible */
    FlagsCcwmpEnrollmentType["NotEligible"] = "not_eligible";
})(FlagsCcwmpEnrollmentType || (FlagsCcwmpEnrollmentType = {}));
/** Possible doctor genders */
export var GenderType;
(function (GenderType) {
    /** Female */
    GenderType["F"] = "f";
    /** Male */
    GenderType["M"] = "m";
})(GenderType || (GenderType = {}));
export var Inboxes_Order;
(function (Inboxes_Order) {
    /** Ascending sort by 'address' field. */
    Inboxes_Order["Address"] = "address";
    /** Ascending sort by 'id' field. */
    Inboxes_Order["Id"] = "id";
    /** Descending sort by 'address' field. */
    Inboxes_Order["ReverseAddress"] = "reverse_address";
    /** Descending sort by 'id' field. */
    Inboxes_Order["ReverseId"] = "reverse_id";
})(Inboxes_Order || (Inboxes_Order = {}));
/** Possible statuses of insurance partners. */
export var Insurance_Partners_Status;
(function (Insurance_Partners_Status) {
    /** Working as expected */
    Insurance_Partners_Status["Active"] = "active";
    /** Payer is showing intermittent issues */
    Insurance_Partners_Status["Delayed"] = "delayed";
    /** Payer is down or inactive for the foreseeable future */
    Insurance_Partners_Status["Inactive"] = "inactive";
    /** Payer is down, but a solution is being implemented */
    Insurance_Partners_Status["InactivePending"] = "inactive_pending";
    /** Status unknown */
    Insurance_Partners_Status["Unknown"] = "unknown";
})(Insurance_Partners_Status || (Insurance_Partners_Status = {}));
export var Insurance_Plans_Order;
(function (Insurance_Plans_Order) {
    /** Ascending sort by 'created' field. */
    Insurance_Plans_Order["Created"] = "created";
    /** Ascending sort by 'display_name' field. */
    Insurance_Plans_Order["DisplayName"] = "display_name";
    /** Ascending sort by 'end_date' field. */
    Insurance_Plans_Order["EndDate"] = "end_date";
    /** Ascending sort by 'name' field. */
    Insurance_Plans_Order["Name"] = "name";
    /** Descending sort by 'created' field. */
    Insurance_Plans_Order["ReverseCreated"] = "reverse_created";
    /** Descending sort by 'display_name' field. */
    Insurance_Plans_Order["ReverseDisplayName"] = "reverse_display_name";
    /** Descending sort by 'end_date' field. */
    Insurance_Plans_Order["ReverseEndDate"] = "reverse_end_date";
    /** Descending sort by 'name' field. */
    Insurance_Plans_Order["ReverseName"] = "reverse_name";
    /** Descending sort by 'start_date' field. */
    Insurance_Plans_Order["ReverseStartDate"] = "reverse_start_date";
    /** Descending sort by 'updated' field. */
    Insurance_Plans_Order["ReverseUpdated"] = "reverse_updated";
    /** Ascending sort by 'start_date' field. */
    Insurance_Plans_Order["StartDate"] = "start_date";
    /** Ascending sort by 'updated' field. */
    Insurance_Plans_Order["Updated"] = "updated";
})(Insurance_Plans_Order || (Insurance_Plans_Order = {}));
export var Insurance_Plan_Assignments_Order;
(function (Insurance_Plan_Assignments_Order) {
    /** Ascending sort by 'created' field. */
    Insurance_Plan_Assignments_Order["Created"] = "created";
    /** Ascending sort by 'display_name' field. */
    Insurance_Plan_Assignments_Order["DisplayName"] = "display_name";
    /** Ascending sort by 'eligibility_end_date' field. */
    Insurance_Plan_Assignments_Order["EligibilityEndDate"] = "eligibility_end_date";
    /** Ascending sort by 'eligibility_start_date' field. */
    Insurance_Plan_Assignments_Order["EligibilityStartDate"] = "eligibility_start_date";
    /** Ascending sort by 'name' field. */
    Insurance_Plan_Assignments_Order["Name"] = "name";
    /** Ascending sort by 'plan_end_date' field. */
    Insurance_Plan_Assignments_Order["PlanEndDate"] = "plan_end_date";
    /** Ascending sort by 'plan_start_date' field. */
    Insurance_Plan_Assignments_Order["PlanStartDate"] = "plan_start_date";
    /** Descending sort by 'created' field. */
    Insurance_Plan_Assignments_Order["ReverseCreated"] = "reverse_created";
    /** Descending sort by 'display_name' field. */
    Insurance_Plan_Assignments_Order["ReverseDisplayName"] = "reverse_display_name";
    /** Descending sort by 'eligibility_end_date' field. */
    Insurance_Plan_Assignments_Order["ReverseEligibilityEndDate"] = "reverse_eligibility_end_date";
    /** Descending sort by 'eligibility_start_date' field. */
    Insurance_Plan_Assignments_Order["ReverseEligibilityStartDate"] = "reverse_eligibility_start_date";
    /** Descending sort by 'name' field. */
    Insurance_Plan_Assignments_Order["ReverseName"] = "reverse_name";
    /** Descending sort by 'plan_end_date' field. */
    Insurance_Plan_Assignments_Order["ReversePlanEndDate"] = "reverse_plan_end_date";
    /** Descending sort by 'plan_start_date' field. */
    Insurance_Plan_Assignments_Order["ReversePlanStartDate"] = "reverse_plan_start_date";
    /** Descending sort by 'updated' field. */
    Insurance_Plan_Assignments_Order["ReverseUpdated"] = "reverse_updated";
    /** Ascending sort by 'updated' field. */
    Insurance_Plan_Assignments_Order["Updated"] = "updated";
})(Insurance_Plan_Assignments_Order || (Insurance_Plan_Assignments_Order = {}));
export var Insurance_Plan_Image_Versions;
(function (Insurance_Plan_Image_Versions) {
    /** large image version. */
    Insurance_Plan_Image_Versions["Large"] = "large";
    /** normal image version. */
    Insurance_Plan_Image_Versions["Normal"] = "normal";
    /** original image version. */
    Insurance_Plan_Image_Versions["Original"] = "original";
})(Insurance_Plan_Image_Versions || (Insurance_Plan_Image_Versions = {}));
export var Insurance_Plan_Matching_Method_Type;
(function (Insurance_Plan_Matching_Method_Type) {
    /** API reference */
    Insurance_Plan_Matching_Method_Type["ApiReference"] = "api_reference";
    /** Eligibility name */
    Insurance_Plan_Matching_Method_Type["EligibilityName"] = "eligibility_name";
})(Insurance_Plan_Matching_Method_Type || (Insurance_Plan_Matching_Method_Type = {}));
export var Insurance_Plan_Referral_Type;
(function (Insurance_Plan_Referral_Type) {
    /** Does Not Require */
    Insurance_Plan_Referral_Type["None"] = "none";
    /** Plan Requires Referral For Specialist */
    Insurance_Plan_Referral_Type["Specialist"] = "specialist";
})(Insurance_Plan_Referral_Type || (Insurance_Plan_Referral_Type = {}));
export var Insurance_Type;
(function (Insurance_Type) {
    Insurance_Type["Dental"] = "dental";
    Insurance_Type["Medical"] = "medical";
    Insurance_Type["Pharmacy"] = "pharmacy";
    Insurance_Type["Vision"] = "vision";
})(Insurance_Type || (Insurance_Type = {}));
export var Intake_Groups_Order;
(function (Intake_Groups_Order) {
    /** Ascending sort by 'created_at' field. */
    Intake_Groups_Order["CreatedAt"] = "created_at";
    /** Ascending sort by 'id' field. */
    Intake_Groups_Order["Id"] = "id";
    /** Ascending sort by 'intake_queues_count' field. */
    Intake_Groups_Order["IntakeQueuesCount"] = "intake_queues_count";
    /** Ascending sort by 'name' field. */
    Intake_Groups_Order["Name"] = "name";
    /** Descending sort by 'created_at' field. */
    Intake_Groups_Order["ReverseCreatedAt"] = "reverse_created_at";
    /** Descending sort by 'id' field. */
    Intake_Groups_Order["ReverseId"] = "reverse_id";
    /** Descending sort by 'intake_queues_count' field. */
    Intake_Groups_Order["ReverseIntakeQueuesCount"] = "reverse_intake_queues_count";
    /** Descending sort by 'name' field. */
    Intake_Groups_Order["ReverseName"] = "reverse_name";
    /** Descending sort by 'status' field. */
    Intake_Groups_Order["ReverseStatus"] = "reverse_status";
    /** Descending sort by 'users_count' field. */
    Intake_Groups_Order["ReverseUsersCount"] = "reverse_users_count";
    /** Ascending sort by 'status' field. */
    Intake_Groups_Order["Status"] = "status";
    /** Ascending sort by 'users_count' field. */
    Intake_Groups_Order["UsersCount"] = "users_count";
})(Intake_Groups_Order || (Intake_Groups_Order = {}));
/** Intake Group statuses */
export var Intake_Group_Status;
(function (Intake_Group_Status) {
    /** Active */
    Intake_Group_Status["Active"] = "active";
    /** Inactive */
    Intake_Group_Status["Inactive"] = "inactive";
})(Intake_Group_Status || (Intake_Group_Status = {}));
export var Intake_Queues_Order;
(function (Intake_Queues_Order) {
    /** Ascending sort by 'id' field. */
    Intake_Queues_Order["Id"] = "id";
    /** Ascending sort by 'name' field. */
    Intake_Queues_Order["Name"] = "name";
    /** Ascending sort by 'position' field. */
    Intake_Queues_Order["Position"] = "position";
    /** Descending sort by 'id' field. */
    Intake_Queues_Order["ReverseId"] = "reverse_id";
    /** Descending sort by 'name' field. */
    Intake_Queues_Order["ReverseName"] = "reverse_name";
    /** Descending sort by 'position' field. */
    Intake_Queues_Order["ReversePosition"] = "reverse_position";
    /** Descending sort by 'status' field. */
    Intake_Queues_Order["ReverseStatus"] = "reverse_status";
    /** Descending sort by 'tickets_count' field. */
    Intake_Queues_Order["ReverseTicketsCount"] = "reverse_tickets_count";
    /** Descending sort by 'users_count' field. */
    Intake_Queues_Order["ReverseUsersCount"] = "reverse_users_count";
    /** Ascending sort by 'status' field. */
    Intake_Queues_Order["Status"] = "status";
    /** Ascending sort by 'tickets_count' field. */
    Intake_Queues_Order["TicketsCount"] = "tickets_count";
    /** Ascending sort by 'users_count' field. */
    Intake_Queues_Order["UsersCount"] = "users_count";
})(Intake_Queues_Order || (Intake_Queues_Order = {}));
/** Intake Queue statuses */
export var Intake_Queue_Status;
(function (Intake_Queue_Status) {
    /** Active */
    Intake_Queue_Status["Active"] = "active";
    /** Inactive */
    Intake_Queue_Status["Inactive"] = "inactive";
})(Intake_Queue_Status || (Intake_Queue_Status = {}));
export var Intake_Tags_Order;
(function (Intake_Tags_Order) {
    /** Ascending sort by 'created' field. */
    Intake_Tags_Order["Created"] = "created";
    /** Ascending sort by 'id' field. */
    Intake_Tags_Order["Id"] = "id";
    /** Ascending sort by 'name' field. */
    Intake_Tags_Order["Name"] = "name";
    /** Descending sort by 'created' field. */
    Intake_Tags_Order["ReverseCreated"] = "reverse_created";
    /** Descending sort by 'id' field. */
    Intake_Tags_Order["ReverseId"] = "reverse_id";
    /** Descending sort by 'name' field. */
    Intake_Tags_Order["ReverseName"] = "reverse_name";
    /** Descending sort by 'status' field. */
    Intake_Tags_Order["ReverseStatus"] = "reverse_status";
    /** Descending sort by 'type' field. */
    Intake_Tags_Order["ReverseType"] = "reverse_type";
    /** Ascending sort by 'status' field. */
    Intake_Tags_Order["Status"] = "status";
    /** Ascending sort by 'type' field. */
    Intake_Tags_Order["Type"] = "type";
})(Intake_Tags_Order || (Intake_Tags_Order = {}));
/** Intake Tag Attribute operators */
export var Intake_Tag_Attribute_Operator;
(function (Intake_Tag_Attribute_Operator) {
    /** Eql */
    Intake_Tag_Attribute_Operator["Eql"] = "eql";
    /** Exclude */
    Intake_Tag_Attribute_Operator["Exclude"] = "exclude";
    /** Gt */
    Intake_Tag_Attribute_Operator["Gt"] = "gt";
    /** Include */
    Intake_Tag_Attribute_Operator["Include"] = "include";
    /** Lt */
    Intake_Tag_Attribute_Operator["Lt"] = "lt";
})(Intake_Tag_Attribute_Operator || (Intake_Tag_Attribute_Operator = {}));
/** Intake Tag Attribute types */
export var Intake_Tag_Attribute_Type;
(function (Intake_Tag_Attribute_Type) {
    /** Benefit question categories */
    Intake_Tag_Attribute_Type["BenefitQuestionCategories"] = "benefit_question_categories";
    /** Care plan request types */
    Intake_Tag_Attribute_Type["CarePlanRequestTypes"] = "care_plan_request_types";
    /** Care pods */
    Intake_Tag_Attribute_Type["CarePods"] = "care_pods";
    /** Member high risk */
    Intake_Tag_Attribute_Type["MemberHighRisk"] = "member_high_risk";
    /** Member US state */
    Intake_Tag_Attribute_Type["MemberUsState"] = "member_us_state";
    /** Member vip */
    Intake_Tag_Attribute_Type["MemberVip"] = "member_vip";
    /** Organization flags */
    Intake_Tag_Attribute_Type["OrganizationFlags"] = "organization_flags";
    /** Organizations */
    Intake_Tag_Attribute_Type["Organizations"] = "organizations";
    /** Service flags */
    Intake_Tag_Attribute_Type["ServiceFlags"] = "service_flags";
    /** Subject */
    Intake_Tag_Attribute_Type["Subject"] = "subject";
    /** Time zone names */
    Intake_Tag_Attribute_Type["TimeZoneNames"] = "time_zone_names";
    /** Tpas */
    Intake_Tag_Attribute_Type["Tpas"] = "tpas";
})(Intake_Tag_Attribute_Type || (Intake_Tag_Attribute_Type = {}));
/** Intake Tag match operator */
export var Intake_Tag_Match_Operator;
(function (Intake_Tag_Match_Operator) {
    /** All */
    Intake_Tag_Match_Operator["All"] = "all";
    /** Any */
    Intake_Tag_Match_Operator["Any"] = "any";
})(Intake_Tag_Match_Operator || (Intake_Tag_Match_Operator = {}));
export var Intake_Tag_Snapshots_Order;
(function (Intake_Tag_Snapshots_Order) {
    /** Ascending sort by 'created' field. */
    Intake_Tag_Snapshots_Order["Created"] = "created";
    /** Ascending sort by 'id' field. */
    Intake_Tag_Snapshots_Order["Id"] = "id";
    /** Ascending sort by 'name' field. */
    Intake_Tag_Snapshots_Order["Name"] = "name";
    /** Descending sort by 'created' field. */
    Intake_Tag_Snapshots_Order["ReverseCreated"] = "reverse_created";
    /** Descending sort by 'id' field. */
    Intake_Tag_Snapshots_Order["ReverseId"] = "reverse_id";
    /** Descending sort by 'name' field. */
    Intake_Tag_Snapshots_Order["ReverseName"] = "reverse_name";
})(Intake_Tag_Snapshots_Order || (Intake_Tag_Snapshots_Order = {}));
/** Intake Tag statuses */
export var Intake_Tag_Status;
(function (Intake_Tag_Status) {
    /** Active */
    Intake_Tag_Status["Active"] = "active";
    /** Inactive */
    Intake_Tag_Status["Inactive"] = "inactive";
})(Intake_Tag_Status || (Intake_Tag_Status = {}));
/** Intake Tag types */
export var Intake_Tag_Type;
(function (Intake_Tag_Type) {
    /** Custom */
    Intake_Tag_Type["Custom"] = "custom";
    /** System */
    Intake_Tag_Type["System"] = "system";
})(Intake_Tag_Type || (Intake_Tag_Type = {}));
/** Possible interaction modality codes. */
export var Interaction_Modality_Code;
(function (Interaction_Modality_Code) {
    /** Accumulator change */
    Interaction_Modality_Code["AccumulatorChange"] = "accumulator_change";
    /** Accumulator issue */
    Interaction_Modality_Code["AccumulatorIssue"] = "accumulator_issue";
    /** Annual physical form */
    Interaction_Modality_Code["AnnualPhysicalForm"] = "annual_physical_form";
    /** Appointment */
    Interaction_Modality_Code["Appointment"] = "appointment";
    /** Benefit inquiry */
    Interaction_Modality_Code["BenefitInquiry"] = "benefit_inquiry";
    /** Care plan */
    Interaction_Modality_Code["CarePlan"] = "care_plan";
    /** Chat */
    Interaction_Modality_Code["Chat"] = "chat";
    /** Claim */
    Interaction_Modality_Code["Claim"] = "claim";
    /** Claim file processings */
    Interaction_Modality_Code["ClaimFileProcessings"] = "claim_file_processings";
    /** Common */
    Interaction_Modality_Code["Common"] = "common";
    /** Diabetes program */
    Interaction_Modality_Code["DiabetesProgram"] = "diabetes_program";
    /** Drug list update request */
    Interaction_Modality_Code["DrugListUpdateRequest"] = "drug_list_update_request";
    /** Eligibility inquiry */
    Interaction_Modality_Code["EligibilityInquiry"] = "eligibility_inquiry";
    /** Email */
    Interaction_Modality_Code["Email"] = "email";
    /** Fax */
    Interaction_Modality_Code["Fax"] = "fax";
    /** Fertility maximum */
    Interaction_Modality_Code["FertilityMaximum"] = "fertility_maximum";
    /** Financial data value */
    Interaction_Modality_Code["FinancialDataValue"] = "financial_data_value";
    /** Group number change */
    Interaction_Modality_Code["GroupNumberChange"] = "group_number_change";
    /** Group terming */
    Interaction_Modality_Code["GroupTerming"] = "group_terming";
    /** Impact report */
    Interaction_Modality_Code["ImpactReport"] = "impact_report";
    /** Internal */
    Interaction_Modality_Code["Internal"] = "internal";
    /** Mail */
    Interaction_Modality_Code["Mail"] = "mail";
    /** Mail order transfer */
    Interaction_Modality_Code["MailOrderTransfer"] = "mail_order_transfer";
    /** Medical navigation */
    Interaction_Modality_Code["MedicalNavigation"] = "medical_navigation";
    /** New implementation */
    Interaction_Modality_Code["NewImplementation"] = "new_implementation";
    /** Other */
    Interaction_Modality_Code["Other"] = "other";
    /** Override */
    Interaction_Modality_Code["Override"] = "override";
    /** Phonecall */
    Interaction_Modality_Code["Phonecall"] = "phonecall";
    /** Plan change handling */
    Interaction_Modality_Code["PlanChangeHandling"] = "plan_change_handling";
    /** Prior authorization */
    Interaction_Modality_Code["PriorAuthorization"] = "prior_authorization";
    /** Prior authorization status */
    Interaction_Modality_Code["PriorAuthorizationStatus"] = "prior_authorization_status";
    /** Proactive drug */
    Interaction_Modality_Code["ProactiveDrug"] = "proactive_drug";
    /** Scheduled follow up */
    Interaction_Modality_Code["ScheduledFollowUp"] = "scheduled_follow_up";
    /** Seldon beattie form */
    Interaction_Modality_Code["SeldonBeattieForm"] = "seldon_beattie_form";
    /** Text message */
    Interaction_Modality_Code["TextMessage"] = "text_message";
    /** Vendor setup */
    Interaction_Modality_Code["VendorSetup"] = "vendor_setup";
    /** Weight management program */
    Interaction_Modality_Code["WeightManagementProgram"] = "weight_management_program";
})(Interaction_Modality_Code || (Interaction_Modality_Code = {}));
export var Interaction_Modality_Type_Order;
(function (Interaction_Modality_Type_Order) {
    /** Ascending sort by 'id' field. */
    Interaction_Modality_Type_Order["Id"] = "id";
    /** Ascending sort by 'name' field. */
    Interaction_Modality_Type_Order["Name"] = "name";
    /** Ascending sort by 'priority' field. */
    Interaction_Modality_Type_Order["Priority"] = "priority";
    /** Descending sort by 'id' field. */
    Interaction_Modality_Type_Order["ReverseId"] = "reverse_id";
    /** Descending sort by 'name' field. */
    Interaction_Modality_Type_Order["ReverseName"] = "reverse_name";
    /** Descending sort by 'priority' field. */
    Interaction_Modality_Type_Order["ReversePriority"] = "reverse_priority";
})(Interaction_Modality_Type_Order || (Interaction_Modality_Type_Order = {}));
/** Possible interaction topic names. */
export var Interaction_Topic_Name;
(function (Interaction_Topic_Name) {
    /** Behavioral health */
    Interaction_Topic_Name["BehavioralHealth"] = "behavioral_health";
    /** Benefits education */
    Interaction_Topic_Name["BenefitsEducation"] = "benefits_education";
    /** Bill advocacy */
    Interaction_Topic_Name["BillAdvocacy"] = "bill_advocacy";
    /** Er redirect */
    Interaction_Topic_Name["ErRedirect"] = "er_redirect";
    /** Imaging */
    Interaction_Topic_Name["Imaging"] = "imaging";
    /** Medical education */
    Interaction_Topic_Name["MedicalEducation"] = "medical_education";
    /** Medical navigation */
    Interaction_Topic_Name["MedicalNavigation"] = "medical_navigation";
    /** Medication coupon price */
    Interaction_Topic_Name["MedicationCouponPrice"] = "medication_coupon_price";
    /** Msk navigation */
    Interaction_Topic_Name["MskNavigation"] = "msk_navigation";
    /** Pcp visit */
    Interaction_Topic_Name["PcpVisit"] = "pcp_visit";
    /** Pop health education */
    Interaction_Topic_Name["PopHealthEducation"] = "pop_health_education";
    /** Radiology */
    Interaction_Topic_Name["Radiology"] = "radiology";
    /** Specialist visit */
    Interaction_Topic_Name["SpecialistVisit"] = "specialist_visit";
    /** Unknown */
    Interaction_Topic_Name["Unknown"] = "unknown";
})(Interaction_Topic_Name || (Interaction_Topic_Name = {}));
export var Interaction_Type_Order;
(function (Interaction_Type_Order) {
    /** Ascending sort by 'created_at' field. */
    Interaction_Type_Order["CreatedAt"] = "created_at";
    /** Ascending sort by 'id' field. */
    Interaction_Type_Order["Id"] = "id";
    /** Ascending sort by 'resolved_at' field. */
    Interaction_Type_Order["ResolvedAt"] = "resolved_at";
    /** Descending sort by 'created_at' field. */
    Interaction_Type_Order["ReverseCreatedAt"] = "reverse_created_at";
    /** Descending sort by 'id' field. */
    Interaction_Type_Order["ReverseId"] = "reverse_id";
    /** Descending sort by 'resolved_at' field. */
    Interaction_Type_Order["ReverseResolvedAt"] = "reverse_resolved_at";
    /** Descending sort by 'ticket_id' field. */
    Interaction_Type_Order["ReverseTicketId"] = "reverse_ticket_id";
    /** Descending sort by 'updated_at' field. */
    Interaction_Type_Order["ReverseUpdatedAt"] = "reverse_updated_at";
    /** Ascending sort by 'ticket_id' field. */
    Interaction_Type_Order["TicketId"] = "ticket_id";
    /** Ascending sort by 'updated_at' field. */
    Interaction_Type_Order["UpdatedAt"] = "updated_at";
})(Interaction_Type_Order || (Interaction_Type_Order = {}));
export var Invites_Order;
(function (Invites_Order) {
    /** Ascending sort by 'id' field. */
    Invites_Order["Id"] = "id";
    /** Descending sort by 'id' field. */
    Invites_Order["ReverseId"] = "reverse_id";
    /** Descending sort by 'sent_at' field. */
    Invites_Order["ReverseSentAt"] = "reverse_sent_at";
    /** Ascending sort by 'sent_at' field. */
    Invites_Order["SentAt"] = "sent_at";
})(Invites_Order || (Invites_Order = {}));
/** Possible insurance plan assignment statuses. */
export var InsurancePlanAssignmentStatusType;
(function (InsurancePlanAssignmentStatusType) {
    /** Current */
    InsurancePlanAssignmentStatusType["Current"] = "current";
    /** Historical */
    InsurancePlanAssignmentStatusType["Historical"] = "historical";
})(InsurancePlanAssignmentStatusType || (InsurancePlanAssignmentStatusType = {}));
/** Possible insurance plan statuses. */
export var InsurancePlanStatusType;
(function (InsurancePlanStatusType) {
    /** Active */
    InsurancePlanStatusType["Active"] = "active";
    /** Future */
    InsurancePlanStatusType["Future"] = "future";
    /** Inactive */
    InsurancePlanStatusType["Inactive"] = "inactive";
})(InsurancePlanStatusType || (InsurancePlanStatusType = {}));
export var InsuranceType;
(function (InsuranceType) {
    /** EPO */
    InsuranceType["Epo"] = "epo";
    /** HMO */
    InsuranceType["Hmo"] = "hmo";
    /** Other */
    InsuranceType["Other"] = "other";
    /** PPO */
    InsuranceType["Ppo"] = "ppo";
    /** PPO-HRA */
    InsuranceType["PpoHra"] = "ppo_hra";
    /** PPO-HSA */
    InsuranceType["PpoHsa"] = "ppo_hsa";
    /** RBP */
    InsuranceType["Rbp"] = "rbp";
})(InsuranceType || (InsuranceType = {}));
export var InteractionDirectionKind;
(function (InteractionDirectionKind) {
    /** Inbound */
    InteractionDirectionKind["Inbound"] = "inbound";
    /** Outbound */
    InteractionDirectionKind["Outbound"] = "outbound";
})(InteractionDirectionKind || (InteractionDirectionKind = {}));
export var InteractionInteractedWith;
(function (InteractionInteractedWith) {
    /** Carrier */
    InteractionInteractedWith["Carrier"] = "carrier";
    /** Client */
    InteractionInteractedWith["Client"] = "client";
    /** Internal */
    InteractionInteractedWith["Internal"] = "internal";
    /** Manufacturer */
    InteractionInteractedWith["Manufacturer"] = "manufacturer";
    /** Member */
    InteractionInteractedWith["Member"] = "member";
    /** Other */
    InteractionInteractedWith["Other"] = "other";
    /** Pharmacy */
    InteractionInteractedWith["Pharmacy"] = "pharmacy";
    /** Provider */
    InteractionInteractedWith["Provider"] = "provider";
    /** TPA or partner */
    InteractionInteractedWith["TpaOrPartner"] = "tpa_or_partner";
})(InteractionInteractedWith || (InteractionInteractedWith = {}));
/** Possible interaction origins */
export var InteractionSourceType;
(function (InteractionSourceType) {
    /** Accumulator change */
    InteractionSourceType["AccumulatorChange"] = "AccumulatorChange";
    /** Accumulator issue */
    InteractionSourceType["AccumulatorIssue"] = "AccumulatorIssue";
    /** Wellness form */
    InteractionSourceType["AnnualPhysicalForm"] = "AnnualPhysicalForm";
    /** Scheduler */
    InteractionSourceType["Appointment"] = "Appointment";
    /** Benefit Inquiry */
    InteractionSourceType["BenefitInquiry"] = "BenefitInquiry";
    /** Chat */
    InteractionSourceType["Chat"] = "Chat";
    /** Billing Advocate */
    InteractionSourceType["Claim"] = "Claim";
    /** Claim File Processing */
    InteractionSourceType["ClaimFileProcessing"] = "ClaimFileProcessing";
    /** Diabetes Program */
    InteractionSourceType["DiabetesProgram"] = "DiabetesProgram";
    /** Drug List Update Request */
    InteractionSourceType["DrugListUpdateRequest"] = "DrugListUpdateRequest";
    /** Eligibility Inquiry */
    InteractionSourceType["EligibilityInquiry"] = "EligibilityInquiry";
    /** Fertility Maximum */
    InteractionSourceType["FertilityMaximum"] = "FertilityMaximum";
    /** Financial data value */
    InteractionSourceType["FinancialDataValue"] = "FinancialDataValue";
    /** Group Number Change */
    InteractionSourceType["GroupNumberChange"] = "GroupNumberChange";
    /** Group Terming */
    InteractionSourceType["GroupTerming"] = "GroupTerming";
    /** Impact Reports */
    InteractionSourceType["ImpactReport"] = "ImpactReport";
    /** Mail Order transfer */
    InteractionSourceType["MailOrderTransfer"] = "MailOrderTransfer";
    /** Medical Navigation */
    InteractionSourceType["MedicalNavigation"] = "MedicalNavigation";
    /** New Implementation */
    InteractionSourceType["NewImplementation"] = "NewImplementation";
    /** Plan Change Handling */
    InteractionSourceType["PlanChangeHandling"] = "PlanChangeHandling";
    /** Prior authorization status */
    InteractionSourceType["PriorAuthorizationStatus"] = "PriorAuthorizationStatus";
    /** Proactive Drug */
    InteractionSourceType["ProactiveDrug"] = "ProactiveDrug";
    /** Find care */
    InteractionSourceType["Roadmap"] = "Roadmap";
    /** RX Common Data */
    InteractionSourceType["RxCommon"] = "RxCommon";
    /** RX Override Data */
    InteractionSourceType["RxOverride"] = "RxOverride";
    /** RX Prior Authorization Data */
    InteractionSourceType["RxPriorAuthorization"] = "RxPriorAuthorization";
    /** SeldonBeattie Wellness form */
    InteractionSourceType["SeldonBeattieForm"] = "SeldonBeattieForm";
    /** Vendor Setup */
    InteractionSourceType["VendorSetup"] = "VendorSetup";
    /** Weight Management Program */
    InteractionSourceType["WeightManagementProgram"] = "WeightManagementProgram";
})(InteractionSourceType || (InteractionSourceType = {}));
/** Possible interaction subjects */
export var InteractionSubjectType;
(function (InteractionSubjectType) {
    /** Appointment */
    InteractionSubjectType["Appointment"] = "appointment";
    /** Billing Advocacy */
    InteractionSubjectType["Claim"] = "claim";
    /** Triage */
    InteractionSubjectType["Triage"] = "triage";
})(InteractionSubjectType || (InteractionSubjectType = {}));
export var Issue;
(function (Issue) {
    /** COB question */
    Issue["CobQuestion"] = "cob_question";
    /** Duplicate profiles */
    Issue["DuplicateProfiles"] = "duplicate_profiles";
    /** Member termed */
    Issue["MemberTermed"] = "member_termed";
    /** New member to be added */
    Issue["NewMemberToBeAdded"] = "new_member_to_be_added";
    /** Update address */
    Issue["UpdateAddress"] = "update_address";
    /** Update DOB */
    Issue["UpdateDob"] = "update_dob";
    /** Update group number */
    Issue["UpdateGroupNumber"] = "update_group_number";
    /** Update person code */
    Issue["UpdatePersonCode"] = "update_person_code";
})(Issue || (Issue = {}));
export var Journal_Note_Order;
(function (Journal_Note_Order) {
    /** Ascending sort by 'id' field. */
    Journal_Note_Order["Id"] = "id";
    /** Descending sort by 'id' field. */
    Journal_Note_Order["ReverseId"] = "reverse_id";
})(Journal_Note_Order || (Journal_Note_Order = {}));
/** Journal note types */
export var Journal_Note_Type;
(function (Journal_Note_Type) {
    Journal_Note_Type["MedicalNotes"] = "medical_notes";
    Journal_Note_Type["MemberNotes"] = "member_notes";
    Journal_Note_Type["PbmNotes"] = "pbm_notes";
    Journal_Note_Type["TicketNotes"] = "ticket_notes";
})(Journal_Note_Type || (Journal_Note_Type = {}));
/** Journal source types */
export var Journal_Source_Type;
(function (Journal_Source_Type) {
    /** Employee source type */
    Journal_Source_Type["Employee"] = "Employee";
    /** Ticket source type */
    Journal_Source_Type["Ticket"] = "Ticket";
})(Journal_Source_Type || (Journal_Source_Type = {}));
export var Locale;
(function (Locale) {
    /** English locale. */
    Locale["En"] = "EN";
    /** Spanish locale. */
    Locale["Es"] = "ES";
})(Locale || (Locale = {}));
/** Possible location kinds. */
export var Location_Kind_Type;
(function (Location_Kind_Type) {
    /** home_address */
    Location_Kind_Type["HomeAddress"] = "home_address";
    /** other_address */
    Location_Kind_Type["OtherAddress"] = "other_address";
    /** work_address */
    Location_Kind_Type["WorkAddress"] = "work_address";
})(Location_Kind_Type || (Location_Kind_Type = {}));
/** Possible statuses for mail order transfer. */
export var Mail_Order_Transfer_Status_Type;
(function (Mail_Order_Transfer_Status_Type) {
    /** in_progress */
    Mail_Order_Transfer_Status_Type["InProgress"] = "in_progress";
    /** pending */
    Mail_Order_Transfer_Status_Type["Pending"] = "pending";
    /** resolved */
    Mail_Order_Transfer_Status_Type["Resolved"] = "resolved";
    /** unresolved */
    Mail_Order_Transfer_Status_Type["Unresolved"] = "unresolved";
})(Mail_Order_Transfer_Status_Type || (Mail_Order_Transfer_Status_Type = {}));
export var Medical_Type;
(function (Medical_Type) {
    Medical_Type["Device"] = "DEVICE";
    Medical_Type["Drug"] = "DRUG";
    Medical_Type["Unspecificed"] = "UNSPECIFICED";
})(Medical_Type || (Medical_Type = {}));
export var Medications_Order;
(function (Medications_Order) {
    /** Ascending sort by 'id' field. */
    Medications_Order["Id"] = "id";
    /** Ascending sort by 'name' field. */
    Medications_Order["Name"] = "name";
    /** Descending sort by 'id' field. */
    Medications_Order["ReverseId"] = "reverse_id";
    /** Descending sort by 'name' field. */
    Medications_Order["ReverseName"] = "reverse_name";
    /** Descending sort by 'symptom_name' field. */
    Medications_Order["ReverseSymptomName"] = "reverse_symptom_name";
    /** Ascending sort by 'symptom_name' field. */
    Medications_Order["SymptomName"] = "symptom_name";
})(Medications_Order || (Medications_Order = {}));
export var Medication_Attribute_Type;
(function (Medication_Attribute_Type) {
    Medication_Attribute_Type["Brand"] = "brand";
    Medication_Attribute_Type["Generic"] = "generic";
    Medication_Attribute_Type["Maintenance"] = "maintenance";
    Medication_Attribute_Type["NonMaintenance"] = "non_maintenance";
    Medication_Attribute_Type["Unspecified"] = "unspecified";
})(Medication_Attribute_Type || (Medication_Attribute_Type = {}));
export var Medication_Category;
(function (Medication_Category) {
    Medication_Category["Active"] = "active";
    Medication_Category["Past"] = "past";
    Medication_Category["Pending"] = "pending";
})(Medication_Category || (Medication_Category = {}));
export var Medication_Info_Item_Type;
(function (Medication_Info_Item_Type) {
    Medication_Info_Item_Type["Paragraph"] = "paragraph";
    Medication_Info_Item_Type["Title"] = "title";
})(Medication_Info_Item_Type || (Medication_Info_Item_Type = {}));
export var Medication_Refill_Status_Type;
(function (Medication_Refill_Status_Type) {
    Medication_Refill_Status_Type["NoRefills"] = "no_refills";
    Medication_Refill_Status_Type["ReadyToRefill"] = "ready_to_refill";
    Medication_Refill_Status_Type["TooEarly"] = "too_early";
    Medication_Refill_Status_Type["Unspecified"] = "unspecified";
})(Medication_Refill_Status_Type || (Medication_Refill_Status_Type = {}));
export var Member_Event;
(function (Member_Event) {
    Member_Event["AppDownloadLinkSms"] = "app_download_link_sms";
    Member_Event["RequestHipaaAuth"] = "request_hipaa_auth";
})(Member_Event || (Member_Event = {}));
/** Member need in Nav Member Services Requests */
export var Member_Need;
(function (Member_Need) {
    Member_Need["ClaimStatus"] = "claim_status";
    Member_Need["Cob"] = "cob";
    Member_Need["Eob"] = "eob";
    Member_Need["IdCard"] = "id_card";
    Member_Need["Pa"] = "pa";
})(Member_Need || (Member_Need = {}));
/** Possible Care Gap Orderings. */
export var MedicalHistoryCareGapOrder;
(function (MedicalHistoryCareGapOrder) {
    MedicalHistoryCareGapOrder["EnabledFirst"] = "enabled_first";
    MedicalHistoryCareGapOrder["EnabledLast"] = "enabled_last";
})(MedicalHistoryCareGapOrder || (MedicalHistoryCareGapOrder = {}));
export var MedicalTypeEnum;
(function (MedicalTypeEnum) {
    /** DEVICE */
    MedicalTypeEnum["Device"] = "DEVICE";
    /** DRUG */
    MedicalTypeEnum["Drug"] = "DRUG";
    /** UNSPECIFIED_MEDICAL_TYPE */
    MedicalTypeEnum["UnspecifiedMedicalType"] = "UNSPECIFIED_MEDICAL_TYPE";
})(MedicalTypeEnum || (MedicalTypeEnum = {}));
/** Indicates whether it is a drug or a device. */
export var MedicationMedicalType;
(function (MedicationMedicalType) {
    MedicationMedicalType["Device"] = "DEVICE";
    MedicationMedicalType["Drug"] = "DRUG";
    MedicationMedicalType["UnspecifiedMedicalType"] = "UNSPECIFIED_MEDICAL_TYPE";
})(MedicationMedicalType || (MedicationMedicalType = {}));
/** Possible member contact methods */
export var MemberContactMethodsType;
(function (MemberContactMethodsType) {
    /** Any */
    MemberContactMethodsType["Any"] = "any";
    /** Chat */
    MemberContactMethodsType["Chat"] = "chat";
    /** Email */
    MemberContactMethodsType["Email"] = "email";
    /** Phone */
    MemberContactMethodsType["Phone"] = "phone";
    /** Text message */
    MemberContactMethodsType["TextMessage"] = "text_message";
})(MemberContactMethodsType || (MemberContactMethodsType = {}));
/** Possible member genders */
export var MemberGenderType;
(function (MemberGenderType) {
    /** Female */
    MemberGenderType["F"] = "f";
    /** Male */
    MemberGenderType["M"] = "m";
    /** Other */
    MemberGenderType["O"] = "o";
    /** Undefined */
    MemberGenderType["U"] = "u";
})(MemberGenderType || (MemberGenderType = {}));
export var MemberOrder;
(function (MemberOrder) {
    /** Ascending sort by 'id' field. */
    MemberOrder["Id"] = "id";
    /** Ascending sort by 'last_interaction' field. */
    MemberOrder["LastInteraction"] = "last_interaction";
    /** Ascending sort by 'name' field. */
    MemberOrder["Name"] = "name";
    /** Ascending sort by 'pos_count_emroom' field. */
    MemberOrder["PosCountEmroom"] = "pos_count_emroom";
    /** Ascending sort by 'pos_count_inpat' field. */
    MemberOrder["PosCountInpat"] = "pos_count_inpat";
    /** Descending sort by 'id' field. */
    MemberOrder["ReverseId"] = "reverse_id";
    /** Descending sort by 'last_interaction' field. */
    MemberOrder["ReverseLastInteraction"] = "reverse_last_interaction";
    /** Descending sort by 'name' field. */
    MemberOrder["ReverseName"] = "reverse_name";
    /** Descending sort by 'pos_count_emroom' field. */
    MemberOrder["ReversePosCountEmroom"] = "reverse_pos_count_emroom";
    /** Descending sort by 'pos_count_inpat' field. */
    MemberOrder["ReversePosCountInpat"] = "reverse_pos_count_inpat";
    /** Descending sort by 'risk_category' field. */
    MemberOrder["ReverseRiskCategory"] = "reverse_risk_category";
    /** Descending sort by 'risk_score' field. */
    MemberOrder["ReverseRiskScore"] = "reverse_risk_score";
    /** Descending sort by 'sign_up_date' field. */
    MemberOrder["ReverseSignUpDate"] = "reverse_sign_up_date";
    /** Descending sort by 'tot_grp' field. */
    MemberOrder["ReverseTotGrp"] = "reverse_tot_grp";
    /** Descending sort by 'tot_payable_family_exp' field. */
    MemberOrder["ReverseTotPayableFamilyExp"] = "reverse_tot_payable_family_exp";
    /** Descending sort by 'tot_payable_ind_exp' field. */
    MemberOrder["ReverseTotPayableIndExp"] = "reverse_tot_payable_ind_exp";
    /** Ascending sort by 'risk_category' field. */
    MemberOrder["RiskCategory"] = "risk_category";
    /** Ascending sort by 'risk_score' field. */
    MemberOrder["RiskScore"] = "risk_score";
    /** Ascending sort by 'sign_up_date' field. */
    MemberOrder["SignUpDate"] = "sign_up_date";
    /** Ascending sort by 'tot_grp' field. */
    MemberOrder["TotGrp"] = "tot_grp";
    /** Ascending sort by 'tot_payable_family_exp' field. */
    MemberOrder["TotPayableFamilyExp"] = "tot_payable_family_exp";
    /** Ascending sort by 'tot_payable_ind_exp' field. */
    MemberOrder["TotPayableIndExp"] = "tot_payable_ind_exp";
})(MemberOrder || (MemberOrder = {}));
/** Possible member register statuses */
export var MemberRegisterStatusType;
(function (MemberRegisterStatusType) {
    MemberRegisterStatusType["Deactivated"] = "deactivated";
    MemberRegisterStatusType["Registered"] = "registered";
    MemberRegisterStatusType["Unregistered"] = "unregistered";
})(MemberRegisterStatusType || (MemberRegisterStatusType = {}));
export var MemberRelationToEnsuredKind;
(function (MemberRelationToEnsuredKind) {
    MemberRelationToEnsuredKind["Dependent"] = "dependent";
    MemberRelationToEnsuredKind["Main"] = "main";
    MemberRelationToEnsuredKind["Pending"] = "pending";
    MemberRelationToEnsuredKind["Spouse"] = "spouse";
})(MemberRelationToEnsuredKind || (MemberRelationToEnsuredKind = {}));
export var Navigator_Note_Samples_Type_Order;
(function (Navigator_Note_Samples_Type_Order) {
    /** Ascending sort by 'id' field. */
    Navigator_Note_Samples_Type_Order["Id"] = "id";
    /** Ascending sort by 'note' field. */
    Navigator_Note_Samples_Type_Order["Note"] = "note";
    /** Descending sort by 'id' field. */
    Navigator_Note_Samples_Type_Order["ReverseId"] = "reverse_id";
    /** Descending sort by 'note' field. */
    Navigator_Note_Samples_Type_Order["ReverseNote"] = "reverse_note";
})(Navigator_Note_Samples_Type_Order || (Navigator_Note_Samples_Type_Order = {}));
/** Possible note source types */
export var Note_Source_Type;
(function (Note_Source_Type) {
    /** Insuranceplan */
    Note_Source_Type["InsurancePlan"] = "InsurancePlan";
    /** Planbenefitcategory */
    Note_Source_Type["PlanBenefitCategory"] = "PlanBenefitCategory";
})(Note_Source_Type || (Note_Source_Type = {}));
export var Note_Template_Type_Order;
(function (Note_Template_Type_Order) {
    /** Descending sort by 'title' field. */
    Note_Template_Type_Order["ReverseTitle"] = "reverse_title";
    /** Ascending sort by 'title' field. */
    Note_Template_Type_Order["Title"] = "title";
})(Note_Template_Type_Order || (Note_Template_Type_Order = {}));
/** Possible note types */
export var Note_Type;
(function (Note_Type) {
    /** External */
    Note_Type["External"] = "external";
    /** Internal */
    Note_Type["Internal"] = "internal";
})(Note_Type || (Note_Type = {}));
export var NotificationSourceType;
(function (NotificationSourceType) {
    NotificationSourceType["Chat"] = "Chat";
    NotificationSourceType["Employee"] = "Employee";
    NotificationSourceType["InsurancePlan"] = "InsurancePlan";
    NotificationSourceType["Ticket"] = "Ticket";
})(NotificationSourceType || (NotificationSourceType = {}));
export var NotificationType;
(function (NotificationType) {
    NotificationType["AppointmentCanceled"] = "appointment_canceled";
    NotificationType["BenefitCategoriesCreated"] = "benefit_categories_created";
    NotificationType["BenefitGroupsBulkCreated"] = "benefit_groups_bulk_created";
    NotificationType["BenefitsBulkCreated"] = "benefits_bulk_created";
    NotificationType["BulkAssignTicketsToPerformer"] = "bulk_assign_tickets_to_performer";
    NotificationType["BulkAssignTicketsToRecipient"] = "bulk_assign_tickets_to_recipient";
    NotificationType["BulkAssignedTicketsToQueue"] = "bulk_assigned_tickets_to_queue";
    NotificationType["BulkChangeStatusTickets"] = "bulk_change_status_tickets";
    NotificationType["BulkCreateTickets"] = "bulk_create_tickets";
    NotificationType["ChatMemberReply"] = "chat_member_reply";
    NotificationType["DueTask"] = "due_task";
    NotificationType["InsurancePlanAddAvailability"] = "insurance_plan_add_availability";
    NotificationType["InsurancePlanBulkUpload"] = "insurance_plan_bulk_upload";
    NotificationType["InsurancePlanCloned"] = "insurance_plan_cloned";
    NotificationType["InteractionsBulkCreate"] = "interactions_bulk_create";
    NotificationType["TaskAssigned"] = "task_assigned";
    NotificationType["TicketAlarm"] = "ticket_alarm";
    NotificationType["TicketAssigned"] = "ticket_assigned";
    NotificationType["TicketDeliverablesBulkCreate"] = "ticket_deliverables_bulk_create";
    NotificationType["UploadPlanCategories"] = "upload_plan_categories";
    NotificationType["UserTagged"] = "user_tagged";
})(NotificationType || (NotificationType = {}));
export var Organization_Groups_Order;
(function (Organization_Groups_Order) {
    /** Ascending sort by 'id' field. */
    Organization_Groups_Order["Id"] = "id";
    /** Ascending sort by 'name' field. */
    Organization_Groups_Order["Name"] = "name";
    /** Descending sort by 'id' field. */
    Organization_Groups_Order["ReverseId"] = "reverse_id";
    /** Descending sort by 'name' field. */
    Organization_Groups_Order["ReverseName"] = "reverse_name";
})(Organization_Groups_Order || (Organization_Groups_Order = {}));
export var Organization_Image_Version;
(function (Organization_Image_Version) {
    /** 400x224 pixels (double size). */
    Organization_Image_Version["Large"] = "large";
    /** 200x112 pixels. */
    Organization_Image_Version["Original"] = "original";
    /** 100x56 pixels (half size). */
    Organization_Image_Version["Small"] = "small";
})(Organization_Image_Version || (Organization_Image_Version = {}));
/** Type of an organization launch history event. */
export var Organization_Launch_History_Event_Type;
(function (Organization_Launch_History_Event_Type) {
    /** Organization was deactivated. */
    Organization_Launch_History_Event_Type["Deactivation"] = "deactivation";
    /** Organization was launched or relaunched. */
    Organization_Launch_History_Event_Type["Launch"] = "launch";
})(Organization_Launch_History_Event_Type || (Organization_Launch_History_Event_Type = {}));
export var Organization_Order;
(function (Organization_Order) {
    /** Ascending sort by 'id' field. */
    Organization_Order["Id"] = "id";
    /** Ascending sort by 'name' field. */
    Organization_Order["Name"] = "name";
    /** Descending sort by 'id' field. */
    Organization_Order["ReverseId"] = "reverse_id";
    /** Descending sort by 'name' field. */
    Organization_Order["ReverseName"] = "reverse_name";
})(Organization_Order || (Organization_Order = {}));
/** Possible spend data sources (deductible, payments) for organization. */
export var Organization_Spend_Data_Source;
(function (Organization_Spend_Data_Source) {
    /** Accumulation file */
    Organization_Spend_Data_Source["AccumulationFile"] = "accumulation_file";
    /** Ribbon API */
    Organization_Spend_Data_Source["RibbonApi"] = "ribbon_api";
})(Organization_Spend_Data_Source || (Organization_Spend_Data_Source = {}));
export var Organization_Splash_Screen_Version;
(function (Organization_Splash_Screen_Version) {
    /** 900x900 pixels (double size). */
    Organization_Splash_Screen_Version["Large"] = "large";
    /** 450x450 pixels. */
    Organization_Splash_Screen_Version["Original"] = "original";
    /** 225x225 pixels (half size). */
    Organization_Splash_Screen_Version["Small"] = "small";
})(Organization_Splash_Screen_Version || (Organization_Splash_Screen_Version = {}));
/** Supported operating systems */
export var Os;
(function (Os) {
    Os["Android"] = "ANDROID";
    Os["Ios"] = "IOS";
})(Os || (Os = {}));
export var OpenEnrollmentCostShareDeductible;
(function (OpenEnrollmentCostShareDeductible) {
    OpenEnrollmentCostShareDeductible["CostShareDeductibleAfter"] = "COST_SHARE_DEDUCTIBLE_AFTER";
    OpenEnrollmentCostShareDeductible["CostShareDeductibleApplies"] = "COST_SHARE_DEDUCTIBLE_APPLIES";
    OpenEnrollmentCostShareDeductible["CostShareDeductibleNone"] = "COST_SHARE_DEDUCTIBLE_NONE";
    OpenEnrollmentCostShareDeductible["CostShareDeductibleUnspecified"] = "COST_SHARE_DEDUCTIBLE_UNSPECIFIED";
})(OpenEnrollmentCostShareDeductible || (OpenEnrollmentCostShareDeductible = {}));
export var OpenEnrollmentCostShareKind;
(function (OpenEnrollmentCostShareKind) {
    OpenEnrollmentCostShareKind["CostShareKindCoinsurance"] = "COST_SHARE_KIND_COINSURANCE";
    OpenEnrollmentCostShareKind["CostShareKindCopay"] = "COST_SHARE_KIND_COPAY";
    OpenEnrollmentCostShareKind["CostShareKindFormula"] = "COST_SHARE_KIND_FORMULA";
    OpenEnrollmentCostShareKind["CostShareKindNotCovered"] = "COST_SHARE_KIND_NOT_COVERED";
    OpenEnrollmentCostShareKind["CostShareKindRefTier"] = "COST_SHARE_KIND_REF_TIER";
    OpenEnrollmentCostShareKind["CostShareKindUnspecified"] = "COST_SHARE_KIND_UNSPECIFIED";
})(OpenEnrollmentCostShareKind || (OpenEnrollmentCostShareKind = {}));
export var OpenEnrollmentCostShareNetwork;
(function (OpenEnrollmentCostShareNetwork) {
    OpenEnrollmentCostShareNetwork["CostShareNetworkInNetwork"] = "COST_SHARE_NETWORK_IN_NETWORK";
    OpenEnrollmentCostShareNetwork["CostShareNetworkInSpecialty"] = "COST_SHARE_NETWORK_IN_SPECIALTY";
    OpenEnrollmentCostShareNetwork["CostShareNetworkOther"] = "COST_SHARE_NETWORK_OTHER";
    OpenEnrollmentCostShareNetwork["CostShareNetworkOutOfNetwork"] = "COST_SHARE_NETWORK_OUT_OF_NETWORK";
    OpenEnrollmentCostShareNetwork["CostShareNetworkOutSpecialty"] = "COST_SHARE_NETWORK_OUT_SPECIALTY";
    OpenEnrollmentCostShareNetwork["CostShareNetworkUnspecified"] = "COST_SHARE_NETWORK_UNSPECIFIED";
})(OpenEnrollmentCostShareNetwork || (OpenEnrollmentCostShareNetwork = {}));
export var OpenEnrollmentCoverageLevel;
(function (OpenEnrollmentCoverageLevel) {
    OpenEnrollmentCoverageLevel["CoverageLevelEmployeeChildren"] = "COVERAGE_LEVEL_EMPLOYEE_CHILDREN";
    OpenEnrollmentCoverageLevel["CoverageLevelEmployeeSpouse"] = "COVERAGE_LEVEL_EMPLOYEE_SPOUSE";
    OpenEnrollmentCoverageLevel["CoverageLevelFamily"] = "COVERAGE_LEVEL_FAMILY";
    OpenEnrollmentCoverageLevel["CoverageLevelIndividual"] = "COVERAGE_LEVEL_INDIVIDUAL";
    OpenEnrollmentCoverageLevel["CoverageLevelIndividualWithinFamily"] = "COVERAGE_LEVEL_INDIVIDUAL_WITHIN_FAMILY";
    OpenEnrollmentCoverageLevel["CoverageLevelUnspecified"] = "COVERAGE_LEVEL_UNSPECIFIED";
})(OpenEnrollmentCoverageLevel || (OpenEnrollmentCoverageLevel = {}));
export var OpenEnrollmentRxAccumulation;
(function (OpenEnrollmentRxAccumulation) {
    OpenEnrollmentRxAccumulation["RxAccumulationIncluded"] = "RX_ACCUMULATION_INCLUDED";
    OpenEnrollmentRxAccumulation["RxAccumulationSeparate"] = "RX_ACCUMULATION_SEPARATE";
    OpenEnrollmentRxAccumulation["RxAccumulationUnspecified"] = "RX_ACCUMULATION_UNSPECIFIED";
})(OpenEnrollmentRxAccumulation || (OpenEnrollmentRxAccumulation = {}));
export var OpenEnrollmentSupplyChannel;
(function (OpenEnrollmentSupplyChannel) {
    OpenEnrollmentSupplyChannel["SupplyChannelFacilitySpecific"] = "SUPPLY_CHANNEL_FACILITY_SPECIFIC";
    OpenEnrollmentSupplyChannel["SupplyChannelHomeDelivery"] = "SUPPLY_CHANNEL_HOME_DELIVERY";
    OpenEnrollmentSupplyChannel["SupplyChannelMail"] = "SUPPLY_CHANNEL_MAIL";
    OpenEnrollmentSupplyChannel["SupplyChannelOther"] = "SUPPLY_CHANNEL_OTHER";
    OpenEnrollmentSupplyChannel["SupplyChannelRetail"] = "SUPPLY_CHANNEL_RETAIL";
    OpenEnrollmentSupplyChannel["SupplyChannelRetailMail"] = "SUPPLY_CHANNEL_RETAIL_MAIL";
    OpenEnrollmentSupplyChannel["SupplyChannelSpecialty"] = "SUPPLY_CHANNEL_SPECIALTY";
    OpenEnrollmentSupplyChannel["SupplyChannelUnspecified"] = "SUPPLY_CHANNEL_UNSPECIFIED";
})(OpenEnrollmentSupplyChannel || (OpenEnrollmentSupplyChannel = {}));
export var OrganisationFeatureCode;
(function (OrganisationFeatureCode) {
    OrganisationFeatureCode["Appointments"] = "appointments";
    OrganisationFeatureCode["BillAdvocacy"] = "bill_advocacy";
    OrganisationFeatureCode["CareLocatorNetFilter"] = "care_locator_net_filter";
    OrganisationFeatureCode["CarePlans"] = "care_plans";
    OrganisationFeatureCode["ClearCost"] = "clear_cost";
    OrganisationFeatureCode["Clinical"] = "clinical";
    OrganisationFeatureCode["Core"] = "core";
    OrganisationFeatureCode["CoreInsuranceCard"] = "core_insurance_card";
    OrganisationFeatureCode["EarlyAccess"] = "early_access";
    OrganisationFeatureCode["FindCare"] = "find_care";
    OrganisationFeatureCode["FindCareFacilitySearch"] = "find_care_facility_search";
    OrganisationFeatureCode["FindCareProviderSearch"] = "find_care_provider_search";
    OrganisationFeatureCode["GetCareSectionNavigation"] = "get_care_section_navigation";
    OrganisationFeatureCode["MedicineCabinet"] = "medicine_cabinet";
    OrganisationFeatureCode["MyCareTeam"] = "my_care_team";
    OrganisationFeatureCode["NavOpenEnrollment"] = "nav_open_enrollment";
    OrganisationFeatureCode["NavOpenEnrollmentAiChatbot"] = "nav_open_enrollment_ai_chatbot";
    OrganisationFeatureCode["OldPbm"] = "old_pbm";
    OrganisationFeatureCode["OpenEnrollment"] = "open_enrollment";
    OrganisationFeatureCode["OpenEnrollmentDrugSearch"] = "open_enrollment_drug_search";
    OrganisationFeatureCode["OpenEnrollmentLabeling"] = "open_enrollment_labeling";
    OrganisationFeatureCode["OpenEnrollmentMailOrderPharmacySearch"] = "open_enrollment_mail_order_pharmacy_search";
    OrganisationFeatureCode["OpenEnrollmentPharmacySearch"] = "open_enrollment_pharmacy_search";
    OrganisationFeatureCode["Pbm"] = "pbm";
    OrganisationFeatureCode["PbmAccumulator"] = "pbm_accumulator";
    OrganisationFeatureCode["PbmDrugSearch"] = "pbm_drug_search";
    OrganisationFeatureCode["PbmMccp"] = "pbm_mccp";
    OrganisationFeatureCode["Ratings"] = "ratings";
    OrganisationFeatureCode["Rewards"] = "rewards";
    OrganisationFeatureCode["SharedActivityFeed"] = "shared_activity_feed";
    OrganisationFeatureCode["SharedDentalCoverage"] = "shared_dental_coverage";
    OrganisationFeatureCode["SharedHealthProfile"] = "shared_health_profile";
    OrganisationFeatureCode["SharedInsuranceBenefits"] = "shared_insurance_benefits";
    OrganisationFeatureCode["SharedMfaRequired"] = "shared_mfa_required";
    OrganisationFeatureCode["SharedMobilePrivacyMasking"] = "shared_mobile_privacy_masking";
    OrganisationFeatureCode["SharedPharmacyCoverage"] = "shared_pharmacy_coverage";
    OrganisationFeatureCode["SharedPhoneVerify"] = "shared_phone_verify";
    OrganisationFeatureCode["SharedProfile"] = "shared_profile";
    OrganisationFeatureCode["SharedSessionTimeout"] = "shared_session_timeout";
    OrganisationFeatureCode["SharedSettings"] = "shared_settings";
    OrganisationFeatureCode["SharedVisionCoverage"] = "shared_vision_coverage";
    OrganisationFeatureCode["SmsAlert"] = "sms_alert";
    OrganisationFeatureCode["Telemedicine"] = "telemedicine";
    OrganisationFeatureCode["Wellness"] = "wellness";
})(OrganisationFeatureCode || (OrganisationFeatureCode = {}));
export var OrganisationGroupOrganizationsScope;
(function (OrganisationGroupOrganizationsScope) {
    OrganisationGroupOrganizationsScope["All"] = "all";
    OrganisationGroupOrganizationsScope["Core"] = "core";
    OrganisationGroupOrganizationsScope["Custom"] = "custom";
    OrganisationGroupOrganizationsScope["Pbm"] = "pbm";
    OrganisationGroupOrganizationsScope["Unity"] = "unity";
})(OrganisationGroupOrganizationsScope || (OrganisationGroupOrganizationsScope = {}));
export var Partner_Card_Image_Versions;
(function (Partner_Card_Image_Versions) {
    /** large image version. */
    Partner_Card_Image_Versions["Large"] = "large";
    /** normal image version. */
    Partner_Card_Image_Versions["Normal"] = "normal";
    /** original image version. */
    Partner_Card_Image_Versions["Original"] = "original";
})(Partner_Card_Image_Versions || (Partner_Card_Image_Versions = {}));
export var Partner_Card_Title;
(function (Partner_Card_Title) {
    /** Benefits Portal */
    Partner_Card_Title["BenefitsPortal"] = "BENEFITS_PORTAL";
    /** Benefit Support */
    Partner_Card_Title["BenefitSupport"] = "BENEFIT_SUPPORT";
    /** Caregiving Support */
    Partner_Card_Title["CaregivingSupport"] = "CAREGIVING_SUPPORT";
    /** Carrier */
    Partner_Card_Title["Carrier"] = "CARRIER";
    /** Case Management */
    Partner_Card_Title["CaseManagement"] = "CASE_MANAGEMENT";
    /** Chronic Condition */
    Partner_Card_Title["ChronicCondition"] = "CHRONIC_CONDITION";
    /** Commuter */
    Partner_Card_Title["Commuter"] = "COMMUTER";
    /** Critical Illness/Accident */
    Partner_Card_Title["CriticalIllnessAccident"] = "CRITICAL_ILLNESS_ACCIDENT";
    /** Dental */
    Partner_Card_Title["Dental"] = "DENTAL";
    /** Diabetes */
    Partner_Card_Title["Diabetes"] = "DIABETES";
    /** Direct Primary Care */
    Partner_Card_Title["DirectPrimaryCare"] = "DIRECT_PRIMARY_CARE";
    /** Disability */
    Partner_Card_Title["Disability"] = "DISABILITY";
    /** Discount Programs */
    Partner_Card_Title["DiscountPrograms"] = "DISCOUNT_PROGRAMS";
    /** Education */
    Partner_Card_Title["Education"] = "EDUCATION";
    /** Employee Assistance Program */
    Partner_Card_Title["EmployeeAssistanceProgram"] = "EMPLOYEE_ASSISTANCE_PROGRAM";
    /** Family Planning */
    Partner_Card_Title["FamilyPlanning"] = "FAMILY_PLANNING";
    /** Female Wellness */
    Partner_Card_Title["FemaleWellness"] = "FEMALE_WELLNESS";
    /** Fertility */
    Partner_Card_Title["Fertility"] = "FERTILITY";
    /** Finances */
    Partner_Card_Title["Finances"] = "FINANCES";
    /** Financial */
    Partner_Card_Title["Financial"] = "FINANCIAL";
    /** Fitness */
    Partner_Card_Title["Fitness"] = "FITNESS";
    /** Flex */
    Partner_Card_Title["Flex"] = "FLEX";
    /** Flex/Commuter */
    Partner_Card_Title["FlexCommuter"] = "FLEX_COMMUTER";
    /** FMLA */
    Partner_Card_Title["Fmla"] = "FMLA";
    /** 401 (k) (Retirement) */
    Partner_Card_Title["FourOOneKRetirement"] = "FOUR_O_ONE_K_RETIREMENT";
    /** FSA */
    Partner_Card_Title["Fsa"] = "FSA";
    /** GAP Insurance */
    Partner_Card_Title["GapInsurance"] = "GAP_INSURANCE";
    /** Grief Counseling */
    Partner_Card_Title["GriefCounseling"] = "GRIEF_COUNSELING";
    /** Health Management */
    Partner_Card_Title["HealthManagement"] = "HEALTH_MANAGEMENT";
    /** Home and Auto Insurance */
    Partner_Card_Title["HomeAndAutoInsurance"] = "HOME_AND_AUTO_INSURANCE";
    /** Hormonal Health */
    Partner_Card_Title["HormonalHealth"] = "HORMONAL_HEALTH";
    /** Hospital Indemnity */
    Partner_Card_Title["HospitalIndemnity"] = "HOSPITAL_INDEMNITY";
    /** HRA */
    Partner_Card_Title["Hra"] = "HRA";
    /** HSA */
    Partner_Card_Title["Hsa"] = "HSA";
    /** HSA/FSA */
    Partner_Card_Title["HsaFsa"] = "HSA_FSA";
    /** Identity Theft */
    Partner_Card_Title["IdentityTheft"] = "IDENTITY_THEFT";
    /** Investment Advice */
    Partner_Card_Title["InvestmentAdvice"] = "INVESTMENT_ADVICE";
    /** Legal Services */
    Partner_Card_Title["LegalServices"] = "LEGAL_SERVICES";
    /** Life Insurance */
    Partner_Card_Title["LifeInsurance"] = "LIFE_INSURANCE";
    /** Life Support Services */
    Partner_Card_Title["LifeSupportServices"] = "LIFE_SUPPORT_SERVICES";
    /** Long-Term Care */
    Partner_Card_Title["LongTermCare"] = "LONG_TERM_CARE";
    /** Long-Term Disability */
    Partner_Card_Title["LongTermDisability"] = "LONG_TERM_DISABILITY";
    /** Maternity */
    Partner_Card_Title["Maternity"] = "MATERNITY";
    /** Medical */
    Partner_Card_Title["Medical"] = "MEDICAL";
    /** Men's Wellness */
    Partner_Card_Title["MensWellness"] = "MENS_WELLNESS";
    /** Mental Health */
    Partner_Card_Title["MentalHealth"] = "MENTAL_HEALTH";
    /** Musculoskeletal */
    Partner_Card_Title["Musculoskeletal"] = "MUSCULOSKELETAL";
    /** New Mother Wellness */
    Partner_Card_Title["NewMotherWellness"] = "NEW_MOTHER_WELLNESS";
    /** Nurseline */
    Partner_Card_Title["Nurseline"] = "NURSELINE";
    /** Opt-In Form */
    Partner_Card_Title["OptInForm"] = "OPT_IN_FORM";
    /** Other */
    Partner_Card_Title["Other"] = "OTHER";
    /** Parental Support */
    Partner_Card_Title["ParentalSupport"] = "PARENTAL_SUPPORT";
    /** Payroll */
    Partner_Card_Title["Payroll"] = "PAYROLL";
    /** Pediatrics */
    Partner_Card_Title["Pediatrics"] = "PEDIATRICS";
    /** Pet Insurance */
    Partner_Card_Title["PetInsurance"] = "PET_INSURANCE";
    /** Prescriptions */
    Partner_Card_Title["Prescriptions"] = "PRESCRIPTIONS";
    /** Primary Care */
    Partner_Card_Title["PrimaryCare"] = "PRIMARY_CARE";
    /** Retirement */
    Partner_Card_Title["Retirement"] = "RETIREMENT";
    /** Second Opinion */
    Partner_Card_Title["SecondOpinion"] = "SECOND_OPINION";
    /** Short Term Disability */
    Partner_Card_Title["ShortTermDisability"] = "SHORT_TERM_DISABILITY";
    /** Specialty Pharmacy */
    Partner_Card_Title["SpecialtyPharmacy"] = "SPECIALTY_PHARMACY";
    /** Speech Therapy */
    Partner_Card_Title["SpeechTherapy"] = "SPEECH_THERAPY";
    /** Telemedicine */
    Partner_Card_Title["Telemedicine"] = "TELEMEDICINE";
    /** Travel Assistance */
    Partner_Card_Title["TravelAssistance"] = "TRAVEL_ASSISTANCE";
    /** Tuition Assistance Program */
    Partner_Card_Title["TuitionAssistanceProgram"] = "TUITION_ASSISTANCE_PROGRAM";
    /** Virtual Primary Care */
    Partner_Card_Title["VirtualPrimaryCare"] = "VIRTUAL_PRIMARY_CARE";
    /** Virtual Second Opinion */
    Partner_Card_Title["VirtualSecondOpinion"] = "VIRTUAL_SECOND_OPINION";
    /** Vision */
    Partner_Card_Title["Vision"] = "VISION";
    /** Voluntary Benefits */
    Partner_Card_Title["VoluntaryBenefits"] = "VOLUNTARY_BENEFITS";
    /** Weight Loss */
    Partner_Card_Title["WeightLoss"] = "WEIGHT_LOSS";
    /** Wellness */
    Partner_Card_Title["Wellness"] = "WELLNESS";
    /** Whole Life Insurance */
    Partner_Card_Title["WholeLifeInsurance"] = "WHOLE_LIFE_INSURANCE";
    /** Will Prep */
    Partner_Card_Title["WillPrep"] = "WILL_PREP";
})(Partner_Card_Title || (Partner_Card_Title = {}));
export var Pa_Activity_Event_Type;
(function (Pa_Activity_Event_Type) {
    Pa_Activity_Event_Type["AppealRequested"] = "APPEAL_REQUESTED";
    Pa_Activity_Event_Type["Approved"] = "APPROVED";
    Pa_Activity_Event_Type["CalledProvider"] = "CALLED_PROVIDER";
    Pa_Activity_Event_Type["Denied"] = "DENIED";
    Pa_Activity_Event_Type["FaxSent"] = "FAX_SENT";
    Pa_Activity_Event_Type["MoreInfoRequested"] = "MORE_INFO_REQUESTED";
    Pa_Activity_Event_Type["PaRequested"] = "PA_REQUESTED";
    Pa_Activity_Event_Type["UnableToReachProvider"] = "UNABLE_TO_REACH_PROVIDER";
    Pa_Activity_Event_Type["Unspecified"] = "UNSPECIFIED";
    Pa_Activity_Event_Type["Withdrawn"] = "WITHDRAWN";
    Pa_Activity_Event_Type["WorkingOnIt"] = "WORKING_ON_IT";
})(Pa_Activity_Event_Type || (Pa_Activity_Event_Type = {}));
export var Pa_Derived_Badge;
(function (Pa_Derived_Badge) {
    Pa_Derived_Badge["AppealPending"] = "APPEAL_PENDING";
    Pa_Derived_Badge["Approved"] = "APPROVED";
    Pa_Derived_Badge["Denied"] = "DENIED";
    Pa_Derived_Badge["InReview"] = "IN_REVIEW";
    Pa_Derived_Badge["NotApproved"] = "NOT_APPROVED";
    Pa_Derived_Badge["Unspecified"] = "UNSPECIFIED";
    Pa_Derived_Badge["Withdrawn"] = "WITHDRAWN";
    Pa_Derived_Badge["WorkingOnIt"] = "WORKING_ON_IT";
})(Pa_Derived_Badge || (Pa_Derived_Badge = {}));
export var Pending_Medication_Priority_Type;
(function (Pending_Medication_Priority_Type) {
    Pending_Medication_Priority_Type["Expedited"] = "expedited";
    Pending_Medication_Priority_Type["Standard"] = "standard";
    Pending_Medication_Priority_Type["Unspecified"] = "unspecified";
})(Pending_Medication_Priority_Type || (Pending_Medication_Priority_Type = {}));
export var Pending_Medication_Request_Type_Type;
(function (Pending_Medication_Request_Type_Type) {
    Pending_Medication_Request_Type_Type["FirstLevelAppeal"] = "first_level_appeal";
    Pending_Medication_Request_Type_Type["InitialDmr"] = "initial_dmr";
    Pending_Medication_Request_Type_Type["InitialRequest"] = "initial_request";
    Pending_Medication_Request_Type_Type["SecondLevelAppeal"] = "second_level_appeal";
    Pending_Medication_Request_Type_Type["Unspecified"] = "unspecified";
})(Pending_Medication_Request_Type_Type || (Pending_Medication_Request_Type_Type = {}));
export var Pending_Medication_Status_Reason_Type;
(function (Pending_Medication_Status_Reason_Type) {
    Pending_Medication_Status_Reason_Type["AdditionalInformationRequired"] = "additional_information_required";
    Pending_Medication_Status_Reason_Type["PendingAor"] = "pending_aor";
    Pending_Medication_Status_Reason_Type["PendingClinicalReview"] = "pending_clinical_review";
    Pending_Medication_Status_Reason_Type["PendingReview"] = "pending_review";
    Pending_Medication_Status_Reason_Type["Unspecified"] = "unspecified";
})(Pending_Medication_Status_Reason_Type || (Pending_Medication_Status_Reason_Type = {}));
export var Pending_Medication_Status_Type;
(function (Pending_Medication_Status_Type) {
    Pending_Medication_Status_Type["Approved"] = "approved";
    Pending_Medication_Status_Type["Denied"] = "denied";
    Pending_Medication_Status_Type["Dismissed"] = "dismissed";
    Pending_Medication_Status_Type["PartialApproval"] = "partial_approval";
    Pending_Medication_Status_Type["Pending"] = "pending";
    Pending_Medication_Status_Type["Unspecified"] = "unspecified";
    Pending_Medication_Status_Type["Withdrawn"] = "withdrawn";
})(Pending_Medication_Status_Type || (Pending_Medication_Status_Type = {}));
export var Permission_Audit_Log_Action_Type;
(function (Permission_Audit_Log_Action_Type) {
    /** Activate team */
    Permission_Audit_Log_Action_Type["ActivateTeam"] = "activate_team";
    /** Add team permission */
    Permission_Audit_Log_Action_Type["AddTeamPermission"] = "add_team_permission";
    /** Assign inbox team */
    Permission_Audit_Log_Action_Type["AssignInboxTeam"] = "assign_inbox_team";
    /** Create organization group */
    Permission_Audit_Log_Action_Type["CreateOrganizationGroup"] = "create_organization_group";
    /** Create team */
    Permission_Audit_Log_Action_Type["CreateTeam"] = "create_team";
    /** Deactivate team */
    Permission_Audit_Log_Action_Type["DeactivateTeam"] = "deactivate_team";
    /** Delete organization group */
    Permission_Audit_Log_Action_Type["DeleteOrganizationGroup"] = "delete_organization_group";
    /** Delete team */
    Permission_Audit_Log_Action_Type["DeleteTeam"] = "delete_team";
    /** Delete team permission */
    Permission_Audit_Log_Action_Type["DeleteTeamPermission"] = "delete_team_permission";
    /** Update organization group */
    Permission_Audit_Log_Action_Type["UpdateOrganizationGroup"] = "update_organization_group";
    /** Update organization group organizations */
    Permission_Audit_Log_Action_Type["UpdateOrganizationGroupOrganizations"] = "update_organization_group_organizations";
    /** Update team */
    Permission_Audit_Log_Action_Type["UpdateTeam"] = "update_team";
    /** Update team article categories */
    Permission_Audit_Log_Action_Type["UpdateTeamArticleCategories"] = "update_team_article_categories";
    /** Update team chat templates */
    Permission_Audit_Log_Action_Type["UpdateTeamChatTemplates"] = "update_team_chat_templates";
    /** Update team deliverables */
    Permission_Audit_Log_Action_Type["UpdateTeamDeliverables"] = "update_team_deliverables";
    /** Update team organization groups */
    Permission_Audit_Log_Action_Type["UpdateTeamOrganizationGroups"] = "update_team_organization_groups";
    /** Update team surveys */
    Permission_Audit_Log_Action_Type["UpdateTeamSurveys"] = "update_team_surveys";
    /** Update team ticket flags */
    Permission_Audit_Log_Action_Type["UpdateTeamTicketFlags"] = "update_team_ticket_flags";
    /** Update team ticket types */
    Permission_Audit_Log_Action_Type["UpdateTeamTicketTypes"] = "update_team_ticket_types";
    /** Update team users */
    Permission_Audit_Log_Action_Type["UpdateTeamUsers"] = "update_team_users";
})(Permission_Audit_Log_Action_Type || (Permission_Audit_Log_Action_Type = {}));
export var Permission_Audit_Log_Order;
(function (Permission_Audit_Log_Order) {
    /** Ascending sort by 'id' field. */
    Permission_Audit_Log_Order["Id"] = "id";
    /** Descending sort by 'id' field. */
    Permission_Audit_Log_Order["ReverseId"] = "reverse_id";
})(Permission_Audit_Log_Order || (Permission_Audit_Log_Order = {}));
export var Pharmacy_Card_Kind;
(function (Pharmacy_Card_Kind) {
    Pharmacy_Card_Kind["MailOrder"] = "mail_order";
    Pharmacy_Card_Kind["Specialty"] = "specialty";
})(Pharmacy_Card_Kind || (Pharmacy_Card_Kind = {}));
export var Pharmacy_Card_Step_Content_Kind;
(function (Pharmacy_Card_Step_Content_Kind) {
    Pharmacy_Card_Step_Content_Kind["Link"] = "link";
    Pharmacy_Card_Step_Content_Kind["RxCard"] = "rx_card";
    Pharmacy_Card_Step_Content_Kind["Text"] = "text";
})(Pharmacy_Card_Step_Content_Kind || (Pharmacy_Card_Step_Content_Kind = {}));
export var Pharmacy_Day_Of_Week_Type;
(function (Pharmacy_Day_Of_Week_Type) {
    Pharmacy_Day_Of_Week_Type["Friday"] = "friday";
    Pharmacy_Day_Of_Week_Type["Monday"] = "monday";
    Pharmacy_Day_Of_Week_Type["Saturday"] = "saturday";
    Pharmacy_Day_Of_Week_Type["Sunday"] = "sunday";
    Pharmacy_Day_Of_Week_Type["Thursday"] = "thursday";
    Pharmacy_Day_Of_Week_Type["Tuesday"] = "tuesday";
    Pharmacy_Day_Of_Week_Type["Unspecified"] = "unspecified";
    Pharmacy_Day_Of_Week_Type["Wednesday"] = "wednesday";
})(Pharmacy_Day_Of_Week_Type || (Pharmacy_Day_Of_Week_Type = {}));
export var Pharmacy_Payment_Type;
(function (Pharmacy_Payment_Type) {
    Pharmacy_Payment_Type["Coinsurance"] = "coinsurance";
    Pharmacy_Payment_Type["Copay"] = "copay";
    Pharmacy_Payment_Type["Unspecified"] = "unspecified";
})(Pharmacy_Payment_Type || (Pharmacy_Payment_Type = {}));
export var Plan_Asset_Kind;
(function (Plan_Asset_Kind) {
    Plan_Asset_Kind["Other"] = "Other";
    /** Statement of Benefits */
    Plan_Asset_Kind["Sob"] = "SOB";
    /** Summary Plan Description */
    Plan_Asset_Kind["Spd"] = "SPD";
})(Plan_Asset_Kind || (Plan_Asset_Kind = {}));
export var Plan_Benefit_Groups_Order;
(function (Plan_Benefit_Groups_Order) {
    /** Ascending sort by 'insurance_plan_id' field. */
    Plan_Benefit_Groups_Order["InsurancePlanId"] = "insurance_plan_id";
    /** Descending sort by 'insurance_plan_id' field. */
    Plan_Benefit_Groups_Order["ReverseInsurancePlanId"] = "reverse_insurance_plan_id";
})(Plan_Benefit_Groups_Order || (Plan_Benefit_Groups_Order = {}));
export var Plan_Benefit_Order;
(function (Plan_Benefit_Order) {
    /** Ascending sort by 'insurance_plan_id' field. */
    Plan_Benefit_Order["InsurancePlanId"] = "insurance_plan_id";
    /** Descending sort by 'insurance_plan_id' field. */
    Plan_Benefit_Order["ReverseInsurancePlanId"] = "reverse_insurance_plan_id";
})(Plan_Benefit_Order || (Plan_Benefit_Order = {}));
export var Plan_Benefit_Tier_Order;
(function (Plan_Benefit_Tier_Order) {
    /** Ascending sort by 'id' field. */
    Plan_Benefit_Tier_Order["Id"] = "id";
    /** Ascending sort by 'name' field. */
    Plan_Benefit_Tier_Order["Name"] = "name";
    /** Ascending sort by 'position' field. */
    Plan_Benefit_Tier_Order["Position"] = "position";
    /** Descending sort by 'id' field. */
    Plan_Benefit_Tier_Order["ReverseId"] = "reverse_id";
    /** Descending sort by 'name' field. */
    Plan_Benefit_Tier_Order["ReverseName"] = "reverse_name";
    /** Descending sort by 'position' field. */
    Plan_Benefit_Tier_Order["ReversePosition"] = "reverse_position";
})(Plan_Benefit_Tier_Order || (Plan_Benefit_Tier_Order = {}));
export var Plan_Category_Order;
(function (Plan_Category_Order) {
    /** Ascending sort by 'id' field. */
    Plan_Category_Order["Id"] = "id";
    /** Ascending sort by 'name' field. */
    Plan_Category_Order["Name"] = "name";
    /** Ascending sort by 'position' field. */
    Plan_Category_Order["Position"] = "position";
    /** Descending sort by 'id' field. */
    Plan_Category_Order["ReverseId"] = "reverse_id";
    /** Descending sort by 'name' field. */
    Plan_Category_Order["ReverseName"] = "reverse_name";
    /** Descending sort by 'position' field. */
    Plan_Category_Order["ReversePosition"] = "reverse_position";
})(Plan_Category_Order || (Plan_Category_Order = {}));
/** Unit used to express when a preset task is due relative to ticket creation */
export var Preset_Task_Time_Type;
(function (Preset_Task_Time_Type) {
    Preset_Task_Time_Type["Days"] = "days";
    Preset_Task_Time_Type["Hours"] = "hours";
    Preset_Task_Time_Type["Minutes"] = "minutes";
})(Preset_Task_Time_Type || (Preset_Task_Time_Type = {}));
/** Prior authorization status pa status */
export var Prior_Authorization_Status_Pa_Status;
(function (Prior_Authorization_Status_Pa_Status) {
    Prior_Authorization_Status_Pa_Status["Approved"] = "approved";
    Prior_Authorization_Status_Pa_Status["Denied"] = "denied";
    Prior_Authorization_Status_Pa_Status["InProgress"] = "in_progress";
})(Prior_Authorization_Status_Pa_Status || (Prior_Authorization_Status_Pa_Status = {}));
/** Prior authorization status requesters */
export var Prior_Authorization_Status_Requester;
(function (Prior_Authorization_Status_Requester) {
    Prior_Authorization_Status_Requester["Cmm"] = "cmm";
    Prior_Authorization_Status_Requester["Manufacturer"] = "manufacturer";
    Prior_Authorization_Status_Requester["Member"] = "member";
    Prior_Authorization_Status_Requester["Pharmacy"] = "pharmacy";
    Prior_Authorization_Status_Requester["Provider"] = "provider";
})(Prior_Authorization_Status_Requester || (Prior_Authorization_Status_Requester = {}));
export var Profile_Image_Versions;
(function (Profile_Image_Versions) {
    /** original image version. */
    Profile_Image_Versions["Original"] = "original";
    /** small image version. */
    Profile_Image_Versions["Small"] = "small";
})(Profile_Image_Versions || (Profile_Image_Versions = {}));
export var PartnerCardType;
(function (PartnerCardType) {
    PartnerCardType["OutboundSso"] = "outbound_sso";
    PartnerCardType["Regular"] = "regular";
})(PartnerCardType || (PartnerCardType = {}));
export var PbmBenefitCmsAccumulatorType;
(function (PbmBenefitCmsAccumulatorType) {
    PbmBenefitCmsAccumulatorType["AccumulatorTypeEmpChild"] = "ACCUMULATOR_TYPE_EMP_CHILD";
    PbmBenefitCmsAccumulatorType["AccumulatorTypeEmpSpouse"] = "ACCUMULATOR_TYPE_EMP_SPOUSE";
    PbmBenefitCmsAccumulatorType["AccumulatorTypeFamily"] = "ACCUMULATOR_TYPE_FAMILY";
    PbmBenefitCmsAccumulatorType["AccumulatorTypeIndividual"] = "ACCUMULATOR_TYPE_INDIVIDUAL";
    PbmBenefitCmsAccumulatorType["AccumulatorTypeIndFam"] = "ACCUMULATOR_TYPE_IND_FAM";
})(PbmBenefitCmsAccumulatorType || (PbmBenefitCmsAccumulatorType = {}));
export var PbmBenefitCmsActivityEntityType;
(function (PbmBenefitCmsActivityEntityType) {
    PbmBenefitCmsActivityEntityType["ActivityEntityTypeComment"] = "ACTIVITY_ENTITY_TYPE_COMMENT";
    PbmBenefitCmsActivityEntityType["ActivityEntityTypeDrugCoverage"] = "ACTIVITY_ENTITY_TYPE_DRUG_COVERAGE";
    PbmBenefitCmsActivityEntityType["ActivityEntityTypeDrugList"] = "ACTIVITY_ENTITY_TYPE_DRUG_LIST";
    PbmBenefitCmsActivityEntityType["ActivityEntityTypePlan"] = "ACTIVITY_ENTITY_TYPE_PLAN";
    PbmBenefitCmsActivityEntityType["ActivityEntityTypeUnspecified"] = "ACTIVITY_ENTITY_TYPE_UNSPECIFIED";
    PbmBenefitCmsActivityEntityType["ActivityEntityTypeWorkflow"] = "ACTIVITY_ENTITY_TYPE_WORKFLOW";
})(PbmBenefitCmsActivityEntityType || (PbmBenefitCmsActivityEntityType = {}));
export var PbmBenefitCmsApplicationMethods;
(function (PbmBenefitCmsApplicationMethods) {
    PbmBenefitCmsApplicationMethods["ApplicationMethodsCustom"] = "APPLICATION_METHODS_CUSTOM";
    PbmBenefitCmsApplicationMethods["ApplicationMethodsStandardCost"] = "APPLICATION_METHODS_STANDARD_COST";
    PbmBenefitCmsApplicationMethods["ApplicationMethodsZeroCost"] = "APPLICATION_METHODS_ZERO_COST";
})(PbmBenefitCmsApplicationMethods || (PbmBenefitCmsApplicationMethods = {}));
export var PbmBenefitCmsBenefitCmsErrorCode;
(function (PbmBenefitCmsBenefitCmsErrorCode) {
    PbmBenefitCmsBenefitCmsErrorCode["BenefitCmsErrorCodeMultiplePlansForGroupNum"] = "BENEFIT_CMS_ERROR_CODE_MULTIPLE_PLANS_FOR_GROUP_NUM";
    PbmBenefitCmsBenefitCmsErrorCode["BenefitCmsErrorCodeUnspecified"] = "BENEFIT_CMS_ERROR_CODE_UNSPECIFIED";
})(PbmBenefitCmsBenefitCmsErrorCode || (PbmBenefitCmsBenefitCmsErrorCode = {}));
export var PbmBenefitCmsBiosimilarFirstLevelEnum;
(function (PbmBenefitCmsBiosimilarFirstLevelEnum) {
    PbmBenefitCmsBiosimilarFirstLevelEnum["BiosimilarFirstLevelDecisiondeferred"] = "BIOSIMILAR_FIRST_LEVEL_DECISIONDEFERRED";
    PbmBenefitCmsBiosimilarFirstLevelEnum["BiosimilarFirstLevelHighwac"] = "BIOSIMILAR_FIRST_LEVEL_HIGHWAC";
    PbmBenefitCmsBiosimilarFirstLevelEnum["BiosimilarFirstLevelLowwac"] = "BIOSIMILAR_FIRST_LEVEL_LOWWAC";
    PbmBenefitCmsBiosimilarFirstLevelEnum["BiosimilarFirstLevelUnspecified"] = "BIOSIMILAR_FIRST_LEVEL_UNSPECIFIED";
})(PbmBenefitCmsBiosimilarFirstLevelEnum || (PbmBenefitCmsBiosimilarFirstLevelEnum = {}));
export var PbmBenefitCmsBiosimilarSecondLevelEnum;
(function (PbmBenefitCmsBiosimilarSecondLevelEnum) {
    PbmBenefitCmsBiosimilarSecondLevelEnum["BiosimilarSecondLevelCostShare"] = "BIOSIMILAR_SECOND_LEVEL_COST_SHARE";
    PbmBenefitCmsBiosimilarSecondLevelEnum["BiosimilarSecondLevelHsaCredit"] = "BIOSIMILAR_SECOND_LEVEL_HSA_CREDIT";
    PbmBenefitCmsBiosimilarSecondLevelEnum["BiosimilarSecondLevelPosCredit"] = "BIOSIMILAR_SECOND_LEVEL_POS_CREDIT";
    PbmBenefitCmsBiosimilarSecondLevelEnum["BiosimilarSecondLevelStandardCostShare"] = "BIOSIMILAR_SECOND_LEVEL_STANDARD_COST_SHARE";
    PbmBenefitCmsBiosimilarSecondLevelEnum["BiosimilarSecondLevelUnspecified"] = "BIOSIMILAR_SECOND_LEVEL_UNSPECIFIED";
    PbmBenefitCmsBiosimilarSecondLevelEnum["BiosimilarSecondLevelZeroCostShareAfterDeductible"] = "BIOSIMILAR_SECOND_LEVEL_ZERO_COST_SHARE_AFTER_DEDUCTIBLE";
})(PbmBenefitCmsBiosimilarSecondLevelEnum || (PbmBenefitCmsBiosimilarSecondLevelEnum = {}));
export var PbmBenefitCmsBypassOptions;
(function (PbmBenefitCmsBypassOptions) {
    PbmBenefitCmsBypassOptions["BypassPa"] = "BYPASS_PA";
    PbmBenefitCmsBypassOptions["BypassQl"] = "BYPASS_QL";
    PbmBenefitCmsBypassOptions["BypassSt"] = "BYPASS_ST";
})(PbmBenefitCmsBypassOptions || (PbmBenefitCmsBypassOptions = {}));
export var PbmBenefitCmsCapImpactOptionsEnum;
(function (PbmBenefitCmsCapImpactOptionsEnum) {
    PbmBenefitCmsCapImpactOptionsEnum["CapImpactOptionsApplyMoop"] = "CAP_IMPACT_OPTIONS_APPLY_MOOP";
    PbmBenefitCmsCapImpactOptionsEnum["CapImpactOptionsCustom"] = "CAP_IMPACT_OPTIONS_CUSTOM";
    PbmBenefitCmsCapImpactOptionsEnum["CapImpactOptionsNotApplyMoop"] = "CAP_IMPACT_OPTIONS_NOT_APPLY_MOOP";
    PbmBenefitCmsCapImpactOptionsEnum["CapImpactOptionsUnspecified"] = "CAP_IMPACT_OPTIONS_UNSPECIFIED";
})(PbmBenefitCmsCapImpactOptionsEnum || (PbmBenefitCmsCapImpactOptionsEnum = {}));
export var PbmBenefitCmsChannelTypes;
(function (PbmBenefitCmsChannelTypes) {
    PbmBenefitCmsChannelTypes["ChannelTypesFacilitySpecific"] = "CHANNEL_TYPES_FACILITY_SPECIFIC";
    PbmBenefitCmsChannelTypes["ChannelTypesHomeDelivery"] = "CHANNEL_TYPES_HOME_DELIVERY";
    PbmBenefitCmsChannelTypes["ChannelTypesMail"] = "CHANNEL_TYPES_MAIL";
    PbmBenefitCmsChannelTypes["ChannelTypesOther"] = "CHANNEL_TYPES_OTHER";
    PbmBenefitCmsChannelTypes["ChannelTypesRetail"] = "CHANNEL_TYPES_RETAIL";
    PbmBenefitCmsChannelTypes["ChannelTypesRetailMail"] = "CHANNEL_TYPES_RETAIL_MAIL";
    PbmBenefitCmsChannelTypes["ChannelTypesSpecialty"] = "CHANNEL_TYPES_SPECIALTY";
})(PbmBenefitCmsChannelTypes || (PbmBenefitCmsChannelTypes = {}));
export var PbmBenefitCmsClaimDataStatusesEnum;
(function (PbmBenefitCmsClaimDataStatusesEnum) {
    PbmBenefitCmsClaimDataStatusesEnum["ClaimDataStatusesCanNot"] = "CLAIM_DATA_STATUSES_CAN_NOT";
    PbmBenefitCmsClaimDataStatusesEnum["ClaimDataStatusesOther"] = "CLAIM_DATA_STATUSES_OTHER";
    PbmBenefitCmsClaimDataStatusesEnum["ClaimDataStatusesSixMonth"] = "CLAIM_DATA_STATUSES_SIX_MONTH";
    PbmBenefitCmsClaimDataStatusesEnum["ClaimDataStatusesUnspecified"] = "CLAIM_DATA_STATUSES_UNSPECIFIED";
})(PbmBenefitCmsClaimDataStatusesEnum || (PbmBenefitCmsClaimDataStatusesEnum = {}));
export var PbmBenefitCmsClientIntents;
(function (PbmBenefitCmsClientIntents) {
    PbmBenefitCmsClientIntents["ClientIntentsAgeWpa"] = "CLIENT_INTENTS_AGE_WPA";
    PbmBenefitCmsClientIntents["ClientIntentsAmountWpa"] = "CLIENT_INTENTS_AMOUNT_WPA";
    PbmBenefitCmsClientIntents["ClientIntentsExclude"] = "CLIENT_INTENTS_EXCLUDE";
    PbmBenefitCmsClientIntents["ClientIntentsInclude"] = "CLIENT_INTENTS_INCLUDE";
    PbmBenefitCmsClientIntents["ClientIntentsWpa"] = "CLIENT_INTENTS_WPA";
    PbmBenefitCmsClientIntents["ClientIntentsWpaWql"] = "CLIENT_INTENTS_WPA_WQL";
    PbmBenefitCmsClientIntents["ClientIntentsWql"] = "CLIENT_INTENTS_WQL";
})(PbmBenefitCmsClientIntents || (PbmBenefitCmsClientIntents = {}));
export var PbmBenefitCmsClientType;
(function (PbmBenefitCmsClientType) {
    PbmBenefitCmsClientType["ClientTypeBenefitsAdministrator"] = "CLIENT_TYPE_BENEFITS_ADMINISTRATOR";
    PbmBenefitCmsClientType["ClientTypeBillingContact"] = "CLIENT_TYPE_BILLING_CONTACT";
    PbmBenefitCmsClientType["ClientTypeClaimsManager"] = "CLIENT_TYPE_CLAIMS_MANAGER";
    PbmBenefitCmsClientType["ClientTypeEligibilityContact"] = "CLIENT_TYPE_ELIGIBILITY_CONTACT";
    PbmBenefitCmsClientType["ClientTypeEscalationContact"] = "CLIENT_TYPE_ESCALATION_CONTACT";
    PbmBenefitCmsClientType["ClientTypeImplementationManager"] = "CLIENT_TYPE_IMPLEMENTATION_MANAGER";
    PbmBenefitCmsClientType["ClientTypeMemberServicesContact"] = "CLIENT_TYPE_MEMBER_SERVICES_CONTACT";
    PbmBenefitCmsClientType["ClientTypeOther"] = "CLIENT_TYPE_OTHER";
    PbmBenefitCmsClientType["ClientTypePrimaryAccountManager"] = "CLIENT_TYPE_PRIMARY_ACCOUNT_MANAGER";
    PbmBenefitCmsClientType["ClientTypeSecondaryAccountManager"] = "CLIENT_TYPE_SECONDARY_ACCOUNT_MANAGER";
    PbmBenefitCmsClientType["ClientTypeTechnicalContact"] = "CLIENT_TYPE_TECHNICAL_CONTACT";
})(PbmBenefitCmsClientType || (PbmBenefitCmsClientType = {}));
export var PbmBenefitCmsCommentType;
(function (PbmBenefitCmsCommentType) {
    PbmBenefitCmsCommentType["CommentTypeApproval"] = "COMMENT_TYPE_APPROVAL";
    PbmBenefitCmsCommentType["CommentTypeConcern"] = "COMMENT_TYPE_CONCERN";
    PbmBenefitCmsCommentType["CommentTypeQuestion"] = "COMMENT_TYPE_QUESTION";
    PbmBenefitCmsCommentType["CommentTypeResponse"] = "COMMENT_TYPE_RESPONSE";
    PbmBenefitCmsCommentType["CommentTypeSuggestion"] = "COMMENT_TYPE_SUGGESTION";
    PbmBenefitCmsCommentType["CommentTypeUnspecified"] = "COMMENT_TYPE_UNSPECIFIED";
})(PbmBenefitCmsCommentType || (PbmBenefitCmsCommentType = {}));
export var PbmBenefitCmsCostShareStructureEnum;
(function (PbmBenefitCmsCostShareStructureEnum) {
    PbmBenefitCmsCostShareStructureEnum["CostShareStructureOther"] = "COST_SHARE_STRUCTURE_OTHER";
    PbmBenefitCmsCostShareStructureEnum["CostShareStructureStandard"] = "COST_SHARE_STRUCTURE_STANDARD";
    PbmBenefitCmsCostShareStructureEnum["CostShareStructureUnspecified"] = "COST_SHARE_STRUCTURE_UNSPECIFIED";
    PbmBenefitCmsCostShareStructureEnum["CostShareStructureZero"] = "COST_SHARE_STRUCTURE_ZERO";
})(PbmBenefitCmsCostShareStructureEnum || (PbmBenefitCmsCostShareStructureEnum = {}));
export var PbmBenefitCmsCostShareStructureOptions;
(function (PbmBenefitCmsCostShareStructureOptions) {
    PbmBenefitCmsCostShareStructureOptions["CostShareOptionStructureCoins"] = "COST_SHARE_OPTION_STRUCTURE_COINS";
    PbmBenefitCmsCostShareStructureOptions["CostShareOptionStructureFlat"] = "COST_SHARE_OPTION_STRUCTURE_FLAT";
    PbmBenefitCmsCostShareStructureOptions["CostShareOptionStructureZero"] = "COST_SHARE_OPTION_STRUCTURE_ZERO";
})(PbmBenefitCmsCostShareStructureOptions || (PbmBenefitCmsCostShareStructureOptions = {}));
export var PbmBenefitCmsCostShareType;
(function (PbmBenefitCmsCostShareType) {
    PbmBenefitCmsCostShareType["CostShareTypeCoinsurance"] = "COST_SHARE_TYPE_COINSURANCE";
    PbmBenefitCmsCostShareType["CostShareTypeCopay"] = "COST_SHARE_TYPE_COPAY";
    PbmBenefitCmsCostShareType["CostShareTypeFormula"] = "COST_SHARE_TYPE_FORMULA";
    PbmBenefitCmsCostShareType["CostShareTypeNotCovered"] = "COST_SHARE_TYPE_NOT_COVERED";
    PbmBenefitCmsCostShareType["CostShareTypeRefTier"] = "COST_SHARE_TYPE_REF_TIER";
})(PbmBenefitCmsCostShareType || (PbmBenefitCmsCostShareType = {}));
export var PbmBenefitCmsCrossAccumsOptions;
(function (PbmBenefitCmsCrossAccumsOptions) {
    PbmBenefitCmsCrossAccumsOptions["CrossAccumsOptionsNa"] = "CROSS_ACCUMS_OPTIONS_NA";
    PbmBenefitCmsCrossAccumsOptions["CrossAccumsOptionsNo"] = "CROSS_ACCUMS_OPTIONS_NO";
    PbmBenefitCmsCrossAccumsOptions["CrossAccumsOptionsYes"] = "CROSS_ACCUMS_OPTIONS_YES";
})(PbmBenefitCmsCrossAccumsOptions || (PbmBenefitCmsCrossAccumsOptions = {}));
export var PbmBenefitCmsDmrOptions;
(function (PbmBenefitCmsDmrOptions) {
    PbmBenefitCmsDmrOptions["DmrAll"] = "DMR_ALL";
    PbmBenefitCmsDmrOptions["DmrEmergency"] = "DMR_EMERGENCY";
    PbmBenefitCmsDmrOptions["DmrNo"] = "DMR_NO";
})(PbmBenefitCmsDmrOptions || (PbmBenefitCmsDmrOptions = {}));
export var PbmBenefitCmsDmrRateOptions;
(function (PbmBenefitCmsDmrRateOptions) {
    PbmBenefitCmsDmrRateOptions["DmrContractedAmount"] = "DMR_CONTRACTED_AMOUNT";
    PbmBenefitCmsDmrRateOptions["DmrRateNa"] = "DMR_RATE_NA";
    PbmBenefitCmsDmrRateOptions["DmrRateOther"] = "DMR_RATE_OTHER";
    PbmBenefitCmsDmrRateOptions["DmrSubmittedAmount"] = "DMR_SUBMITTED_AMOUNT";
})(PbmBenefitCmsDmrRateOptions || (PbmBenefitCmsDmrRateOptions = {}));
export var PbmBenefitCmsDaysSupplyOptions;
(function (PbmBenefitCmsDaysSupplyOptions) {
    PbmBenefitCmsDaysSupplyOptions["Days_30"] = "DAYS_30";
    PbmBenefitCmsDaysSupplyOptions["Days_60"] = "DAYS_60";
    PbmBenefitCmsDaysSupplyOptions["Days_90"] = "DAYS_90";
})(PbmBenefitCmsDaysSupplyOptions || (PbmBenefitCmsDaysSupplyOptions = {}));
export var PbmBenefitCmsDeductibleCellType;
(function (PbmBenefitCmsDeductibleCellType) {
    PbmBenefitCmsDeductibleCellType["DeductibleCellTypeAfter"] = "DEDUCTIBLE_CELL_TYPE_AFTER";
    PbmBenefitCmsDeductibleCellType["DeductibleCellTypeApplies"] = "DEDUCTIBLE_CELL_TYPE_APPLIES";
    PbmBenefitCmsDeductibleCellType["DeductibleCellTypeNone"] = "DEDUCTIBLE_CELL_TYPE_NONE";
})(PbmBenefitCmsDeductibleCellType || (PbmBenefitCmsDeductibleCellType = {}));
export var PbmBenefitCmsDeductibleType;
(function (PbmBenefitCmsDeductibleType) {
    PbmBenefitCmsDeductibleType["DeductibleTypeEmbedded"] = "DEDUCTIBLE_TYPE_EMBEDDED";
    PbmBenefitCmsDeductibleType["DeductibleTypeNonEmbedded"] = "DEDUCTIBLE_TYPE_NON_EMBEDDED";
    PbmBenefitCmsDeductibleType["DeductibleTypeNoPharmacy"] = "DEDUCTIBLE_TYPE_NO_PHARMACY";
})(PbmBenefitCmsDeductibleType || (PbmBenefitCmsDeductibleType = {}));
export var PbmBenefitCmsDiabetesOptionsEnum;
(function (PbmBenefitCmsDiabetesOptionsEnum) {
    PbmBenefitCmsDiabetesOptionsEnum["DiabetesOptionsNo"] = "DIABETES_OPTIONS_NO";
    PbmBenefitCmsDiabetesOptionsEnum["DiabetesOptionsUnspecified"] = "DIABETES_OPTIONS_UNSPECIFIED";
    PbmBenefitCmsDiabetesOptionsEnum["DiabetesOptionsYesCcdp"] = "DIABETES_OPTIONS_YES_CCDP";
    PbmBenefitCmsDiabetesOptionsEnum["DiabetesOptionsYesOther"] = "DIABETES_OPTIONS_YES_OTHER";
})(PbmBenefitCmsDiabetesOptionsEnum || (PbmBenefitCmsDiabetesOptionsEnum = {}));
export var PbmBenefitCmsDiabeticCostShareOption;
(function (PbmBenefitCmsDiabeticCostShareOption) {
    PbmBenefitCmsDiabeticCostShareOption["DiabeticCostShareOptionBypassDedApplyPlan"] = "DIABETIC_COST_SHARE_OPTION_BYPASS_DED_APPLY_PLAN";
    PbmBenefitCmsDiabeticCostShareOption["DiabeticCostShareOptionBypassDedApplyZero"] = "DIABETIC_COST_SHARE_OPTION_BYPASS_DED_APPLY_ZERO";
    PbmBenefitCmsDiabeticCostShareOption["DiabeticCostShareOptionCustom"] = "DIABETIC_COST_SHARE_OPTION_CUSTOM";
    PbmBenefitCmsDiabeticCostShareOption["DiabeticCostShareOptionFollowStandardTiering"] = "DIABETIC_COST_SHARE_OPTION_FOLLOW_STANDARD_TIERING";
    PbmBenefitCmsDiabeticCostShareOption["DiabeticCostShareOptionNotCovered"] = "DIABETIC_COST_SHARE_OPTION_NOT_COVERED";
})(PbmBenefitCmsDiabeticCostShareOption || (PbmBenefitCmsDiabeticCostShareOption = {}));
export var PbmBenefitCmsDifferentialAppliances;
(function (PbmBenefitCmsDifferentialAppliances) {
    PbmBenefitCmsDifferentialAppliances["DaDawOne"] = "DA_DAW_ONE";
    PbmBenefitCmsDifferentialAppliances["DaDawOneTwo"] = "DA_DAW_ONE_TWO";
    PbmBenefitCmsDifferentialAppliances["DaDawTwo"] = "DA_DAW_TWO";
})(PbmBenefitCmsDifferentialAppliances || (PbmBenefitCmsDifferentialAppliances = {}));
export var PbmBenefitCmsDocumentType;
(function (PbmBenefitCmsDocumentType) {
    PbmBenefitCmsDocumentType["DocumentTypeAmendment"] = "DOCUMENT_TYPE_AMENDMENT";
    PbmBenefitCmsDocumentType["DocumentTypeBenefitSummaryDocument"] = "DOCUMENT_TYPE_BENEFIT_SUMMARY_DOCUMENT";
    PbmBenefitCmsDocumentType["DocumentTypeClinicalProgramDocument"] = "DOCUMENT_TYPE_CLINICAL_PROGRAM_DOCUMENT";
    PbmBenefitCmsDocumentType["DocumentTypeImplementationGuide"] = "DOCUMENT_TYPE_IMPLEMENTATION_GUIDE";
    PbmBenefitCmsDocumentType["DocumentTypeMemberCommunication"] = "DOCUMENT_TYPE_MEMBER_COMMUNICATION";
    PbmBenefitCmsDocumentType["DocumentTypeOther"] = "DOCUMENT_TYPE_OTHER";
    PbmBenefitCmsDocumentType["DocumentTypePlanDocument"] = "DOCUMENT_TYPE_PLAN_DOCUMENT";
    PbmBenefitCmsDocumentType["DocumentTypeSummaryOfBenefitsAndCoverage"] = "DOCUMENT_TYPE_SUMMARY_OF_BENEFITS_AND_COVERAGE";
    PbmBenefitCmsDocumentType["DocumentTypeSummaryPlanDescription"] = "DOCUMENT_TYPE_SUMMARY_PLAN_DESCRIPTION";
})(PbmBenefitCmsDocumentType || (PbmBenefitCmsDocumentType = {}));
export var PbmBenefitCmsDrugListOptions;
(function (PbmBenefitCmsDrugListOptions) {
    PbmBenefitCmsDrugListOptions["DrugListOptionsA"] = "DRUG_LIST_OPTIONS_A";
    PbmBenefitCmsDrugListOptions["DrugListOptionsB"] = "DRUG_LIST_OPTIONS_B";
    PbmBenefitCmsDrugListOptions["DrugListOptionsC"] = "DRUG_LIST_OPTIONS_C";
    PbmBenefitCmsDrugListOptions["DrugListOptionsCustom"] = "DRUG_LIST_OPTIONS_CUSTOM";
    PbmBenefitCmsDrugListOptions["DrugListOptionsD"] = "DRUG_LIST_OPTIONS_D";
    PbmBenefitCmsDrugListOptions["DrugListOptionsE"] = "DRUG_LIST_OPTIONS_E";
    PbmBenefitCmsDrugListOptions["DrugListOptionsExpanded"] = "DRUG_LIST_OPTIONS_EXPANDED";
    PbmBenefitCmsDrugListOptions["DrugListOptionsF"] = "DRUG_LIST_OPTIONS_F";
    PbmBenefitCmsDrugListOptions["DrugListOptionsMidCoverageList"] = "DRUG_LIST_OPTIONS_MID_COVERAGE_LIST";
    PbmBenefitCmsDrugListOptions["DrugListOptionsPreventiveCore"] = "DRUG_LIST_OPTIONS_PREVENTIVE_CORE";
    PbmBenefitCmsDrugListOptions["DrugListOptionsPreventivePlus"] = "DRUG_LIST_OPTIONS_PREVENTIVE_PLUS";
    PbmBenefitCmsDrugListOptions["DrugListOptionsPreventivePremier"] = "DRUG_LIST_OPTIONS_PREVENTIVE_PREMIER";
    PbmBenefitCmsDrugListOptions["DrugListOptionsStandard"] = "DRUG_LIST_OPTIONS_STANDARD";
    PbmBenefitCmsDrugListOptions["DrugListOptionsTrudatarx"] = "DRUG_LIST_OPTIONS_TRUDATARX";
})(PbmBenefitCmsDrugListOptions || (PbmBenefitCmsDrugListOptions = {}));
export var PbmBenefitCmsDrugListSourceType;
(function (PbmBenefitCmsDrugListSourceType) {
    PbmBenefitCmsDrugListSourceType["DrugListRightwayStandard"] = "DRUG_LIST_RIGHTWAY_STANDARD";
    PbmBenefitCmsDrugListSourceType["DrugListSourceTypeFile"] = "DRUG_LIST_SOURCE_TYPE_FILE";
    PbmBenefitCmsDrugListSourceType["DrugListSourceTypeUrl"] = "DRUG_LIST_SOURCE_TYPE_URL";
})(PbmBenefitCmsDrugListSourceType || (PbmBenefitCmsDrugListSourceType = {}));
export var PbmBenefitCmsFertilityAccumulationType;
(function (PbmBenefitCmsFertilityAccumulationType) {
    PbmBenefitCmsFertilityAccumulationType["FertilityAccumulationTypeMedicalOnly"] = "FERTILITY_ACCUMULATION_TYPE_MEDICAL_ONLY";
    PbmBenefitCmsFertilityAccumulationType["FertilityAccumulationTypeMedicalPharmacyCombined"] = "FERTILITY_ACCUMULATION_TYPE_MEDICAL_PHARMACY_COMBINED";
    PbmBenefitCmsFertilityAccumulationType["FertilityAccumulationTypeNa"] = "FERTILITY_ACCUMULATION_TYPE_NA";
    PbmBenefitCmsFertilityAccumulationType["FertilityAccumulationTypePharmacyOnly"] = "FERTILITY_ACCUMULATION_TYPE_PHARMACY_ONLY";
    PbmBenefitCmsFertilityAccumulationType["FertilityAccumulationTypeUnspecified"] = "FERTILITY_ACCUMULATION_TYPE_UNSPECIFIED";
})(PbmBenefitCmsFertilityAccumulationType || (PbmBenefitCmsFertilityAccumulationType = {}));
export var PbmBenefitCmsFertilityPeriodOptions;
(function (PbmBenefitCmsFertilityPeriodOptions) {
    PbmBenefitCmsFertilityPeriodOptions["FertilityPeriodOptionsAnnual"] = "FERTILITY_PERIOD_OPTIONS_ANNUAL";
    PbmBenefitCmsFertilityPeriodOptions["FertilityPeriodOptionsLifetime"] = "FERTILITY_PERIOD_OPTIONS_LIFETIME";
    PbmBenefitCmsFertilityPeriodOptions["FertilityPeriodOptionsLifeAnnual"] = "FERTILITY_PERIOD_OPTIONS_LIFE_ANNUAL";
})(PbmBenefitCmsFertilityPeriodOptions || (PbmBenefitCmsFertilityPeriodOptions = {}));
export var PbmBenefitCmsFormularyEnum;
(function (PbmBenefitCmsFormularyEnum) {
    PbmBenefitCmsFormularyEnum["FormularyCustom"] = "FORMULARY_CUSTOM";
    PbmBenefitCmsFormularyEnum["FormularyOpen"] = "FORMULARY_OPEN";
    PbmBenefitCmsFormularyEnum["FormularyPerformance"] = "FORMULARY_PERFORMANCE";
    PbmBenefitCmsFormularyEnum["FormularyTrudatarx"] = "FORMULARY_TRUDATARX";
    PbmBenefitCmsFormularyEnum["FormularyUnspecified"] = "FORMULARY_UNSPECIFIED";
    PbmBenefitCmsFormularyEnum["FormularyValue"] = "FORMULARY_VALUE";
})(PbmBenefitCmsFormularyEnum || (PbmBenefitCmsFormularyEnum = {}));
export var PbmBenefitCmsGlpCoverage;
(function (PbmBenefitCmsGlpCoverage) {
    PbmBenefitCmsGlpCoverage["GlpAll"] = "GLP_ALL";
    PbmBenefitCmsGlpCoverage["GlpNo"] = "GLP_NO";
    PbmBenefitCmsGlpCoverage["GlpSelected"] = "GLP_SELECTED";
})(PbmBenefitCmsGlpCoverage || (PbmBenefitCmsGlpCoverage = {}));
export var PbmBenefitCmsImplementationStatus;
(function (PbmBenefitCmsImplementationStatus) {
    PbmBenefitCmsImplementationStatus["ImplementationStatusComplete"] = "IMPLEMENTATION_STATUS_COMPLETE";
    PbmBenefitCmsImplementationStatus["ImplementationStatusInProgress"] = "IMPLEMENTATION_STATUS_IN_PROGRESS";
    PbmBenefitCmsImplementationStatus["ImplementationStatusNotStarted"] = "IMPLEMENTATION_STATUS_NOT_STARTED";
    PbmBenefitCmsImplementationStatus["ImplementationStatusOnHold"] = "IMPLEMENTATION_STATUS_ON_HOLD";
})(PbmBenefitCmsImplementationStatus || (PbmBenefitCmsImplementationStatus = {}));
export var PbmBenefitCmsInternalCommentType;
(function (PbmBenefitCmsInternalCommentType) {
    PbmBenefitCmsInternalCommentType["InternalCommentTypeConcern"] = "INTERNAL_COMMENT_TYPE_CONCERN";
    PbmBenefitCmsInternalCommentType["InternalCommentTypeGeneral"] = "INTERNAL_COMMENT_TYPE_GENERAL";
    PbmBenefitCmsInternalCommentType["InternalCommentTypeQuestion"] = "INTERNAL_COMMENT_TYPE_QUESTION";
    PbmBenefitCmsInternalCommentType["InternalCommentTypeSuggestion"] = "INTERNAL_COMMENT_TYPE_SUGGESTION";
    PbmBenefitCmsInternalCommentType["InternalCommentTypeUnspecified"] = "INTERNAL_COMMENT_TYPE_UNSPECIFIED";
})(PbmBenefitCmsInternalCommentType || (PbmBenefitCmsInternalCommentType = {}));
export var PbmBenefitCmsLinkType;
(function (PbmBenefitCmsLinkType) {
    PbmBenefitCmsLinkType["LinkTypeBenefitInformation"] = "LINK_TYPE_BENEFIT_INFORMATION";
    PbmBenefitCmsLinkType["LinkTypeClientPortal"] = "LINK_TYPE_CLIENT_PORTAL";
    PbmBenefitCmsLinkType["LinkTypeEnrollmentSite"] = "LINK_TYPE_ENROLLMENT_SITE";
    PbmBenefitCmsLinkType["LinkTypeFormulary"] = "LINK_TYPE_FORMULARY";
    PbmBenefitCmsLinkType["LinkTypeMemberPortal"] = "LINK_TYPE_MEMBER_PORTAL";
    PbmBenefitCmsLinkType["LinkTypeOther"] = "LINK_TYPE_OTHER";
    PbmBenefitCmsLinkType["LinkTypeProviderDirectory"] = "LINK_TYPE_PROVIDER_DIRECTORY";
})(PbmBenefitCmsLinkType || (PbmBenefitCmsLinkType = {}));
export var PbmBenefitCmsLoadFrequency;
(function (PbmBenefitCmsLoadFrequency) {
    PbmBenefitCmsLoadFrequency["LoadFrequencyBiWeekly"] = "LOAD_FREQUENCY_BI_WEEKLY";
    PbmBenefitCmsLoadFrequency["LoadFrequencyDaily"] = "LOAD_FREQUENCY_DAILY";
    PbmBenefitCmsLoadFrequency["LoadFrequencyMonthly"] = "LOAD_FREQUENCY_MONTHLY";
    PbmBenefitCmsLoadFrequency["LoadFrequencyWeekly"] = "LOAD_FREQUENCY_WEEKLY";
})(PbmBenefitCmsLoadFrequency || (PbmBenefitCmsLoadFrequency = {}));
export var PbmBenefitCmsMoopType;
(function (PbmBenefitCmsMoopType) {
    PbmBenefitCmsMoopType["MoopTypeEmbedded"] = "MOOP_TYPE_EMBEDDED";
    PbmBenefitCmsMoopType["MoopTypeNonEmbedded"] = "MOOP_TYPE_NON_EMBEDDED";
    PbmBenefitCmsMoopType["MoopTypeNoPharmacy"] = "MOOP_TYPE_NO_PHARMACY";
})(PbmBenefitCmsMoopType || (PbmBenefitCmsMoopType = {}));
export var PbmBenefitCmsMedicationsCoverage;
(function (PbmBenefitCmsMedicationsCoverage) {
    PbmBenefitCmsMedicationsCoverage["MedAll"] = "MED_ALL";
    PbmBenefitCmsMedicationsCoverage["MedNo"] = "MED_NO";
    PbmBenefitCmsMedicationsCoverage["MedSelected"] = "MED_SELECTED";
})(PbmBenefitCmsMedicationsCoverage || (PbmBenefitCmsMedicationsCoverage = {}));
export var PbmBenefitCmsMobileAppType;
(function (PbmBenefitCmsMobileAppType) {
    PbmBenefitCmsMobileAppType["MobileAppTypeCustomEmployerApp"] = "MOBILE_APP_TYPE_CUSTOM_EMPLOYER_APP";
    PbmBenefitCmsMobileAppType["MobileAppTypeNone"] = "MOBILE_APP_TYPE_NONE";
    PbmBenefitCmsMobileAppType["MobileAppTypeRightwayMobileApp"] = "MOBILE_APP_TYPE_RIGHTWAY_MOBILE_APP";
    PbmBenefitCmsMobileAppType["MobileAppTypeThirdPartyApp"] = "MOBILE_APP_TYPE_THIRD_PARTY_APP";
})(PbmBenefitCmsMobileAppType || (PbmBenefitCmsMobileAppType = {}));
/** Order direction */
export var PbmBenefitCmsOrderDirection;
(function (PbmBenefitCmsOrderDirection) {
    PbmBenefitCmsOrderDirection["Asc"] = "ASC";
    PbmBenefitCmsOrderDirection["Desc"] = "DESC";
})(PbmBenefitCmsOrderDirection || (PbmBenefitCmsOrderDirection = {}));
export var PbmBenefitCmsPlanStatusEnum;
(function (PbmBenefitCmsPlanStatusEnum) {
    PbmBenefitCmsPlanStatusEnum["PlanStatusDraft"] = "PLAN_STATUS_DRAFT";
    PbmBenefitCmsPlanStatusEnum["PlanStatusPublished"] = "PLAN_STATUS_PUBLISHED";
    PbmBenefitCmsPlanStatusEnum["PlanStatusReview"] = "PLAN_STATUS_REVIEW";
    PbmBenefitCmsPlanStatusEnum["PlanStatusUnspecified"] = "PLAN_STATUS_UNSPECIFIED";
})(PbmBenefitCmsPlanStatusEnum || (PbmBenefitCmsPlanStatusEnum = {}));
export var PbmBenefitCmsPlanTab;
(function (PbmBenefitCmsPlanTab) {
    PbmBenefitCmsPlanTab["PlanTabAccumulators"] = "PLAN_TAB_ACCUMULATORS";
    PbmBenefitCmsPlanTab["PlanTabClientInfo"] = "PLAN_TAB_CLIENT_INFO";
    PbmBenefitCmsPlanTab["PlanTabCostSharing"] = "PLAN_TAB_COST_SHARING";
    PbmBenefitCmsPlanTab["PlanTabDaw"] = "PLAN_TAB_DAW";
    PbmBenefitCmsPlanTab["PlanTabDrugCoverage"] = "PLAN_TAB_DRUG_COVERAGE";
    PbmBenefitCmsPlanTab["PlanTabDrugList"] = "PLAN_TAB_DRUG_LIST";
    PbmBenefitCmsPlanTab["PlanTabExpandedPreventiveList"] = "PLAN_TAB_EXPANDED_PREVENTIVE_LIST";
    PbmBenefitCmsPlanTab["PlanTabPharmacyBenefitLimits"] = "PLAN_TAB_PHARMACY_BENEFIT_LIMITS";
    PbmBenefitCmsPlanTab["PlanTabPlanConfig"] = "PLAN_TAB_PLAN_CONFIG";
    PbmBenefitCmsPlanTab["PlanTabPrograms"] = "PLAN_TAB_PROGRAMS";
    PbmBenefitCmsPlanTab["PlanTabRightwayStandard"] = "PLAN_TAB_RIGHTWAY_STANDARD";
    PbmBenefitCmsPlanTab["PlanTabUnspecified"] = "PLAN_TAB_UNSPECIFIED";
})(PbmBenefitCmsPlanTab || (PbmBenefitCmsPlanTab = {}));
export var PbmBenefitCmsPlanTypeEnum;
(function (PbmBenefitCmsPlanTypeEnum) {
    PbmBenefitCmsPlanTypeEnum["PlanTypeCopay"] = "PLAN_TYPE_COPAY";
    PbmBenefitCmsPlanTypeEnum["PlanTypeEpo"] = "PLAN_TYPE_EPO";
    PbmBenefitCmsPlanTypeEnum["PlanTypeHdhp"] = "PLAN_TYPE_HDHP";
    PbmBenefitCmsPlanTypeEnum["PlanTypeHmo"] = "PLAN_TYPE_HMO";
    PbmBenefitCmsPlanTypeEnum["PlanTypeHsa"] = "PLAN_TYPE_HSA";
    PbmBenefitCmsPlanTypeEnum["PlanTypeIndemnity"] = "PLAN_TYPE_INDEMNITY";
    PbmBenefitCmsPlanTypeEnum["PlanTypeOther"] = "PLAN_TYPE_OTHER";
    PbmBenefitCmsPlanTypeEnum["PlanTypePos"] = "PLAN_TYPE_POS";
    PbmBenefitCmsPlanTypeEnum["PlanTypePpo"] = "PLAN_TYPE_PPO";
    PbmBenefitCmsPlanTypeEnum["PlanTypeRbp"] = "PLAN_TYPE_RBP";
    PbmBenefitCmsPlanTypeEnum["PlanTypeRxOnly"] = "PLAN_TYPE_RX_ONLY";
    PbmBenefitCmsPlanTypeEnum["PlanTypeUnspecified"] = "PLAN_TYPE_UNSPECIFIED";
})(PbmBenefitCmsPlanTypeEnum || (PbmBenefitCmsPlanTypeEnum = {}));
export var PbmBenefitCmsProgramTypeEnum;
(function (PbmBenefitCmsProgramTypeEnum) {
    PbmBenefitCmsProgramTypeEnum["ProgramTypeAltSpecialty"] = "PROGRAM_TYPE_ALT_SPECIALTY";
    PbmBenefitCmsProgramTypeEnum["ProgramTypeCapSpecialty"] = "PROGRAM_TYPE_CAP_SPECIALTY";
    PbmBenefitCmsProgramTypeEnum["ProgramTypeDiabetes"] = "PROGRAM_TYPE_DIABETES";
    PbmBenefitCmsProgramTypeEnum["ProgramTypeExpandedPreventiveList"] = "PROGRAM_TYPE_EXPANDED_PREVENTIVE_LIST";
    PbmBenefitCmsProgramTypeEnum["ProgramTypeMedicalSpecialty"] = "PROGRAM_TYPE_MEDICAL_SPECIALTY";
    PbmBenefitCmsProgramTypeEnum["ProgramTypeOther"] = "PROGRAM_TYPE_OTHER";
    PbmBenefitCmsProgramTypeEnum["ProgramTypeUnspecified"] = "PROGRAM_TYPE_UNSPECIFIED";
    PbmBenefitCmsProgramTypeEnum["ProgramTypeWeightLoss"] = "PROGRAM_TYPE_WEIGHT_LOSS";
})(PbmBenefitCmsProgramTypeEnum || (PbmBenefitCmsProgramTypeEnum = {}));
export var PbmBenefitCmsRightwayStandardProgramTypeEnum;
(function (PbmBenefitCmsRightwayStandardProgramTypeEnum) {
    PbmBenefitCmsRightwayStandardProgramTypeEnum["ProgramTypeAltSpecialty"] = "PROGRAM_TYPE_ALT_SPECIALTY";
    PbmBenefitCmsRightwayStandardProgramTypeEnum["ProgramTypeCapSpecialty"] = "PROGRAM_TYPE_CAP_SPECIALTY";
    PbmBenefitCmsRightwayStandardProgramTypeEnum["ProgramTypeDiabetes"] = "PROGRAM_TYPE_DIABETES";
    PbmBenefitCmsRightwayStandardProgramTypeEnum["ProgramTypeExpandedPreventiveList"] = "PROGRAM_TYPE_EXPANDED_PREVENTIVE_LIST";
    PbmBenefitCmsRightwayStandardProgramTypeEnum["ProgramTypeMedicalSpecialty"] = "PROGRAM_TYPE_MEDICAL_SPECIALTY";
    PbmBenefitCmsRightwayStandardProgramTypeEnum["ProgramTypeUnspecified"] = "PROGRAM_TYPE_UNSPECIFIED";
    PbmBenefitCmsRightwayStandardProgramTypeEnum["ProgramTypeWeightLoss"] = "PROGRAM_TYPE_WEIGHT_LOSS";
})(PbmBenefitCmsRightwayStandardProgramTypeEnum || (PbmBenefitCmsRightwayStandardProgramTypeEnum = {}));
export var PbmBenefitCmsTempPharmacyCoverage;
(function (PbmBenefitCmsTempPharmacyCoverage) {
    PbmBenefitCmsTempPharmacyCoverage["TempPharmacyCoverageNa"] = "TEMP_PHARMACY_COVERAGE_NA";
    PbmBenefitCmsTempPharmacyCoverage["TempPharmacyCoverageStandardTiering"] = "TEMP_PHARMACY_COVERAGE_STANDARD_TIERING";
    PbmBenefitCmsTempPharmacyCoverage["TempPharmacyCoverageTier_4"] = "TEMP_PHARMACY_COVERAGE_TIER_4";
    PbmBenefitCmsTempPharmacyCoverage["TempPharmacyCoverageUnspecified"] = "TEMP_PHARMACY_COVERAGE_UNSPECIFIED";
})(PbmBenefitCmsTempPharmacyCoverage || (PbmBenefitCmsTempPharmacyCoverage = {}));
export var PbmBenefitCmsTierColumnType;
(function (PbmBenefitCmsTierColumnType) {
    PbmBenefitCmsTierColumnType["TierColumnFacilitySpecific"] = "TIER_COLUMN_FACILITY_SPECIFIC";
    PbmBenefitCmsTierColumnType["TierColumnHomeDelivery"] = "TIER_COLUMN_HOME_DELIVERY";
    PbmBenefitCmsTierColumnType["TierColumnMail"] = "TIER_COLUMN_MAIL";
    PbmBenefitCmsTierColumnType["TierColumnOther"] = "TIER_COLUMN_OTHER";
    PbmBenefitCmsTierColumnType["TierColumnRetail"] = "TIER_COLUMN_RETAIL";
    PbmBenefitCmsTierColumnType["TierColumnRetailMail"] = "TIER_COLUMN_RETAIL_MAIL";
    PbmBenefitCmsTierColumnType["TierColumnSpecialty"] = "TIER_COLUMN_SPECIALTY";
})(PbmBenefitCmsTierColumnType || (PbmBenefitCmsTierColumnType = {}));
export var PbmBenefitCmsTierRowType;
(function (PbmBenefitCmsTierRowType) {
    PbmBenefitCmsTierRowType["TierRowInNetwork"] = "TIER_ROW_IN_NETWORK";
    PbmBenefitCmsTierRowType["TierRowInSpecialty"] = "TIER_ROW_IN_SPECIALTY";
    PbmBenefitCmsTierRowType["TierRowOther"] = "TIER_ROW_OTHER";
    PbmBenefitCmsTierRowType["TierRowOutOfNetwork"] = "TIER_ROW_OUT_OF_NETWORK";
    PbmBenefitCmsTierRowType["TierRowOutSpecialty"] = "TIER_ROW_OUT_SPECIALTY";
})(PbmBenefitCmsTierRowType || (PbmBenefitCmsTierRowType = {}));
export var PbmBenefitCmsTiers;
(function (PbmBenefitCmsTiers) {
    PbmBenefitCmsTiers["TierFive"] = "TIER_FIVE";
    PbmBenefitCmsTiers["TierFour"] = "TIER_FOUR";
    PbmBenefitCmsTiers["TierNo"] = "TIER_NO";
    PbmBenefitCmsTiers["TierOne"] = "TIER_ONE";
    PbmBenefitCmsTiers["TierSix"] = "TIER_SIX";
    PbmBenefitCmsTiers["TierThree"] = "TIER_THREE";
    PbmBenefitCmsTiers["TierTwo"] = "TIER_TWO";
})(PbmBenefitCmsTiers || (PbmBenefitCmsTiers = {}));
export var PbmBenefitCmsUserType;
(function (PbmBenefitCmsUserType) {
    PbmBenefitCmsUserType["UserTypeAdvocate"] = "USER_TYPE_ADVOCATE";
    PbmBenefitCmsUserType["UserTypeClientUser"] = "USER_TYPE_CLIENT_USER";
    PbmBenefitCmsUserType["UserTypeUnspecified"] = "USER_TYPE_UNSPECIFIED";
})(PbmBenefitCmsUserType || (PbmBenefitCmsUserType = {}));
export var PbmBenefitCmsValidationSeverityEnum;
(function (PbmBenefitCmsValidationSeverityEnum) {
    PbmBenefitCmsValidationSeverityEnum["ValidationSeverityCriticalError"] = "VALIDATION_SEVERITY_CRITICAL_ERROR";
    PbmBenefitCmsValidationSeverityEnum["ValidationSeverityMissingOptional"] = "VALIDATION_SEVERITY_MISSING_OPTIONAL";
    PbmBenefitCmsValidationSeverityEnum["ValidationSeverityMissingRecommended"] = "VALIDATION_SEVERITY_MISSING_RECOMMENDED";
    PbmBenefitCmsValidationSeverityEnum["ValidationSeverityNeedsReview"] = "VALIDATION_SEVERITY_NEEDS_REVIEW";
    PbmBenefitCmsValidationSeverityEnum["ValidationSeverityUnspecified"] = "VALIDATION_SEVERITY_UNSPECIFIED";
    PbmBenefitCmsValidationSeverityEnum["ValidationSeverityWarning"] = "VALIDATION_SEVERITY_WARNING";
})(PbmBenefitCmsValidationSeverityEnum || (PbmBenefitCmsValidationSeverityEnum = {}));
export var PbmBenefitCmsWeightLossOptionsEnum;
(function (PbmBenefitCmsWeightLossOptionsEnum) {
    PbmBenefitCmsWeightLossOptionsEnum["WeightLossOptionsAll"] = "WEIGHT_LOSS_OPTIONS_ALL";
    PbmBenefitCmsWeightLossOptionsEnum["WeightLossOptionsNo"] = "WEIGHT_LOSS_OPTIONS_NO";
    PbmBenefitCmsWeightLossOptionsEnum["WeightLossOptionsSelected"] = "WEIGHT_LOSS_OPTIONS_SELECTED";
    PbmBenefitCmsWeightLossOptionsEnum["WeightLossOptionsUnspecified"] = "WEIGHT_LOSS_OPTIONS_UNSPECIFIED";
})(PbmBenefitCmsWeightLossOptionsEnum || (PbmBenefitCmsWeightLossOptionsEnum = {}));
export var PbmBenefitCmsWorkflowStatus;
(function (PbmBenefitCmsWorkflowStatus) {
    PbmBenefitCmsWorkflowStatus["WorkflowStatusClientApproved"] = "WORKFLOW_STATUS_CLIENT_APPROVED";
    PbmBenefitCmsWorkflowStatus["WorkflowStatusClientReview"] = "WORKFLOW_STATUS_CLIENT_REVIEW";
    PbmBenefitCmsWorkflowStatus["WorkflowStatusFinalized"] = "WORKFLOW_STATUS_FINALIZED";
    PbmBenefitCmsWorkflowStatus["WorkflowStatusInternalApproval"] = "WORKFLOW_STATUS_INTERNAL_APPROVAL";
    PbmBenefitCmsWorkflowStatus["WorkflowStatusInternalReview"] = "WORKFLOW_STATUS_INTERNAL_REVIEW";
    PbmBenefitCmsWorkflowStatus["WorkflowStatusPendingSignature"] = "WORKFLOW_STATUS_PENDING_SIGNATURE";
    PbmBenefitCmsWorkflowStatus["WorkflowStatusUnspecified"] = "WORKFLOW_STATUS_UNSPECIFIED";
})(PbmBenefitCmsWorkflowStatus || (PbmBenefitCmsWorkflowStatus = {}));
/** Resource permissions checkable via the permission-check endpoint. */
export var PermissionName;
(function (PermissionName) {
    PermissionName["AdministerEmployees"] = "ADMINISTER_EMPLOYEES";
    PermissionName["CreateInvites"] = "CREATE_INVITES";
    PermissionName["ManageArticles"] = "MANAGE_ARTICLES";
    PermissionName["ManageChats"] = "MANAGE_CHATS";
    PermissionName["ManageClaims"] = "MANAGE_CLAIMS";
    PermissionName["ManageEmployees"] = "MANAGE_EMPLOYEES";
    PermissionName["ManageIntakeQueues"] = "MANAGE_INTAKE_QUEUES";
    PermissionName["ManageIntakeTags"] = "MANAGE_INTAKE_TAGS";
    PermissionName["ManagePharmacyPlan"] = "MANAGE_PHARMACY_PLAN";
    PermissionName["ManageRoadmaps"] = "MANAGE_ROADMAPS";
    PermissionName["ManageTasks"] = "MANAGE_TASKS";
    PermissionName["ManageTickets"] = "MANAGE_TICKETS";
    PermissionName["ManageUsers"] = "MANAGE_USERS";
    PermissionName["ViewAppointments"] = "VIEW_APPOINTMENTS";
    PermissionName["ViewArticles"] = "VIEW_ARTICLES";
    PermissionName["ViewCarePods"] = "VIEW_CARE_PODS";
    PermissionName["ViewChats"] = "VIEW_CHATS";
    PermissionName["ViewClaims"] = "VIEW_CLAIMS";
    PermissionName["ViewEmployees"] = "VIEW_EMPLOYEES";
    PermissionName["ViewInsurancePlans"] = "VIEW_INSURANCE_PLANS";
    PermissionName["ViewInteractions"] = "VIEW_INTERACTIONS";
    PermissionName["ViewInvites"] = "VIEW_INVITES";
    PermissionName["ViewOrganizations"] = "VIEW_ORGANIZATIONS";
    PermissionName["ViewPharmacyPlan"] = "VIEW_PHARMACY_PLAN";
    PermissionName["ViewRoadmaps"] = "VIEW_ROADMAPS";
    PermissionName["ViewTasks"] = "VIEW_TASKS";
    PermissionName["ViewTickets"] = "VIEW_TICKETS";
    PermissionName["ViewUploads"] = "VIEW_UPLOADS";
    PermissionName["ViewUsers"] = "VIEW_USERS";
})(PermissionName || (PermissionName = {}));
/** Resource types supported by the permission-check endpoint. */
export var PermissionResourceType;
(function (PermissionResourceType) {
    PermissionResourceType["Claim"] = "CLAIM";
    PermissionResourceType["Employee"] = "EMPLOYEE";
    PermissionResourceType["Organization"] = "ORGANIZATION";
    PermissionResourceType["Roadmap"] = "ROADMAP";
    PermissionResourceType["Task"] = "TASK";
    PermissionResourceType["Ticket"] = "TICKET";
})(PermissionResourceType || (PermissionResourceType = {}));
export var PharmacyTypeEnum;
(function (PharmacyTypeEnum) {
    PharmacyTypeEnum["Alto"] = "ALTO";
    PharmacyTypeEnum["BswhMo"] = "BSWH_MO";
    PharmacyTypeEnum["BswhSpecialty"] = "BSWH_SPECIALTY";
    PharmacyTypeEnum["Cvs"] = "CVS";
    PharmacyTypeEnum["MarkCuban"] = "MARK_CUBAN";
    PharmacyTypeEnum["Moog"] = "MOOG";
    PharmacyTypeEnum["OuHealth"] = "OU_HEALTH";
    PharmacyTypeEnum["Retail"] = "RETAIL";
    PharmacyTypeEnum["UnspecifiedType"] = "UNSPECIFIED_TYPE";
    PharmacyTypeEnum["Walgreens"] = "WALGREENS";
    PharmacyTypeEnum["Welldyne"] = "WELLDYNE";
})(PharmacyTypeEnum || (PharmacyTypeEnum = {}));
/** Possible plan benefit values. */
export var PlanBenefitValueType;
(function (PlanBenefitValueType) {
    PlanBenefitValueType["Money"] = "money";
    PlanBenefitValueType["Percent"] = "percent";
    PlanBenefitValueType["Text"] = "text";
})(PlanBenefitValueType || (PlanBenefitValueType = {}));
/** Possible plan categories. */
export var PlanCategoryType;
(function (PlanCategoryType) {
    /** Behavioral */
    PlanCategoryType["Behavioral"] = "behavioral";
    /** Dental care */
    PlanCategoryType["DentalCare"] = "dental_care";
    /** Medical behavioral */
    PlanCategoryType["MedicalBehavioral"] = "medical_behavioral";
    /** Medical care */
    PlanCategoryType["MedicalCare"] = "medical_care";
    /** Pharmacy */
    PlanCategoryType["Pharmacy"] = "pharmacy";
    /** Vision care */
    PlanCategoryType["VisionCare"] = "vision_care";
})(PlanCategoryType || (PlanCategoryType = {}));
/** Possible plan definitions. */
export var PlanDefinitionType;
(function (PlanDefinitionType) {
    /** Carrier name */
    PlanDefinitionType["CarrierName"] = "carrier_name";
    /** Co insurance */
    PlanDefinitionType["CoInsurance"] = "co_insurance";
    /** Copay */
    PlanDefinitionType["Copay"] = "copay";
    /** Deductible */
    PlanDefinitionType["Deductible"] = "deductible";
    /** HIPAA authorization */
    PlanDefinitionType["HipaaAuthorization"] = "hipaa_authorization";
    /** Out of pocket max */
    PlanDefinitionType["OutOfPocketMax"] = "out_of_pocket_max";
    /** Plan availability */
    PlanDefinitionType["PlanAvailability"] = "plan_availability";
    /** Plan category */
    PlanDefinitionType["PlanCategory"] = "plan_category";
    /** Plan contact options */
    PlanDefinitionType["PlanContactOptions"] = "plan_contact_options";
    /** Plan display name */
    PlanDefinitionType["PlanDisplayName"] = "plan_display_name";
    /** Plan eligibility file */
    PlanDefinitionType["PlanEligibilityFile"] = "plan_eligibility_file";
    /** Plan end date */
    PlanDefinitionType["PlanEndDate"] = "plan_end_date";
    /** Plan start date */
    PlanDefinitionType["PlanStartDate"] = "plan_start_date";
    /** Plan status */
    PlanDefinitionType["PlanStatus"] = "plan_status";
    /** Plan tiers */
    PlanDefinitionType["PlanTiers"] = "plan_tiers";
})(PlanDefinitionType || (PlanDefinitionType = {}));
export var ProductOptions;
(function (ProductOptions) {
    /** Joint (PBM + Nav) */
    ProductOptions["CoreAndPbm"] = "core_and_pbm";
    /** Nav Only */
    ProductOptions["OnlyCore"] = "only_core";
    /** PBM Only */
    ProductOptions["OnlyPbm"] = "only_pbm";
})(ProductOptions || (ProductOptions = {}));
/** Type of provider */
export var ProviderType;
(function (ProviderType) {
    ProviderType["Clinic"] = "CLINIC";
    ProviderType["Compounding"] = "COMPOUNDING";
    ProviderType["CustomizedEquipment"] = "CUSTOMIZED_EQUIPMENT";
    ProviderType["DialysisEquipment"] = "DIALYSIS_EQUIPMENT";
    ProviderType["DmeSupplier"] = "DME_SUPPLIER";
    ProviderType["HomeInfusionTherapy"] = "HOME_INFUSION_THERAPY";
    ProviderType["IndianHealthService"] = "INDIAN_HEALTH_SERVICE";
    ProviderType["InstitutionalPharmacy"] = "INSTITUTIONAL_PHARMACY";
    ProviderType["LongTermCare"] = "LONG_TERM_CARE";
    ProviderType["MailOrder"] = "MAIL_ORDER";
    ProviderType["ManagedCareOrganization"] = "MANAGED_CARE_ORGANIZATION";
    ProviderType["Military"] = "MILITARY";
    ProviderType["NonPharmacyDispensing"] = "NON_PHARMACY_DISPENSING";
    ProviderType["Nuclear"] = "NUCLEAR";
    ProviderType["NursingFacilitySupplies"] = "NURSING_FACILITY_SUPPLIES";
    ProviderType["OxygenEquipment"] = "OXYGEN_EQUIPMENT";
    ProviderType["ParenteralNutrition"] = "PARENTERAL_NUTRITION";
    ProviderType["ProviderTypeUnspecified"] = "PROVIDER_TYPE_UNSPECIFIED";
    ProviderType["RetailPharmacy"] = "RETAIL_PHARMACY";
    ProviderType["Specialty"] = "SPECIALTY";
    ProviderType["VeteransAffairs"] = "VETERANS_AFFAIRS";
})(ProviderType || (ProviderType = {}));
export var Queue_System_Audit_Log_Action_Type;
(function (Queue_System_Audit_Log_Action_Type) {
    /** Group activated */
    Queue_System_Audit_Log_Action_Type["GroupActivated"] = "group_activated";
    /** Group counters reset */
    Queue_System_Audit_Log_Action_Type["GroupCountersReset"] = "group_counters_reset";
    /** Group created */
    Queue_System_Audit_Log_Action_Type["GroupCreated"] = "group_created";
    /** Group deactivated */
    Queue_System_Audit_Log_Action_Type["GroupDeactivated"] = "group_deactivated";
    /** Group destroyed */
    Queue_System_Audit_Log_Action_Type["GroupDestroyed"] = "group_destroyed";
    /** Group queues reranked */
    Queue_System_Audit_Log_Action_Type["GroupQueuesReranked"] = "group_queues_reranked";
    /** Group updated */
    Queue_System_Audit_Log_Action_Type["GroupUpdated"] = "group_updated";
    /** Group users added */
    Queue_System_Audit_Log_Action_Type["GroupUsersAdded"] = "group_users_added";
    /** Group users removed */
    Queue_System_Audit_Log_Action_Type["GroupUsersRemoved"] = "group_users_removed";
    /** Queue activated */
    Queue_System_Audit_Log_Action_Type["QueueActivated"] = "queue_activated";
    /** Queue counters reset */
    Queue_System_Audit_Log_Action_Type["QueueCountersReset"] = "queue_counters_reset";
    /** Queue created */
    Queue_System_Audit_Log_Action_Type["QueueCreated"] = "queue_created";
    /** Queue deactivated */
    Queue_System_Audit_Log_Action_Type["QueueDeactivated"] = "queue_deactivated";
    /** Queue destroyed */
    Queue_System_Audit_Log_Action_Type["QueueDestroyed"] = "queue_destroyed";
    /** Queue reordered */
    Queue_System_Audit_Log_Action_Type["QueueReordered"] = "queue_reordered";
    /** Queue updated */
    Queue_System_Audit_Log_Action_Type["QueueUpdated"] = "queue_updated";
    /** Queue users added */
    Queue_System_Audit_Log_Action_Type["QueueUsersAdded"] = "queue_users_added";
    /** Queue users removed */
    Queue_System_Audit_Log_Action_Type["QueueUsersRemoved"] = "queue_users_removed";
    /** Tag activated */
    Queue_System_Audit_Log_Action_Type["TagActivated"] = "tag_activated";
    /** Tag assigned */
    Queue_System_Audit_Log_Action_Type["TagAssigned"] = "tag_assigned";
    /** Tag counters reset */
    Queue_System_Audit_Log_Action_Type["TagCountersReset"] = "tag_counters_reset";
    /** Tag created */
    Queue_System_Audit_Log_Action_Type["TagCreated"] = "tag_created";
    /** Tag deactivated */
    Queue_System_Audit_Log_Action_Type["TagDeactivated"] = "tag_deactivated";
    /** Tag destroyed */
    Queue_System_Audit_Log_Action_Type["TagDestroyed"] = "tag_destroyed";
    /** Tag updated */
    Queue_System_Audit_Log_Action_Type["TagUpdated"] = "tag_updated";
    /** Toggle */
    Queue_System_Audit_Log_Action_Type["Toggle"] = "toggle";
})(Queue_System_Audit_Log_Action_Type || (Queue_System_Audit_Log_Action_Type = {}));
export var Queue_System_Audit_Log_Order;
(function (Queue_System_Audit_Log_Order) {
    /** Ascending sort by 'id' field. */
    Queue_System_Audit_Log_Order["Id"] = "id";
    /** Descending sort by 'id' field. */
    Queue_System_Audit_Log_Order["ReverseId"] = "reverse_id";
})(Queue_System_Audit_Log_Order || (Queue_System_Audit_Log_Order = {}));
/** Account type of an employee record */
export var Registration_Status;
(function (Registration_Status) {
    /** Member */
    Registration_Status["Member"] = "member";
    /** Staff */
    Registration_Status["Staff"] = "staff";
    /** Unregistered */
    Registration_Status["Unregistered"] = "unregistered";
})(Registration_Status || (Registration_Status = {}));
/** Possible RibbonHealth doctor's education type. */
export var Ribbon_Health_Education_Type;
(function (Ribbon_Health_Education_Type) {
    /** Dental School */
    Ribbon_Health_Education_Type["DentalSchool"] = "DENTAL_SCHOOL";
    /** Fellowship */
    Ribbon_Health_Education_Type["Fellowship"] = "FELLOWSHIP";
    /** Graduate School */
    Ribbon_Health_Education_Type["GraduateSchool"] = "GRADUATE_SCHOOL";
    /** Internship */
    Ribbon_Health_Education_Type["Internship"] = "INTERNSHIP";
    /** Medical School */
    Ribbon_Health_Education_Type["MedicalSchool"] = "MEDICAL_SCHOOL";
    /** Other */
    Ribbon_Health_Education_Type["Other"] = "OTHER";
    /** Residency */
    Ribbon_Health_Education_Type["Residency"] = "RESIDENCY";
    /** School */
    Ribbon_Health_Education_Type["School"] = "SCHOOL";
    /** Undergraduate School */
    Ribbon_Health_Education_Type["UndergraduateSchool"] = "UNDERGRADUATE_SCHOOL";
})(Ribbon_Health_Education_Type || (Ribbon_Health_Education_Type = {}));
/** Possible names for searh for doctor by language. */
export var Ribbon_Health_Language_Search_Name;
(function (Ribbon_Health_Language_Search_Name) {
    /** Abkhazian */
    Ribbon_Health_Language_Search_Name["Abkhazian"] = "abkhazian";
    /** Afar */
    Ribbon_Health_Language_Search_Name["Afar"] = "afar";
    /** Afrikaans */
    Ribbon_Health_Language_Search_Name["Afrikaans"] = "afrikaans";
    /** Akan */
    Ribbon_Health_Language_Search_Name["Akan"] = "akan";
    /** Albanian */
    Ribbon_Health_Language_Search_Name["Albanian"] = "albanian";
    /** Amharic */
    Ribbon_Health_Language_Search_Name["Amharic"] = "amharic";
    /** Arabic */
    Ribbon_Health_Language_Search_Name["Arabic"] = "arabic";
    /** Aragonese */
    Ribbon_Health_Language_Search_Name["Aragonese"] = "aragonese";
    /** Armenian */
    Ribbon_Health_Language_Search_Name["Armenian"] = "armenian";
    /** Assamese */
    Ribbon_Health_Language_Search_Name["Assamese"] = "assamese";
    /** Avaric */
    Ribbon_Health_Language_Search_Name["Avaric"] = "avaric";
    /** Avestan */
    Ribbon_Health_Language_Search_Name["Avestan"] = "avestan";
    /** Aymara */
    Ribbon_Health_Language_Search_Name["Aymara"] = "aymara";
    /** Azerbaijani */
    Ribbon_Health_Language_Search_Name["Azerbaijani"] = "azerbaijani";
    /** Bambara */
    Ribbon_Health_Language_Search_Name["Bambara"] = "bambara";
    /** Bashkir */
    Ribbon_Health_Language_Search_Name["Bashkir"] = "bashkir";
    /** Basque */
    Ribbon_Health_Language_Search_Name["Basque"] = "basque";
    /** Belarusian */
    Ribbon_Health_Language_Search_Name["Belarusian"] = "belarusian";
    /** Bengali */
    Ribbon_Health_Language_Search_Name["Bengali"] = "bengali";
    /** Bislama */
    Ribbon_Health_Language_Search_Name["Bislama"] = "bislama";
    /** Bosnian */
    Ribbon_Health_Language_Search_Name["Bosnian"] = "bosnian";
    /** Breton */
    Ribbon_Health_Language_Search_Name["Breton"] = "breton";
    /** Bulgarian */
    Ribbon_Health_Language_Search_Name["Bulgarian"] = "bulgarian";
    /** Burmese */
    Ribbon_Health_Language_Search_Name["Burmese"] = "burmese";
    /** Cambodian */
    Ribbon_Health_Language_Search_Name["Cambodian"] = "cambodian";
    /** Chamorro */
    Ribbon_Health_Language_Search_Name["Chamorro"] = "chamorro";
    /** Chechen */
    Ribbon_Health_Language_Search_Name["Chechen"] = "chechen";
    /** Chinese */
    Ribbon_Health_Language_Search_Name["Chinese"] = "chinese";
    /** Chuvash */
    Ribbon_Health_Language_Search_Name["Chuvash"] = "chuvash";
    /** Cornish */
    Ribbon_Health_Language_Search_Name["Cornish"] = "cornish";
    /** Corsican */
    Ribbon_Health_Language_Search_Name["Corsican"] = "corsican";
    /** Cree */
    Ribbon_Health_Language_Search_Name["Cree"] = "cree";
    /** Croatian */
    Ribbon_Health_Language_Search_Name["Croatian"] = "croatian";
    /** Czech */
    Ribbon_Health_Language_Search_Name["Czech"] = "czech";
    /** Danish */
    Ribbon_Health_Language_Search_Name["Danish"] = "danish";
    /** Dzongkha */
    Ribbon_Health_Language_Search_Name["Dzongkha"] = "dzongkha";
    /** English */
    Ribbon_Health_Language_Search_Name["English"] = "english";
    /** Esperanto */
    Ribbon_Health_Language_Search_Name["Esperanto"] = "esperanto";
    /** Estonian */
    Ribbon_Health_Language_Search_Name["Estonian"] = "estonian";
    /** Ewe */
    Ribbon_Health_Language_Search_Name["Ewe"] = "ewe";
    /** Faroese */
    Ribbon_Health_Language_Search_Name["Faroese"] = "faroese";
    /** Fijian */
    Ribbon_Health_Language_Search_Name["Fijian"] = "fijian";
    /** Finnish */
    Ribbon_Health_Language_Search_Name["Finnish"] = "finnish";
    /** French */
    Ribbon_Health_Language_Search_Name["French"] = "french";
    /** Fulah */
    Ribbon_Health_Language_Search_Name["Fulah"] = "fulah";
    /** Galician */
    Ribbon_Health_Language_Search_Name["Galician"] = "galician";
    /** Ganda */
    Ribbon_Health_Language_Search_Name["Ganda"] = "ganda";
    /** Georgian */
    Ribbon_Health_Language_Search_Name["Georgian"] = "georgian";
    /** German */
    Ribbon_Health_Language_Search_Name["German"] = "german";
    /** Guarani */
    Ribbon_Health_Language_Search_Name["Guarani"] = "guarani";
    /** Gujarati */
    Ribbon_Health_Language_Search_Name["Gujarati"] = "gujarati";
    /** Hausa */
    Ribbon_Health_Language_Search_Name["Hausa"] = "hausa";
    /** Hebrew */
    Ribbon_Health_Language_Search_Name["Hebrew"] = "hebrew";
    /** Herero */
    Ribbon_Health_Language_Search_Name["Herero"] = "herero";
    /** Hindi */
    Ribbon_Health_Language_Search_Name["Hindi"] = "hindi";
    /** Hungarian */
    Ribbon_Health_Language_Search_Name["Hungarian"] = "hungarian";
    /** Icelandic */
    Ribbon_Health_Language_Search_Name["Icelandic"] = "icelandic";
    /** Ido */
    Ribbon_Health_Language_Search_Name["Ido"] = "ido";
    /** Igbo */
    Ribbon_Health_Language_Search_Name["Igbo"] = "igbo";
    /** Indonesian */
    Ribbon_Health_Language_Search_Name["Indonesian"] = "indonesian";
    /** Inuktitut */
    Ribbon_Health_Language_Search_Name["Inuktitut"] = "inuktitut";
    /** Inupiaq */
    Ribbon_Health_Language_Search_Name["Inupiaq"] = "inupiaq";
    /** Irish */
    Ribbon_Health_Language_Search_Name["Irish"] = "irish";
    /** Italian */
    Ribbon_Health_Language_Search_Name["Italian"] = "italian";
    /** Japanese */
    Ribbon_Health_Language_Search_Name["Japanese"] = "japanese";
    /** Javanese */
    Ribbon_Health_Language_Search_Name["Javanese"] = "javanese";
    /** Kannada */
    Ribbon_Health_Language_Search_Name["Kannada"] = "kannada";
    /** Kanuri */
    Ribbon_Health_Language_Search_Name["Kanuri"] = "kanuri";
    /** Kashmiri */
    Ribbon_Health_Language_Search_Name["Kashmiri"] = "kashmiri";
    /** Kazakh */
    Ribbon_Health_Language_Search_Name["Kazakh"] = "kazakh";
    /** Kinyarwanda */
    Ribbon_Health_Language_Search_Name["Kinyarwanda"] = "kinyarwanda";
    /** Komi */
    Ribbon_Health_Language_Search_Name["Komi"] = "komi";
    /** Kongo */
    Ribbon_Health_Language_Search_Name["Kongo"] = "kongo";
    /** Korean */
    Ribbon_Health_Language_Search_Name["Korean"] = "korean";
    /** Kurdish */
    Ribbon_Health_Language_Search_Name["Kurdish"] = "kurdish";
    /** Lao */
    Ribbon_Health_Language_Search_Name["Lao"] = "lao";
    /** Latin */
    Ribbon_Health_Language_Search_Name["Latin"] = "latin";
    /** Latvian */
    Ribbon_Health_Language_Search_Name["Latvian"] = "latvian";
    /** Lingala */
    Ribbon_Health_Language_Search_Name["Lingala"] = "lingala";
    /** Lithuanian */
    Ribbon_Health_Language_Search_Name["Lithuanian"] = "lithuanian";
    /** Macedonian */
    Ribbon_Health_Language_Search_Name["Macedonian"] = "macedonian";
    /** Malagasy */
    Ribbon_Health_Language_Search_Name["Malagasy"] = "malagasy";
    /** Malay */
    Ribbon_Health_Language_Search_Name["Malay"] = "malay";
    /** Malayalam */
    Ribbon_Health_Language_Search_Name["Malayalam"] = "malayalam";
    /** Maltese */
    Ribbon_Health_Language_Search_Name["Maltese"] = "maltese";
    /** Manx */
    Ribbon_Health_Language_Search_Name["Manx"] = "manx";
    /** Maori */
    Ribbon_Health_Language_Search_Name["Maori"] = "maori";
    /** Marathi */
    Ribbon_Health_Language_Search_Name["Marathi"] = "marathi";
    /** Marshallese */
    Ribbon_Health_Language_Search_Name["Marshallese"] = "marshallese";
    /** Mongolian */
    Ribbon_Health_Language_Search_Name["Mongolian"] = "mongolian";
    /** Nauru */
    Ribbon_Health_Language_Search_Name["Nauru"] = "nauru";
    /** Ndonga */
    Ribbon_Health_Language_Search_Name["Ndonga"] = "ndonga";
    /** Nepali */
    Ribbon_Health_Language_Search_Name["Nepali"] = "nepali";
    /** Norwegian */
    Ribbon_Health_Language_Search_Name["Norwegian"] = "norwegian";
    /** Ojibwa */
    Ribbon_Health_Language_Search_Name["Ojibwa"] = "ojibwa";
    /** Oriya */
    Ribbon_Health_Language_Search_Name["Oriya"] = "oriya";
    /** Oromo */
    Ribbon_Health_Language_Search_Name["Oromo"] = "oromo";
    /** Pali */
    Ribbon_Health_Language_Search_Name["Pali"] = "pali";
    /** Persian */
    Ribbon_Health_Language_Search_Name["Persian"] = "persian";
    /** Polish */
    Ribbon_Health_Language_Search_Name["Polish"] = "polish";
    /** Portuguese */
    Ribbon_Health_Language_Search_Name["Portuguese"] = "portuguese";
    /** Quechua */
    Ribbon_Health_Language_Search_Name["Quechua"] = "quechua";
    /** Romansh */
    Ribbon_Health_Language_Search_Name["Romansh"] = "romansh";
    /** Rundi */
    Ribbon_Health_Language_Search_Name["Rundi"] = "rundi";
    /** Russian */
    Ribbon_Health_Language_Search_Name["Russian"] = "russian";
    /** Samoan */
    Ribbon_Health_Language_Search_Name["Samoan"] = "samoan";
    /** Sango */
    Ribbon_Health_Language_Search_Name["Sango"] = "sango";
    /** Sanskrit */
    Ribbon_Health_Language_Search_Name["Sanskrit"] = "sanskrit";
    /** Sardinian */
    Ribbon_Health_Language_Search_Name["Sardinian"] = "sardinian";
    /** Serbian */
    Ribbon_Health_Language_Search_Name["Serbian"] = "serbian";
    /** Shona */
    Ribbon_Health_Language_Search_Name["Shona"] = "shona";
    /** Sindhi */
    Ribbon_Health_Language_Search_Name["Sindhi"] = "sindhi";
    /** Slovak */
    Ribbon_Health_Language_Search_Name["Slovak"] = "slovak";
    /** Slovenian */
    Ribbon_Health_Language_Search_Name["Slovenian"] = "slovenian";
    /** Somali */
    Ribbon_Health_Language_Search_Name["Somali"] = "somali";
    /** Spanish */
    Ribbon_Health_Language_Search_Name["Spanish"] = "spanish";
    /** Sundanese */
    Ribbon_Health_Language_Search_Name["Sundanese"] = "sundanese";
    /** Swahili */
    Ribbon_Health_Language_Search_Name["Swahili"] = "swahili";
    /** Swati */
    Ribbon_Health_Language_Search_Name["Swati"] = "swati";
    /** Swedish */
    Ribbon_Health_Language_Search_Name["Swedish"] = "swedish";
    /** Tagalog */
    Ribbon_Health_Language_Search_Name["Tagalog"] = "tagalog";
    /** Tahitian */
    Ribbon_Health_Language_Search_Name["Tahitian"] = "tahitian";
    /** Tajik */
    Ribbon_Health_Language_Search_Name["Tajik"] = "tajik";
    /** Tamil */
    Ribbon_Health_Language_Search_Name["Tamil"] = "tamil";
    /** Tatar */
    Ribbon_Health_Language_Search_Name["Tatar"] = "tatar";
    /** Telugu */
    Ribbon_Health_Language_Search_Name["Telugu"] = "telugu";
    /** Thai */
    Ribbon_Health_Language_Search_Name["Thai"] = "thai";
    /** Tibetan */
    Ribbon_Health_Language_Search_Name["Tibetan"] = "tibetan";
    /** Tigrinya */
    Ribbon_Health_Language_Search_Name["Tigrinya"] = "tigrinya";
    /** Tsonga */
    Ribbon_Health_Language_Search_Name["Tsonga"] = "tsonga";
    /** Tswana */
    Ribbon_Health_Language_Search_Name["Tswana"] = "tswana";
    /** Turkish */
    Ribbon_Health_Language_Search_Name["Turkish"] = "turkish";
    /** Turkmen */
    Ribbon_Health_Language_Search_Name["Turkmen"] = "turkmen";
    /** Twi */
    Ribbon_Health_Language_Search_Name["Twi"] = "twi";
    /** Ukrainian */
    Ribbon_Health_Language_Search_Name["Ukrainian"] = "ukrainian";
    /** Urdu */
    Ribbon_Health_Language_Search_Name["Urdu"] = "urdu";
    /** Uzbek */
    Ribbon_Health_Language_Search_Name["Uzbek"] = "uzbek";
    /** Venda */
    Ribbon_Health_Language_Search_Name["Venda"] = "venda";
    /** Vietnamese */
    Ribbon_Health_Language_Search_Name["Vietnamese"] = "vietnamese";
    /** Walloon */
    Ribbon_Health_Language_Search_Name["Walloon"] = "walloon";
    /** Welsh */
    Ribbon_Health_Language_Search_Name["Welsh"] = "welsh";
    /** Wolof */
    Ribbon_Health_Language_Search_Name["Wolof"] = "wolof";
    /** Xhosa */
    Ribbon_Health_Language_Search_Name["Xhosa"] = "xhosa";
    /** Yiddish */
    Ribbon_Health_Language_Search_Name["Yiddish"] = "yiddish";
    /** Yoruba */
    Ribbon_Health_Language_Search_Name["Yoruba"] = "yoruba";
    /** Zulu */
    Ribbon_Health_Language_Search_Name["Zulu"] = "zulu";
})(Ribbon_Health_Language_Search_Name || (Ribbon_Health_Language_Search_Name = {}));
/** Possible names for search for doctor by specialty. */
export var Ribbon_Health_Specialty_Search_Name;
(function (Ribbon_Health_Specialty_Search_Name) {
    /** Acupuncturist */
    Ribbon_Health_Specialty_Search_Name["Acupunct"] = "acupunct";
    /** Allergist */
    Ribbon_Health_Specialty_Search_Name["Allergist"] = "allergist";
    /** Audiologist (Hearing Aids) */
    Ribbon_Health_Specialty_Search_Name["Audiolog"] = "audiolog";
    /** Cardiologist */
    Ribbon_Health_Specialty_Search_Name["Cardiolog"] = "cardiolog";
    /** Chiropractor */
    Ribbon_Health_Specialty_Search_Name["Chiropract"] = "chiropract";
    /** Dentists and Dental Specialists */
    Ribbon_Health_Specialty_Search_Name["Dent"] = "dent";
    /** General Dentist */
    Ribbon_Health_Specialty_Search_Name["Dentist"] = "dentist";
    /** Dermatologist */
    Ribbon_Health_Specialty_Search_Name["Dermatol"] = "dermatol";
    /** Endocrinologist (Hormones, Thyroid, Osteoporosis, and/or Diabetes) */
    Ribbon_Health_Specialty_Search_Name["Endocrinolog"] = "endocrinolog";
    /** Endodontist */
    Ribbon_Health_Specialty_Search_Name["Endodont"] = "endodont";
    /** Eye Doctors */
    Ribbon_Health_Specialty_Search_Name["Eye"] = "eye";
    /** Family Medicine Doctor */
    Ribbon_Health_Specialty_Search_Name["Family"] = "family";
    /** Gastroenterologist (Colonoscopy) */
    Ribbon_Health_Specialty_Search_Name["Gastro"] = "gastro";
    /** Obstetrician-Gynecologists (OBGYNs) */
    Ribbon_Health_Specialty_Search_Name["Gynecolog"] = "gynecolog";
    /** Hematologist (Blood Specialist) */
    Ribbon_Health_Specialty_Search_Name["Hematolog"] = "hematolog";
    /** Infectious Disease Specialist */
    Ribbon_Health_Specialty_Search_Name["Infect"] = "infect";
    /** Mental Health Providers */
    Ribbon_Health_Specialty_Search_Name["Mental"] = "mental";
    /** Nephrologist (Kidney Specialist) */
    Ribbon_Health_Specialty_Search_Name["Nephrolog"] = "nephrolog";
    /** Neurologist (Headache and Nervous System) */
    Ribbon_Health_Specialty_Search_Name["Neurolog"] = "neurolog";
    /** Neurosurgeon */
    Ribbon_Health_Specialty_Search_Name["Neurosurgeon"] = "neurosurgeon";
    /** Dietician / Nutritionist */
    Ribbon_Health_Specialty_Search_Name["Nutrition"] = "nutrition";
    /** General OBGYN */
    Ribbon_Health_Specialty_Search_Name["Obgyn"] = "obgyn";
    /** Obsetrician */
    Ribbon_Health_Specialty_Search_Name["Obsetrician"] = "obsetrician";
    /** Occupational Therapy */
    Ribbon_Health_Specialty_Search_Name["Occupat"] = "occupat";
    /** Oncologist (Cancer Specialist) */
    Ribbon_Health_Specialty_Search_Name["Oncolog"] = "oncolog";
    /** Ophthalmologist */
    Ribbon_Health_Specialty_Search_Name["Ophthalmolog"] = "ophthalmolog";
    /** Optometrist */
    Ribbon_Health_Specialty_Search_Name["Optometr"] = "optometr";
    /** Oral Surgeon */
    Ribbon_Health_Specialty_Search_Name["Oral"] = "oral";
    /** Orthodontist */
    Ribbon_Health_Specialty_Search_Name["Orthodont"] = "orthodont";
    /** Orthopedist/Orthopedic Surgeon */
    Ribbon_Health_Specialty_Search_Name["Orthoped"] = "orthoped";
    /** Ear, Nose, & Throat Doctor (ENT/Otolaryngologist) */
    Ribbon_Health_Specialty_Search_Name["Otolaryng"] = "otolaryng";
    /** Pain Medicine Specialist */
    Ribbon_Health_Specialty_Search_Name["Pain"] = "pain";
    /** Pediatricians */
    Ribbon_Health_Specialty_Search_Name["Pediatr"] = "pediatr";
    /** Periodontist */
    Ribbon_Health_Specialty_Search_Name["Periodont"] = "periodont";
    /** Physiatrist (Physical Medicine) */
    Ribbon_Health_Specialty_Search_Name["Physiatr"] = "physiatr";
    /** Physical Therapy */
    Ribbon_Health_Specialty_Search_Name["Physic"] = "physic";
    /** Podiatrist (Foot/Ankle Specialist) */
    Ribbon_Health_Specialty_Search_Name["Podiatr"] = "podiatr";
    /** Primary Care Physicians (PCPs) */
    Ribbon_Health_Specialty_Search_Name["PrimaryCare"] = "primary_care";
    /** Proctologist / Colorectal Surgeon */
    Ribbon_Health_Specialty_Search_Name["Proctolog"] = "proctolog";
    /** Prosthodontist */
    Ribbon_Health_Specialty_Search_Name["Prosthodont"] = "prosthodont";
    /** Psychiatrist / Medication Management */
    Ribbon_Health_Specialty_Search_Name["Psychiatr"] = "psychiatr";
    /** Psychologist / Therapist */
    Ribbon_Health_Specialty_Search_Name["Psycholog"] = "psycholog";
    /** Pulmonologist (Lung Specialist) */
    Ribbon_Health_Specialty_Search_Name["Pulmonolog"] = "pulmonolog";
    /** Plastic / Reconstructive Surgeon */
    Ribbon_Health_Specialty_Search_Name["Reconstruct"] = "reconstruct";
    /** Reproductive Endocrinologist */
    Ribbon_Health_Specialty_Search_Name["Reproduc"] = "reproduc";
    /** Reproductive Endocrinologist (Fertility Specialist) */
    Ribbon_Health_Specialty_Search_Name["Reproduct"] = "reproduct";
    /** Rheumatologist (Arthritis and/or Autoimmune Conditions) */
    Ribbon_Health_Specialty_Search_Name["Rheumatolog"] = "rheumatolog";
    /** Sleep Specialist */
    Ribbon_Health_Specialty_Search_Name["Sleep"] = "sleep";
    /** Speech Therapy */
    Ribbon_Health_Specialty_Search_Name["Speech"] = "speech";
    /** General Surgeon */
    Ribbon_Health_Specialty_Search_Name["Surgeo"] = "surgeo";
    /** Surgeons */
    Ribbon_Health_Specialty_Search_Name["Surgeon"] = "surgeon";
    /** Urologist */
    Ribbon_Health_Specialty_Search_Name["Urolog"] = "urolog";
    /** Vascular Surgeon */
    Ribbon_Health_Specialty_Search_Name["Vascular"] = "vascular";
    /** Gynecologist */
    Ribbon_Health_Specialty_Search_Name["Women"] = "women";
})(Ribbon_Health_Specialty_Search_Name || (Ribbon_Health_Specialty_Search_Name = {}));
export var Rightway_Rx_Pharmacies_Order;
(function (Rightway_Rx_Pharmacies_Order) {
    /** Ascending sort by 'id' field. */
    Rightway_Rx_Pharmacies_Order["Id"] = "id";
    /** Ascending sort by 'name' field. */
    Rightway_Rx_Pharmacies_Order["Name"] = "name";
    /** Ascending sort by 'npi' field. */
    Rightway_Rx_Pharmacies_Order["Npi"] = "npi";
    /** Descending sort by 'id' field. */
    Rightway_Rx_Pharmacies_Order["ReverseId"] = "reverse_id";
    /** Descending sort by 'name' field. */
    Rightway_Rx_Pharmacies_Order["ReverseName"] = "reverse_name";
    /** Descending sort by 'npi' field. */
    Rightway_Rx_Pharmacies_Order["ReverseNpi"] = "reverse_npi";
})(Rightway_Rx_Pharmacies_Order || (Rightway_Rx_Pharmacies_Order = {}));
export var Rippling_Events_Order;
(function (Rippling_Events_Order) {
    /** Ascending sort by 'id' field. */
    Rippling_Events_Order["Id"] = "id";
    /** Descending sort by 'id' field. */
    Rippling_Events_Order["ReverseId"] = "reverse_id";
})(Rippling_Events_Order || (Rippling_Events_Order = {}));
export var Rippling_Event_Status;
(function (Rippling_Event_Status) {
    /** Completed */
    Rippling_Event_Status["Completed"] = "completed";
    /** Failed */
    Rippling_Event_Status["Failed"] = "failed";
    /** Pending */
    Rippling_Event_Status["Pending"] = "pending";
    /** Processing */
    Rippling_Event_Status["Processing"] = "processing";
})(Rippling_Event_Status || (Rippling_Event_Status = {}));
export var Rippling_Event_Type;
(function (Rippling_Event_Type) {
    /** Company deactivated */
    Rippling_Event_Type["CompanyDeactivated"] = "company_deactivated";
    /** Company plans updated */
    Rippling_Event_Type["CompanyPlansUpdated"] = "company_plans_updated";
})(Rippling_Event_Type || (Rippling_Event_Type = {}));
export var Roadmaps_Type_Order;
(function (Roadmaps_Type_Order) {
    /** Ascending sort by 'created_at' field. */
    Roadmaps_Type_Order["CreatedAt"] = "created_at";
    /** Ascending sort by 'id' field. */
    Roadmaps_Type_Order["Id"] = "id";
    /** Ascending sort by 'name' field. */
    Roadmaps_Type_Order["Name"] = "name";
    /** Descending sort by 'created_at' field. */
    Roadmaps_Type_Order["ReverseCreatedAt"] = "reverse_created_at";
    /** Descending sort by 'id' field. */
    Roadmaps_Type_Order["ReverseId"] = "reverse_id";
    /** Descending sort by 'name' field. */
    Roadmaps_Type_Order["ReverseName"] = "reverse_name";
    /** Descending sort by 'ticket_id' field. */
    Roadmaps_Type_Order["ReverseTicketId"] = "reverse_ticket_id";
    /** Descending sort by 'updated_at' field. */
    Roadmaps_Type_Order["ReverseUpdatedAt"] = "reverse_updated_at";
    /** Ascending sort by 'ticket_id' field. */
    Roadmaps_Type_Order["TicketId"] = "ticket_id";
    /** Ascending sort by 'updated_at' field. */
    Roadmaps_Type_Order["UpdatedAt"] = "updated_at";
})(Roadmaps_Type_Order || (Roadmaps_Type_Order = {}));
export var Roadmap_Appointment_Entity_Type;
(function (Roadmap_Appointment_Entity_Type) {
    Roadmap_Appointment_Entity_Type["Doctor"] = "doctor";
    Roadmap_Appointment_Entity_Type["Facility"] = "facility";
})(Roadmap_Appointment_Entity_Type || (Roadmap_Appointment_Entity_Type = {}));
export var Roadmap_Change_Status_Event;
(function (Roadmap_Change_Status_Event) {
    /** Changes state from 'resolved' to 'closed' */
    Roadmap_Change_Status_Event["Complete"] = "complete";
    /** Changes state from 'in_progress' to 'in_progress' from 'resolved' to 'in_progress' */
    Roadmap_Change_Status_Event["Edit"] = "edit";
    /** Changes state from 'pending' to 'in_progress' */
    Roadmap_Change_Status_Event["Start"] = "start";
    /** Changes state from 'in_progress' to 'pending' */
    Roadmap_Change_Status_Event["Stop"] = "stop";
    /** Changes state from 'in_progress' to 'resolved' from 'resolved' to 'resolved' */
    Roadmap_Change_Status_Event["Submit"] = "submit";
})(Roadmap_Change_Status_Event || (Roadmap_Change_Status_Event = {}));
export var Roadmap_Entity_Source_Type;
(function (Roadmap_Entity_Source_Type) {
    Roadmap_Entity_Source_Type["Doctor"] = "Doctor";
    Roadmap_Entity_Source_Type["Facility"] = "Facility";
    Roadmap_Entity_Source_Type["Provider"] = "Provider";
})(Roadmap_Entity_Source_Type || (Roadmap_Entity_Source_Type = {}));
export var Roadmap_Health_Issue_Chronicality;
(function (Roadmap_Health_Issue_Chronicality) {
    /** Neither */
    Roadmap_Health_Issue_Chronicality["Neither"] = "neither";
    /** New */
    Roadmap_Health_Issue_Chronicality["New"] = "new";
    /** Ongoing */
    Roadmap_Health_Issue_Chronicality["Ongoing"] = "ongoing";
})(Roadmap_Health_Issue_Chronicality || (Roadmap_Health_Issue_Chronicality = {}));
export var Roadmap_Image_Background;
(function (Roadmap_Image_Background) {
    Roadmap_Image_Background["Acute"] = "acute";
    Roadmap_Image_Background["Chronic"] = "chronic";
    Roadmap_Image_Background["Wellness"] = "wellness";
})(Roadmap_Image_Background || (Roadmap_Image_Background = {}));
export var Roadmap_Image_Type;
(function (Roadmap_Image_Type) {
    /** Allergist */
    Roadmap_Image_Type["Allergist"] = "allergist";
    /** Back Pain */
    Roadmap_Image_Type["BackPain"] = "back_pain";
    /** Blood Test */
    Roadmap_Image_Type["BloodTest"] = "blood_test";
    /** Chiropractor */
    Roadmap_Image_Type["Chiropractor"] = "chiropractor";
    /** Dentist */
    Roadmap_Image_Type["Dentist"] = "dentist";
    /** Dermatologist */
    Roadmap_Image_Type["Dermatologist"] = "dermatologist";
    /** Endocrinologist */
    Roadmap_Image_Type["Endocrinologist"] = "endocrinologist";
    /** Gastroenterologist (GI) */
    Roadmap_Image_Type["Gastroenterology"] = "gastroenterology";
    /** General */
    Roadmap_Image_Type["General"] = "general";
    /** OB-GYN */
    Roadmap_Image_Type["Gynecologist"] = "gynecologist";
    /** Hip Pain */
    Roadmap_Image_Type["HipPain"] = "hip_pain";
    /** Knee Pain */
    Roadmap_Image_Type["KneePain"] = "knee_pain";
    /** MRI */
    Roadmap_Image_Type["Mri"] = "mri";
    /** Neurologist */
    Roadmap_Image_Type["Neurology"] = "neurology";
    /** Eye Doctor */
    Roadmap_Image_Type["Ophthalmology"] = "ophthalmology";
    /** Orthodontist */
    Roadmap_Image_Type["Orthodontist"] = "orthodontist";
    /** Orthopedic Surgeon */
    Roadmap_Image_Type["Orthopedics"] = "orthopedics";
    /** Pediatrician */
    Roadmap_Image_Type["Pediatrician"] = "pediatrician";
    /** Physical Therapy */
    Roadmap_Image_Type["PhysicalTherapy"] = "physical_therapy";
    /** Podiatrist */
    Roadmap_Image_Type["Podiatrist"] = "podiatrist";
    /** Primary Care Provider */
    Roadmap_Image_Type["PrimaryCareDoctor"] = "primary_care_doctor";
    /** Mental Health */
    Roadmap_Image_Type["Psychiatrist"] = "psychiatrist";
    /** Radiology */
    Roadmap_Image_Type["Radiology"] = "radiology";
    /** Shoulder Pain */
    Roadmap_Image_Type["ShoulderPain"] = "shoulder_pain";
    /** Specialist */
    Roadmap_Image_Type["Specialist"] = "specialist";
    /** Urgent Care */
    Roadmap_Image_Type["UrgentCare"] = "urgent_care";
    /** Wellness Visit */
    Roadmap_Image_Type["WellnessVisit"] = "wellness_visit";
})(Roadmap_Image_Type || (Roadmap_Image_Type = {}));
export var Roadmap_Name_Type;
(function (Roadmap_Name_Type) {
    /** Consultation */
    Roadmap_Name_Type["Consultation"] = "consultation";
    /** Followup Visit */
    Roadmap_Name_Type["FollowupVisit"] = "followup_visit";
    /** Inpatient Procedure */
    Roadmap_Name_Type["InpatientProcedure"] = "inpatient_procedure";
    /** Office Visit */
    Roadmap_Name_Type["OfficeVisit"] = "office_visit";
    /** Outpatient Procedure */
    Roadmap_Name_Type["OutpatientProcedure"] = "outpatient_procedure";
})(Roadmap_Name_Type || (Roadmap_Name_Type = {}));
export var Roadmap_Performed_By_Type;
(function (Roadmap_Performed_By_Type) {
    /** Facility */
    Roadmap_Performed_By_Type["Facility"] = "facility";
    /** Provider */
    Roadmap_Performed_By_Type["Provider"] = "provider";
})(Roadmap_Performed_By_Type || (Roadmap_Performed_By_Type = {}));
export var Roadmap_Preferred_Distance;
(function (Roadmap_Preferred_Distance) {
    /** Any distance */
    Roadmap_Preferred_Distance["Any"] = "any";
    /** Less than 5 miles */
    Roadmap_Preferred_Distance["LessThan_5Miles"] = "less_than_5_miles";
    /** Less than 10 miles */
    Roadmap_Preferred_Distance["LessThan_10Miles"] = "less_than_10_miles";
    /** Less than 20 miles */
    Roadmap_Preferred_Distance["LessThan_20Miles"] = "less_than_20_miles";
    /** Less than a mile */
    Roadmap_Preferred_Distance["LessThanAMile"] = "less_than_a_mile";
})(Roadmap_Preferred_Distance || (Roadmap_Preferred_Distance = {}));
export var Roadmap_Response_Threshold;
(function (Roadmap_Response_Threshold) {
    /** As soon as possible */
    Roadmap_Response_Threshold["Asap"] = "asap";
    /** Within 1 month */
    Roadmap_Response_Threshold["OneMonth"] = "one_month";
    /** Within 1 week */
    Roadmap_Response_Threshold["OneWeek"] = "one_week";
    /** Within 3 months */
    Roadmap_Response_Threshold["ThreeMonths"] = "three_months";
    /** Within 2 weeks */
    Roadmap_Response_Threshold["TwoWeeks"] = "two_weeks";
})(Roadmap_Response_Threshold || (Roadmap_Response_Threshold = {}));
export var Roadmap_Status;
(function (Roadmap_Status) {
    Roadmap_Status["Closed"] = "closed";
    Roadmap_Status["InProgress"] = "in_progress";
    Roadmap_Status["Pending"] = "pending";
    Roadmap_Status["Resolved"] = "resolved";
})(Roadmap_Status || (Roadmap_Status = {}));
export var RejectTypeEnum;
(function (RejectTypeEnum) {
    RejectTypeEnum["DaysSupplyExceeds"] = "DAYS_SUPPLY_EXCEEDS";
    RejectTypeEnum["DrugNotCovered"] = "DRUG_NOT_COVERED";
    RejectTypeEnum["Generic"] = "GENERIC";
    RejectTypeEnum["PriorAuthorizationRequired"] = "PRIOR_AUTHORIZATION_REQUIRED";
    RejectTypeEnum["ProgramEnrollmentRequired"] = "PROGRAM_ENROLLMENT_REQUIRED";
    RejectTypeEnum["QuantityExceeds"] = "QUANTITY_EXCEEDS";
    RejectTypeEnum["SpecialtyDrug"] = "SPECIALTY_DRUG";
    RejectTypeEnum["UnspecifiedRejectType"] = "UNSPECIFIED_REJECT_TYPE";
})(RejectTypeEnum || (RejectTypeEnum = {}));
/** List of boolean filters for RiskScore. */
export var RiskScoreFiltersEnum;
(function (RiskScoreFiltersEnum) {
    RiskScoreFiltersEnum["CardiacDysrhy"] = "cardiac_dysrhy";
    RiskScoreFiltersEnum["CcGrp_1"] = "cc_grp_1";
    RiskScoreFiltersEnum["CcGrp_2"] = "cc_grp_2";
    RiskScoreFiltersEnum["CcGrp_3"] = "cc_grp_3";
    RiskScoreFiltersEnum["CcGrp_4"] = "cc_grp_4";
    RiskScoreFiltersEnum["CcGrp_5"] = "cc_grp_5";
    RiskScoreFiltersEnum["CcGrp_6"] = "cc_grp_6";
    RiskScoreFiltersEnum["CcGrp_7"] = "cc_grp_7";
    RiskScoreFiltersEnum["CcGrp_8"] = "cc_grp_8";
    RiskScoreFiltersEnum["CcGrp_9"] = "cc_grp_9";
    RiskScoreFiltersEnum["CcGrp_10"] = "cc_grp_10";
    RiskScoreFiltersEnum["CcGrp_11"] = "cc_grp_11";
    RiskScoreFiltersEnum["CcGrp_12"] = "cc_grp_12";
    RiskScoreFiltersEnum["CcGrp_13"] = "cc_grp_13";
    RiskScoreFiltersEnum["CcGrp_14"] = "cc_grp_14";
    RiskScoreFiltersEnum["CcGrp_15"] = "cc_grp_15";
    RiskScoreFiltersEnum["CcGrp_16"] = "cc_grp_16";
    RiskScoreFiltersEnum["CcGrp_17"] = "cc_grp_17";
    RiskScoreFiltersEnum["Cerebrovas"] = "cerebrovas";
    RiskScoreFiltersEnum["Cvd"] = "cvd";
    RiskScoreFiltersEnum["Htn"] = "htn";
    RiskScoreFiltersEnum["Injuries"] = "injuries";
    RiskScoreFiltersEnum["Msk"] = "msk";
    RiskScoreFiltersEnum["PayBinary"] = "pay_binary";
})(RiskScoreFiltersEnum || (RiskScoreFiltersEnum = {}));
export var RxOverrideRequestedByInput;
(function (RxOverrideRequestedByInput) {
    /** Member */
    RxOverrideRequestedByInput["Member"] = "member";
    /** Pharmacy */
    RxOverrideRequestedByInput["Pharmacy"] = "pharmacy";
})(RxOverrideRequestedByInput || (RxOverrideRequestedByInput = {}));
export var RxOverrideStatusInput;
(function (RxOverrideStatusInput) {
    /** Approved */
    RxOverrideStatusInput["Approved"] = "approved";
    /** Denied */
    RxOverrideStatusInput["Denied"] = "denied";
    /** Unspecified */
    RxOverrideStatusInput["Unspecified"] = "unspecified";
})(RxOverrideStatusInput || (RxOverrideStatusInput = {}));
export var RxPriorAuthorizationNewStartOrCotInput;
(function (RxPriorAuthorizationNewStartOrCotInput) {
    /** Cot */
    RxPriorAuthorizationNewStartOrCotInput["Cot"] = "cot";
    /** New start */
    RxPriorAuthorizationNewStartOrCotInput["NewStart"] = "new_start";
})(RxPriorAuthorizationNewStartOrCotInput || (RxPriorAuthorizationNewStartOrCotInput = {}));
export var RxPriorAuthorizationRequestedByInput;
(function (RxPriorAuthorizationRequestedByInput) {
    /** Member */
    RxPriorAuthorizationRequestedByInput["Member"] = "member";
    /** Provider */
    RxPriorAuthorizationRequestedByInput["Provider"] = "provider";
})(RxPriorAuthorizationRequestedByInput || (RxPriorAuthorizationRequestedByInput = {}));
export var Settings_Order;
(function (Settings_Order) {
    /** Ascending sort by 'id' field. */
    Settings_Order["Id"] = "id";
    /** Ascending sort by 'key' field. */
    Settings_Order["Key"] = "key";
    /** Descending sort by 'id' field. */
    Settings_Order["ReverseId"] = "reverse_id";
    /** Descending sort by 'key' field. */
    Settings_Order["ReverseKey"] = "reverse_key";
    /** Descending sort by 'updated_at' field. */
    Settings_Order["ReverseUpdatedAt"] = "reverse_updated_at";
    /** Ascending sort by 'updated_at' field. */
    Settings_Order["UpdatedAt"] = "updated_at";
})(Settings_Order || (Settings_Order = {}));
export var Setting_Key;
(function (Setting_Key) {
    Setting_Key["AndroidAppUpdateExcludedVersions"] = "android_app_update_excluded_versions";
    Setting_Key["AndroidAppVersion"] = "android_app_version";
    Setting_Key["ChatAnalyzeTeamIds"] = "chat_analyze_team_ids";
    Setting_Key["DemoAccountPreferences"] = "demo_account_preferences";
    Setting_Key["FeedbackEmailRecipient"] = "feedback_email_recipient";
    Setting_Key["ForgotPasswordSupportRecipient"] = "forgot_password_support_recipient";
    Setting_Key["GiftangoPackagingCode"] = "giftango_packaging_code";
    Setting_Key["GiftangoProductSku"] = "giftango_product_sku";
    Setting_Key["GiftangoProgramId"] = "giftango_program_id";
    Setting_Key["ImportErrorsRecipients"] = "import_errors_recipients";
    Setting_Key["IntakeGroupsEnabled"] = "intake_groups_enabled";
    Setting_Key["IntelligentUnreadNotificationsEnabled"] = "intelligent_unread_notifications_enabled";
    Setting_Key["IosAppUpdateExcludedVersions"] = "ios_app_update_excluded_versions";
    Setting_Key["IosAppVersion"] = "ios_app_version";
    Setting_Key["MemberNotificationPreferencesEnabled"] = "member_notification_preferences_enabled";
    Setting_Key["OeAiSessionAbandonedAfterMinutes"] = "oe_ai_session_abandoned_after_minutes";
    Setting_Key["OpenFgaFullSyncTimestamp"] = "open_fga_full_sync_timestamp";
    Setting_Key["OpenFgaIncrementalSyncToken"] = "open_fga_incremental_sync_token";
    Setting_Key["OpswatEnableFileSanitization"] = "opswat_enable_file_sanitization";
    Setting_Key["OpswatEnableFileScanning"] = "opswat_enable_file_scanning";
    Setting_Key["OrganizationAlertMail"] = "organization_alert_mail";
    Setting_Key["QueueSystemProcess"] = "queue_system_process";
    Setting_Key["RegistrationProofTokenMinVersionMemberRn"] = "registration_proof_token_min_version_member_rn";
    Setting_Key["RegistrationProofTokenMinVersionMemberWeb"] = "registration_proof_token_min_version_member_web";
    Setting_Key["RequestAccountDeletionRecipient"] = "request_account_deletion_recipient";
    Setting_Key["RipplingEventsLookupEnabled"] = "rippling_events_lookup_enabled";
    Setting_Key["SsoFailureNotificationEmail"] = "sso_failure_notification_email";
    Setting_Key["UsedForAqa"] = "used_for_aqa";
})(Setting_Key || (Setting_Key = {}));
export var Subscription_Event_Type;
(function (Subscription_Event_Type) {
    /** Object was added to subscription scope. */
    Subscription_Event_Type["Added"] = "added";
    /** New object was created. */
    Subscription_Event_Type["Created"] = "created";
    /** Object was deleted. */
    Subscription_Event_Type["Deleted"] = "deleted";
    /** Object was removed from subscription scope. */
    Subscription_Event_Type["Removed"] = "removed";
    /** Object was updated. */
    Subscription_Event_Type["Updated"] = "updated";
})(Subscription_Event_Type || (Subscription_Event_Type = {}));
/** Possible survey answer kinds. */
export var Survey_Answer_Kind;
(function (Survey_Answer_Kind) {
    Survey_Answer_Kind["Date"] = "date";
    Survey_Answer_Kind["Doctor"] = "doctor";
    Survey_Answer_Kind["Email"] = "email";
    Survey_Answer_Kind["Height"] = "height";
    Survey_Answer_Kind["Inherit"] = "inherit";
    Survey_Answer_Kind["Money"] = "money";
    Survey_Answer_Kind["Numeric"] = "numeric";
    Survey_Answer_Kind["Phone"] = "phone";
    Survey_Answer_Kind["Text"] = "text";
    Survey_Answer_Kind["Weight"] = "weight";
})(Survey_Answer_Kind || (Survey_Answer_Kind = {}));
/** Possible survey question kinds. */
export var Survey_Question_Kind;
(function (Survey_Question_Kind) {
    Survey_Question_Kind["Address"] = "address";
    Survey_Question_Kind["Boolean"] = "boolean";
    Survey_Question_Kind["Checkbox"] = "checkbox";
    Survey_Question_Kind["Date"] = "date";
    Survey_Question_Kind["Email"] = "email";
    Survey_Question_Kind["Height"] = "height";
    Survey_Question_Kind["Money"] = "money";
    Survey_Question_Kind["Numeric"] = "numeric";
    Survey_Question_Kind["Phone"] = "phone";
    Survey_Question_Kind["Radio"] = "radio";
    Survey_Question_Kind["Select"] = "select";
    Survey_Question_Kind["Text"] = "text";
    Survey_Question_Kind["Weight"] = "weight";
})(Survey_Question_Kind || (Survey_Question_Kind = {}));
export var SectionPriceType;
(function (SectionPriceType) {
    SectionPriceType["Favorite"] = "FAVORITE";
    SectionPriceType["Other"] = "OTHER";
    SectionPriceType["Recommended"] = "RECOMMENDED";
    SectionPriceType["Specialty"] = "SPECIALTY";
})(SectionPriceType || (SectionPriceType = {}));
export var SurveyQuestionType;
(function (SurveyQuestionType) {
    /** Question that may have text answer formatted as address. */
    SurveyQuestionType["Address"] = "address";
    /** Question that only may have yes/no answer. */
    SurveyQuestionType["Boolean"] = "boolean";
    /** Question that may have any of predefined answers. */
    SurveyQuestionType["Checkbox"] = "checkbox";
    /** Question that may have text answer formatted as email. */
    SurveyQuestionType["Email"] = "email";
    /** Question that may have text answer formatted as person's height. */
    SurveyQuestionType["Height"] = "height";
    /** Question that may have text answer formatted as phone number. */
    SurveyQuestionType["Phone"] = "phone";
    /** Question that may have one of predefined answers. */
    SurveyQuestionType["Radio"] = "radio";
    /** Question that may have text answer formatted as person's weight. */
    SurveyQuestionType["Weight"] = "weight";
})(SurveyQuestionType || (SurveyQuestionType = {}));
export var Task_By_Time_Type;
(function (Task_By_Time_Type) {
    Task_By_Time_Type["Overdue"] = "overdue";
    Task_By_Time_Type["Today"] = "today";
    Task_By_Time_Type["Upcoming"] = "upcoming";
})(Task_By_Time_Type || (Task_By_Time_Type = {}));
export var Task_Type_Order;
(function (Task_Type_Order) {
    /** Ascending sort by 'due_date' field. */
    Task_Type_Order["DueDate"] = "due_date";
    /** Ascending sort by 'id' field. */
    Task_Type_Order["Id"] = "id";
    /** Descending sort by 'due_date' field. */
    Task_Type_Order["ReverseDueDate"] = "reverse_due_date";
    /** Descending sort by 'id' field. */
    Task_Type_Order["ReverseId"] = "reverse_id";
})(Task_Type_Order || (Task_Type_Order = {}));
export var Teams_Order;
(function (Teams_Order) {
    /** Ascending sort by 'id' field. */
    Teams_Order["Id"] = "id";
    /** Ascending sort by 'name' field. */
    Teams_Order["Name"] = "name";
    /** Descending sort by 'id' field. */
    Teams_Order["ReverseId"] = "reverse_id";
    /** Descending sort by 'name' field. */
    Teams_Order["ReverseName"] = "reverse_name";
})(Teams_Order || (Teams_Order = {}));
/** Team permissions */
export var Team_Permission;
(function (Team_Permission) {
    /** Access admin */
    Team_Permission["AccessAdmin"] = "access_admin";
    /** Access benefit manager */
    Team_Permission["AccessBenefitManager"] = "access_benefit_manager";
    /** Access copilot chat summaries */
    Team_Permission["AccessCopilotChatSummaries"] = "access_copilot_chat_summaries";
    /** Access copilot classifier */
    Team_Permission["AccessCopilotClassifier"] = "access_copilot_classifier";
    /** Access copilot member summaries */
    Team_Permission["AccessCopilotMemberSummaries"] = "access_copilot_member_summaries";
    /** Access demo creation */
    Team_Permission["AccessDemoCreation"] = "access_demo_creation";
    /** Access email */
    Team_Permission["AccessEmail"] = "access_email";
    /** Access navigation advanced */
    Team_Permission["AccessNavigationAdvanced"] = "access_navigation_advanced";
    /** Access navigation base */
    Team_Permission["AccessNavigationBase"] = "access_navigation_base";
    /** Access org launcher */
    Team_Permission["AccessOrgLauncher"] = "access_org_launcher";
    /** Access PBM journal notes */
    Team_Permission["AccessPbmJournalNotes"] = "access_pbm_journal_notes";
    /** Administer employees */
    Team_Permission["AdministerEmployees"] = "administer_employees";
    /** Create invites */
    Team_Permission["CreateInvites"] = "create_invites";
    /** Manage articles */
    Team_Permission["ManageArticles"] = "manage_articles";
    /** Manage chats */
    Team_Permission["ManageChats"] = "manage_chats";
    /** Manage claims */
    Team_Permission["ManageClaims"] = "manage_claims";
    /** Manage employees */
    Team_Permission["ManageEmployees"] = "manage_employees";
    /** Manage intake queues */
    Team_Permission["ManageIntakeQueues"] = "manage_intake_queues";
    /** Manage intake tags */
    Team_Permission["ManageIntakeTags"] = "manage_intake_tags";
    /** Manage pharmacy plan */
    Team_Permission["ManagePharmacyPlan"] = "manage_pharmacy_plan";
    /** Manage roadmaps */
    Team_Permission["ManageRoadmaps"] = "manage_roadmaps";
    /** Manage tasks */
    Team_Permission["ManageTasks"] = "manage_tasks";
    /** Manage tickets */
    Team_Permission["ManageTickets"] = "manage_tickets";
    /** Manage users */
    Team_Permission["ManageUsers"] = "manage_users";
    /** View appointments */
    Team_Permission["ViewAppointments"] = "view_appointments";
    /** View articles */
    Team_Permission["ViewArticles"] = "view_articles";
    /** View care pods */
    Team_Permission["ViewCarePods"] = "view_care_pods";
    /** View chats */
    Team_Permission["ViewChats"] = "view_chats";
    /** View claims */
    Team_Permission["ViewClaims"] = "view_claims";
    /** View employees */
    Team_Permission["ViewEmployees"] = "view_employees";
    /** View insurance plans */
    Team_Permission["ViewInsurancePlans"] = "view_insurance_plans";
    /** View interactions */
    Team_Permission["ViewInteractions"] = "view_interactions";
    /** View invites */
    Team_Permission["ViewInvites"] = "view_invites";
    /** View organizations */
    Team_Permission["ViewOrganizations"] = "view_organizations";
    /** View pharmacy plan */
    Team_Permission["ViewPharmacyPlan"] = "view_pharmacy_plan";
    /** View roadmaps */
    Team_Permission["ViewRoadmaps"] = "view_roadmaps";
    /** View tasks */
    Team_Permission["ViewTasks"] = "view_tasks";
    /** View tickets */
    Team_Permission["ViewTickets"] = "view_tickets";
    /** View uploads */
    Team_Permission["ViewUploads"] = "view_uploads";
    /** View users */
    Team_Permission["ViewUsers"] = "view_users";
})(Team_Permission || (Team_Permission = {}));
export var Terms_Of_Service_Agreement_Kind;
(function (Terms_Of_Service_Agreement_Kind) {
    Terms_Of_Service_Agreement_Kind["Href"] = "href";
    Terms_Of_Service_Agreement_Kind["Inline"] = "inline";
    Terms_Of_Service_Agreement_Kind["Modal"] = "modal";
})(Terms_Of_Service_Agreement_Kind || (Terms_Of_Service_Agreement_Kind = {}));
export var Ticket_Audit_Log_Action_Type;
(function (Ticket_Audit_Log_Action_Type) {
    Ticket_Audit_Log_Action_Type["AdvocateAppointmentClose"] = "advocate_appointment_close";
    Ticket_Audit_Log_Action_Type["AdvocateAppointmentCreate"] = "advocate_appointment_create";
    Ticket_Audit_Log_Action_Type["AdvocateAppointmentUpdate"] = "advocate_appointment_update";
    Ticket_Audit_Log_Action_Type["AdvocateManual"] = "advocate_manual";
    Ticket_Audit_Log_Action_Type["AdvocateTicketMerge"] = "advocate_ticket_merge";
    Ticket_Audit_Log_Action_Type["AssignQueue"] = "assign_queue";
    Ticket_Audit_Log_Action_Type["AssignedByQueue"] = "assigned_by_queue";
    Ticket_Audit_Log_Action_Type["BulkAssignToNavigator"] = "bulk_assign_to_navigator";
    Ticket_Audit_Log_Action_Type["BulkAssignedToQueue"] = "bulk_assigned_to_queue";
    Ticket_Audit_Log_Action_Type["BulkChangeStatus"] = "bulk_change_status";
    Ticket_Audit_Log_Action_Type["BulkCreated"] = "bulk_created";
    Ticket_Audit_Log_Action_Type["Created"] = "created";
    Ticket_Audit_Log_Action_Type["Historical"] = "historical";
    Ticket_Audit_Log_Action_Type["MemberAppointmentClose"] = "member_appointment_close";
    Ticket_Audit_Log_Action_Type["MemberAppointmentUpdate"] = "member_appointment_update";
    Ticket_Audit_Log_Action_Type["MemberChatReply"] = "member_chat_reply";
    Ticket_Audit_Log_Action_Type["OeAiEndChat"] = "oe_ai_end_chat";
    Ticket_Audit_Log_Action_Type["OeAiHandOffToHuman"] = "oe_ai_hand_off_to_human";
    Ticket_Audit_Log_Action_Type["OeAiSessionAbandoned"] = "oe_ai_session_abandoned";
    Ticket_Audit_Log_Action_Type["QueueDeactivate"] = "queue_deactivate";
    Ticket_Audit_Log_Action_Type["ScheduledJob"] = "scheduled_job";
    Ticket_Audit_Log_Action_Type["TagDeactivate"] = "tag_deactivate";
    Ticket_Audit_Log_Action_Type["TaskCreated"] = "task_created";
    Ticket_Audit_Log_Action_Type["TaskDeleted"] = "task_deleted";
    Ticket_Audit_Log_Action_Type["TaskUpdated"] = "task_updated";
})(Ticket_Audit_Log_Action_Type || (Ticket_Audit_Log_Action_Type = {}));
export var Ticket_Audit_Log_Field;
(function (Ticket_Audit_Log_Field) {
    Ticket_Audit_Log_Field["Alarm"] = "alarm";
    Ticket_Audit_Log_Field["Archived"] = "archived";
    Ticket_Audit_Log_Field["AssignedToId"] = "assigned_to_id";
    Ticket_Audit_Log_Field["ClosedAt"] = "closed_at";
    Ticket_Audit_Log_Field["CreatedAt"] = "created_at";
    Ticket_Audit_Log_Field["CreatedById"] = "created_by_id";
    Ticket_Audit_Log_Field["Deliverables"] = "deliverables";
    Ticket_Audit_Log_Field["DueDate"] = "due_date";
    Ticket_Audit_Log_Field["EmployeeId"] = "employee_id";
    Ticket_Audit_Log_Field["EnterpriseId"] = "enterprise_id";
    Ticket_Audit_Log_Field["FollowUpData"] = "follow_up_data";
    Ticket_Audit_Log_Field["Id"] = "id";
    Ticket_Audit_Log_Field["MailboxerConversationId"] = "mailboxer_conversation_id";
    Ticket_Audit_Log_Field["NoteBody"] = "note_body";
    Ticket_Audit_Log_Field["Notes"] = "notes";
    Ticket_Audit_Log_Field["OrganizationId"] = "organization_id";
    Ticket_Audit_Log_Field["ParentTicketId"] = "parent_ticket_id";
    Ticket_Audit_Log_Field["Priority"] = "priority";
    Ticket_Audit_Log_Field["QueueName"] = "queue_name";
    Ticket_Audit_Log_Field["SourceId"] = "source_id";
    Ticket_Audit_Log_Field["SourceType"] = "source_type";
    Ticket_Audit_Log_Field["SurveyId"] = "survey_id";
    Ticket_Audit_Log_Field["SymptomId"] = "symptom_id";
    Ticket_Audit_Log_Field["SymptomName"] = "symptom_name";
    Ticket_Audit_Log_Field["TagNames"] = "tag_names";
    Ticket_Audit_Log_Field["Task"] = "task";
    Ticket_Audit_Log_Field["TaskNames"] = "task_names";
    Ticket_Audit_Log_Field["TicketFlagId"] = "ticket_flag_id";
    Ticket_Audit_Log_Field["TicketStateId"] = "ticket_state_id";
    Ticket_Audit_Log_Field["TicketTypeId"] = "ticket_type_id";
    Ticket_Audit_Log_Field["Title"] = "title";
    Ticket_Audit_Log_Field["UpdatedAt"] = "updated_at";
    Ticket_Audit_Log_Field["Urgency"] = "urgency";
})(Ticket_Audit_Log_Field || (Ticket_Audit_Log_Field = {}));
export var Ticket_Benefit_Category_Type;
(function (Ticket_Benefit_Category_Type) {
    Ticket_Benefit_Category_Type["Dental"] = "Dental";
    Ticket_Benefit_Category_Type["Medical"] = "Medical";
    Ticket_Benefit_Category_Type["Pharmacy"] = "Pharmacy";
    Ticket_Benefit_Category_Type["Vision"] = "Vision";
})(Ticket_Benefit_Category_Type || (Ticket_Benefit_Category_Type = {}));
export var Ticket_Order;
(function (Ticket_Order) {
    /** Ascending sort by 'alarm_date_time' field. */
    Ticket_Order["AlarmDateTime"] = "alarm_date_time";
    /** Ascending sort by 'assignee_name' field. */
    Ticket_Order["AssigneeName"] = "assignee_name";
    /** Ascending sort by 'closed_at' field. */
    Ticket_Order["ClosedAt"] = "closed_at";
    /** Ascending sort by 'created_at' field. */
    Ticket_Order["CreatedAt"] = "created_at";
    /** Ascending sort by 'due_date' field. */
    Ticket_Order["DueDate"] = "due_date";
    /** Ascending sort by 'flag_name' field. */
    Ticket_Order["FlagName"] = "flag_name";
    /** Ascending sort by 'id' field. */
    Ticket_Order["Id"] = "id";
    /** Ascending sort by 'last_interaction' field. */
    Ticket_Order["LastInteraction"] = "last_interaction";
    /** Ascending sort by 'next_task' field. */
    Ticket_Order["NextTask"] = "next_task";
    /** Ascending sort by 'organization_name' field. */
    Ticket_Order["OrganizationName"] = "organization_name";
    /** Ascending sort by 'priority' field. */
    Ticket_Order["Priority"] = "priority";
    /** Ascending sort by 'queue' field. */
    Ticket_Order["Queue"] = "queue";
    /** Descending sort by 'alarm_date_time' field. */
    Ticket_Order["ReverseAlarmDateTime"] = "reverse_alarm_date_time";
    /** Descending sort by 'assignee_name' field. */
    Ticket_Order["ReverseAssigneeName"] = "reverse_assignee_name";
    /** Descending sort by 'closed_at' field. */
    Ticket_Order["ReverseClosedAt"] = "reverse_closed_at";
    /** Descending sort by 'created_at' field. */
    Ticket_Order["ReverseCreatedAt"] = "reverse_created_at";
    /** Descending sort by 'due_date' field. */
    Ticket_Order["ReverseDueDate"] = "reverse_due_date";
    /** Descending sort by 'flag_name' field. */
    Ticket_Order["ReverseFlagName"] = "reverse_flag_name";
    /** Descending sort by 'id' field. */
    Ticket_Order["ReverseId"] = "reverse_id";
    /** Descending sort by 'last_interaction' field. */
    Ticket_Order["ReverseLastInteraction"] = "reverse_last_interaction";
    /** Descending sort by 'next_task' field. */
    Ticket_Order["ReverseNextTask"] = "reverse_next_task";
    /** Descending sort by 'organization_name' field. */
    Ticket_Order["ReverseOrganizationName"] = "reverse_organization_name";
    /** Descending sort by 'priority' field. */
    Ticket_Order["ReversePriority"] = "reverse_priority";
    /** Descending sort by 'queue' field. */
    Ticket_Order["ReverseQueue"] = "reverse_queue";
    /** Descending sort by 'status' field. */
    Ticket_Order["ReverseStatus"] = "reverse_status";
    /** Descending sort by 'subject' field. */
    Ticket_Order["ReverseSubject"] = "reverse_subject";
    /** Descending sort by 'third_party_admin_name' field. */
    Ticket_Order["ReverseThirdPartyAdminName"] = "reverse_third_party_admin_name";
    /** Descending sort by 'time_zone' field. */
    Ticket_Order["ReverseTimeZone"] = "reverse_time_zone";
    /** Descending sort by 'title' field. */
    Ticket_Order["ReverseTitle"] = "reverse_title";
    /** Descending sort by 'updated_at' field. */
    Ticket_Order["ReverseUpdatedAt"] = "reverse_updated_at";
    /** Ascending sort by 'status' field. */
    Ticket_Order["Status"] = "status";
    /** Ascending sort by 'subject' field. */
    Ticket_Order["Subject"] = "subject";
    /** Ascending sort by 'third_party_admin_name' field. */
    Ticket_Order["ThirdPartyAdminName"] = "third_party_admin_name";
    /** Ascending sort by 'time_zone' field. */
    Ticket_Order["TimeZone"] = "time_zone";
    /** Ascending sort by 'title' field. */
    Ticket_Order["Title"] = "title";
    /** Ascending sort by 'updated_at' field. */
    Ticket_Order["UpdatedAt"] = "updated_at";
})(Ticket_Order || (Ticket_Order = {}));
export var Ticket_Order_Scope;
(function (Ticket_Order_Scope) {
    /** 'with_chat_activities_first' order scope. */
    Ticket_Order_Scope["WithChatActivitiesFirst"] = "with_chat_activities_first";
})(Ticket_Order_Scope || (Ticket_Order_Scope = {}));
export var Ticket_State_Order;
(function (Ticket_State_Order) {
    /** Ascending sort by 'id' field. */
    Ticket_State_Order["Id"] = "id";
    /** Ascending sort by 'name' field. */
    Ticket_State_Order["Name"] = "name";
    /** Ascending sort by 'priority' field. */
    Ticket_State_Order["Priority"] = "priority";
    /** Descending sort by 'id' field. */
    Ticket_State_Order["ReverseId"] = "reverse_id";
    /** Descending sort by 'name' field. */
    Ticket_State_Order["ReverseName"] = "reverse_name";
    /** Descending sort by 'priority' field. */
    Ticket_State_Order["ReversePriority"] = "reverse_priority";
})(Ticket_State_Order || (Ticket_State_Order = {}));
export var Ticket_State_Priority;
(function (Ticket_State_Priority) {
    /** Ready to close */
    Ticket_State_Priority["ClosedReadyToClose"] = "closed_ready_to_close";
    /** Closed */
    Ticket_State_Priority["ClosedResolved"] = "closed_resolved";
    /** Closed (Unresolved) */
    Ticket_State_Priority["ClosedUnresolved"] = "closed_unresolved";
    /** In Progress Navigator */
    Ticket_State_Priority["InProgressNavigator"] = "in_progress_navigator";
    /** In Progress Waiting */
    Ticket_State_Priority["InProgressWaiting"] = "in_progress_waiting";
    /** Assigned */
    Ticket_State_Priority["PendingAssigned"] = "pending_assigned";
    /** New */
    Ticket_State_Priority["PendingNew"] = "pending_new";
    /** Waiting For Assignment */
    Ticket_State_Priority["PendingWaiting"] = "pending_waiting";
})(Ticket_State_Priority || (Ticket_State_Priority = {}));
export var Ticket_Status_Code;
(function (Ticket_Status_Code) {
    Ticket_Status_Code["Closed"] = "closed";
    Ticket_Status_Code["InProgress"] = "in_progress";
    Ticket_Status_Code["Pending"] = "pending";
})(Ticket_Status_Code || (Ticket_Status_Code = {}));
export var Ticket_Type_Group_Order;
(function (Ticket_Type_Group_Order) {
    /** Ascending sort by 'id' field. */
    Ticket_Type_Group_Order["Id"] = "id";
    /** Ascending sort by 'name' field. */
    Ticket_Type_Group_Order["Name"] = "name";
    /** Descending sort by 'id' field. */
    Ticket_Type_Group_Order["ReverseId"] = "reverse_id";
    /** Descending sort by 'name' field. */
    Ticket_Type_Group_Order["ReverseName"] = "reverse_name";
})(Ticket_Type_Group_Order || (Ticket_Type_Group_Order = {}));
export var Ticket_Type_Order;
(function (Ticket_Type_Order) {
    /** Ascending sort by 'id' field. */
    Ticket_Type_Order["Id"] = "id";
    /** Ascending sort by 'name' field. */
    Ticket_Type_Order["Name"] = "name";
    /** Descending sort by 'id' field. */
    Ticket_Type_Order["ReverseId"] = "reverse_id";
    /** Descending sort by 'name' field. */
    Ticket_Type_Order["ReverseName"] = "reverse_name";
})(Ticket_Type_Order || (Ticket_Type_Order = {}));
export var Time_Slot_Kind;
(function (Time_Slot_Kind) {
    /** ASAP */
    Time_Slot_Kind["Asap"] = "asap";
    /** Cancelled Time */
    Time_Slot_Kind["Cancelled"] = "cancelled";
    /** Confirmed Time */
    Time_Slot_Kind["Confirmed"] = "confirmed";
    /** Pending Confirmation Time */
    Time_Slot_Kind["Pending"] = "pending";
    /** Specific Time */
    Time_Slot_Kind["Specific"] = "specific";
    /** Suggested Time */
    Time_Slot_Kind["Suggested"] = "suggested";
    /** Time Block */
    Time_Slot_Kind["TimeBlock"] = "time_block";
})(Time_Slot_Kind || (Time_Slot_Kind = {}));
export var Time_String_Format;
(function (Time_String_Format) {
    Time_String_Format["Hours_12AmPm"] = "hours_12_am_pm";
    Time_String_Format["Hours_24"] = "hours_24";
})(Time_String_Format || (Time_String_Format = {}));
export var Tpa_Order;
(function (Tpa_Order) {
    /** Ascending sort by 'name' field. */
    Tpa_Order["Name"] = "name";
    /** Descending sort by 'name' field. */
    Tpa_Order["ReverseName"] = "reverse_name";
})(Tpa_Order || (Tpa_Order = {}));
export var TicketPriority;
(function (TicketPriority) {
    TicketPriority["Critical"] = "Critical";
    TicketPriority["High"] = "High";
    TicketPriority["Normal"] = "Normal";
})(TicketPriority || (TicketPriority = {}));
/** DEPRICATED. Please use ProductOptions. */
export var TicketProducts;
(function (TicketProducts) {
    /** Joint (PBM + Nav) */
    TicketProducts["CoreAndPbm"] = "core_and_pbm";
    /** Nav Only */
    TicketProducts["OnlyCore"] = "only_core";
    /** PBM Only */
    TicketProducts["OnlyPbm"] = "only_pbm";
})(TicketProducts || (TicketProducts = {}));
export var TicketUrgency;
(function (TicketUrgency) {
    TicketUrgency["UrgencyHigh"] = "urgency_high";
    TicketUrgency["UrgencyLow"] = "urgency_low";
    TicketUrgency["UrgencyMedium"] = "urgency_medium";
    TicketUrgency["UrgencyUnspecified"] = "urgency_unspecified";
})(TicketUrgency || (TicketUrgency = {}));
export var TierSpendingInfoType;
(function (TierSpendingInfoType) {
    TierSpendingInfoType["Complete"] = "COMPLETE";
    TierSpendingInfoType["Incomplete"] = "INCOMPLETE";
})(TierSpendingInfoType || (TierSpendingInfoType = {}));
export var TierType;
(function (TierType) {
    TierType["Tier_1"] = "TIER_1";
    TierType["Tier_2"] = "TIER_2";
    TierType["Tier_3"] = "TIER_3";
    TierType["Tier_4"] = "TIER_4";
    TierType["Tier_5"] = "TIER_5";
    TierType["Tier_6"] = "TIER_6";
})(TierType || (TierType = {}));
export var TrialClaimRejectReason;
(function (TrialClaimRejectReason) {
    TrialClaimRejectReason["DaysSupplyExceeds"] = "DAYS_SUPPLY_EXCEEDS";
    TrialClaimRejectReason["NotAvailableAtPharmacy"] = "NOT_AVAILABLE_AT_PHARMACY";
    TrialClaimRejectReason["NotCovered"] = "NOT_COVERED";
    TrialClaimRejectReason["Other"] = "OTHER";
    TrialClaimRejectReason["OutOfNetwork"] = "OUT_OF_NETWORK";
    TrialClaimRejectReason["PriorAuthRequired"] = "PRIOR_AUTH_REQUIRED";
    TrialClaimRejectReason["QuantityExceeds"] = "QUANTITY_EXCEEDS";
    TrialClaimRejectReason["Timeout"] = "TIMEOUT";
})(TrialClaimRejectReason || (TrialClaimRejectReason = {}));
/** Possible upload scan statuses. */
export var Upload_File_Scan_Status_Kind;
(function (Upload_File_Scan_Status_Kind) {
    Upload_File_Scan_Status_Kind["Clean"] = "clean";
    Upload_File_Scan_Status_Kind["Infected"] = "infected";
    Upload_File_Scan_Status_Kind["InvalidLink"] = "invalid_link";
    Upload_File_Scan_Status_Kind["NotChecked"] = "not_checked";
    Upload_File_Scan_Status_Kind["SanitizationFailed"] = "sanitization_failed";
    Upload_File_Scan_Status_Kind["Sanitized"] = "sanitized";
    Upload_File_Scan_Status_Kind["Started"] = "started";
})(Upload_File_Scan_Status_Kind || (Upload_File_Scan_Status_Kind = {}));
/** User tag's source types */
export var User_Tag_Source_Type;
(function (User_Tag_Source_Type) {
    /** Employee source type */
    User_Tag_Source_Type["Employee"] = "Employee";
    /** Ticket source type */
    User_Tag_Source_Type["Ticket"] = "Ticket";
})(User_Tag_Source_Type || (User_Tag_Source_Type = {}));
/** User ticket statistic time period */
export var User_Ticket_Statistic_Time_Period;
(function (User_Ticket_Statistic_Time_Period) {
    User_Ticket_Statistic_Time_Period["AllTime"] = "ALL_TIME";
    User_Ticket_Statistic_Time_Period["Month"] = "MONTH";
    User_Ticket_Statistic_Time_Period["Week"] = "WEEK";
})(User_Ticket_Statistic_Time_Period || (User_Ticket_Statistic_Time_Period = {}));
export var Us_State_Name;
(function (Us_State_Name) {
    /** Alaska */
    Us_State_Name["Ak"] = "AK";
    /** Alabama */
    Us_State_Name["Al"] = "AL";
    /** Arkansas */
    Us_State_Name["Ar"] = "AR";
    /** American Samoa */
    Us_State_Name["As"] = "AS";
    /** Arizona */
    Us_State_Name["Az"] = "AZ";
    /** California */
    Us_State_Name["Ca"] = "CA";
    /** Colorado */
    Us_State_Name["Co"] = "CO";
    /** Connecticut */
    Us_State_Name["Ct"] = "CT";
    /** District Of Columbia */
    Us_State_Name["Dc"] = "DC";
    /** Delaware */
    Us_State_Name["De"] = "DE";
    /** Florida */
    Us_State_Name["Fl"] = "FL";
    /** Federated States Of Micronesia */
    Us_State_Name["Fm"] = "FM";
    /** Georgia */
    Us_State_Name["Ga"] = "GA";
    /** Guam */
    Us_State_Name["Gu"] = "GU";
    /** Hawaii */
    Us_State_Name["Hi"] = "HI";
    /** Iowa */
    Us_State_Name["Ia"] = "IA";
    /** Idaho */
    Us_State_Name["Id"] = "ID";
    /** Illinois */
    Us_State_Name["Il"] = "IL";
    /** Indiana */
    Us_State_Name["In"] = "IN";
    /** Kansas */
    Us_State_Name["Ks"] = "KS";
    /** Kentucky */
    Us_State_Name["Ky"] = "KY";
    /** Louisiana */
    Us_State_Name["La"] = "LA";
    /** Massachusetts */
    Us_State_Name["Ma"] = "MA";
    /** Maryland */
    Us_State_Name["Md"] = "MD";
    /** Maine */
    Us_State_Name["Me"] = "ME";
    /** Marshall Islands */
    Us_State_Name["Mh"] = "MH";
    /** Michigan */
    Us_State_Name["Mi"] = "MI";
    /** Minnesota */
    Us_State_Name["Mn"] = "MN";
    /** Missouri */
    Us_State_Name["Mo"] = "MO";
    /** Northern Mariana Islands */
    Us_State_Name["Mp"] = "MP";
    /** Mississippi */
    Us_State_Name["Ms"] = "MS";
    /** Montana */
    Us_State_Name["Mt"] = "MT";
    /** North Carolina */
    Us_State_Name["Nc"] = "NC";
    /** North Dakota */
    Us_State_Name["Nd"] = "ND";
    /** Nebraska */
    Us_State_Name["Ne"] = "NE";
    /** New Hampshire */
    Us_State_Name["Nh"] = "NH";
    /** New Jersey */
    Us_State_Name["Nj"] = "NJ";
    /** New Mexico */
    Us_State_Name["Nm"] = "NM";
    /** Nevada */
    Us_State_Name["Nv"] = "NV";
    /** New York */
    Us_State_Name["Ny"] = "NY";
    /** Ohio */
    Us_State_Name["Oh"] = "OH";
    /** Oklahoma */
    Us_State_Name["Ok"] = "OK";
    /** Oregon */
    Us_State_Name["Or"] = "OR";
    /** Pennsylvania */
    Us_State_Name["Pa"] = "PA";
    /** Puerto Rico */
    Us_State_Name["Pr"] = "PR";
    /** Palau */
    Us_State_Name["Pw"] = "PW";
    /** Rhode Island */
    Us_State_Name["Ri"] = "RI";
    /** South Carolina */
    Us_State_Name["Sc"] = "SC";
    /** South Dakota */
    Us_State_Name["Sd"] = "SD";
    /** Tennessee */
    Us_State_Name["Tn"] = "TN";
    /** Texas */
    Us_State_Name["Tx"] = "TX";
    /** Utah */
    Us_State_Name["Ut"] = "UT";
    /** Virginia */
    Us_State_Name["Va"] = "VA";
    /** Virgin Islands */
    Us_State_Name["Vi"] = "VI";
    /** Vermont */
    Us_State_Name["Vt"] = "VT";
    /** Washington */
    Us_State_Name["Wa"] = "WA";
    /** Wisconsin */
    Us_State_Name["Wi"] = "WI";
    /** West Virginia */
    Us_State_Name["Wv"] = "WV";
    /** Wyoming */
    Us_State_Name["Wy"] = "WY";
})(Us_State_Name || (Us_State_Name = {}));
export var UserLanguage;
(function (UserLanguage) {
    /** En */
    UserLanguage["En"] = "EN";
    /** Es */
    UserLanguage["Es"] = "ES";
})(UserLanguage || (UserLanguage = {}));
